import React, { useEffect, useState, useMemo, useRef } from "react";
import Container from "../../Container/Container";
import { useNavigate, useLocation, Link } from "react-router";
import { useForm, Controller } from "react-hook-form";
import { get } from "../../ApiServices/ApiServices";
import Select from "react-select";
import { Search } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";
import { Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setSize,
  clearSize,
  setShirtSize,
  setMappedDefaultColor,
} from "../../redux/profileSlice";
import { useDebounce } from "use-debounce";
import { ImageUrl } from "../../ApiServices/ApiServices";
import AlterationsCoatModal from "../Component/AlterationsCoatModal";
import SubRentalWarning from "../Component/SubRentalWarning";
import Progessbar from "../Component/Progessbar";

function AddMeasured({
  onSubmit,
  onNext,
  onBack,
  ticket,
  account,
  initialValues,
}) {
  const {
    register,
    handleSubmit,
    formState,
    control,
    watch,
    getValues,
    trigger,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: initialValues,
  });

  const getLocalStorageItem = (key) => {
    try {
      const item = localStorage.getItem(key);
      if (item == null || item == "undefined" || item == "null" || item == "") {
        return null;
      }
      return JSON.parse(item);
    } catch (error) {
      localStorage.removeItem(key); // Clean up corrupted data
      return null;
    }
  };
  const { errors } = formState;
  const [isUserSelectedInsleeve, setIsUserSelectedInsleeve] = useState(false);
  const [recommendedRange, setRecommendedRange] = useState(null);
  const [debouncedWeight, setDebouncedWeight] = useState(null);
  const categoryErrorRef = useRef(null);
  const [debouncedWeightValue] = useDebounce(watch("Weight"), 800);
  const [data, setdata] = useState([]);
  const [sizes, setsizes] = useState([]);
  const [sizesCategory, setsizesCategory] = useState([]);
  const [showSleeve, setShowSleeve] = useState(true);
  const [selectedHeight, setSelectedHeight] = useState(
    initialValues.Height || "",
  );
  // const [coat, setcoat] = useState('')
  // const [sizefilterid, setsizefilterid] = useState('')
  const [AllSize, setAllSize] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [isUserSelectedCategory, setIsUserSelectedCategory] = useState(false);
  const profile = useSelector((state) => state.profile.profile);

  console.log(profile?.insleeve_alteration, "profile----------------");

  const CoatstyleData = getLocalStorageItem("coatStyle");
  const [Coatstyle, setCoatstyle] = useState(CoatstyleData || null);
  const pantstyleData = getLocalStorageItem("pantStyle");
  const [Pantstyle, setPantstyle] = useState(pantstyleData || null);
  const shirtstyleData = getLocalStorageItem("shirtstyle");
  // const [tempCoatSize, setTempCoatSize] = useState(null);
  const VeststyleData = getLocalStorageItem("Veststyle");
  const ShoesData = getLocalStorageItem("Shoes");
  const [activeItem, setActiveItem] = useState(null);
  const [Shoesstyle, setShoesstyle] = useState(ShoesData || null);
  // const selectedCoatStyle = watch("Coat");
  const selectedVestStyle = watch("Vest");
  const selectedShoesStyle = watch("Shoes");
  const CoatSizetext = watch("CoatSize");
  const VestColor = watch("VestColor");
  const shirt_size = watch("shirt_size");
  const ShoesSize = watch("ShoesSize");
  const shirtStyleValue = watch("Shirt");
  const Waistsize = watch("Waist");

  const [LebelCoat, setLebelCoat] = useState(CoatstyleData || null);
  const [Lebelpant, setLebelpant] = useState(pantstyleData || null);
  const [LebelShirt, setLebelShirt] = useState(shirtstyleData || null);
  const [LebelVest, setLebelVest] = useState(VeststyleData || null);
  const [LebelShoes, setLebelShoes] = useState(selectedShoesStyle || null);

  const [LebelCoatsize, setLebelCoatsize] = useState(CoatSizetext || null);
  const [Lebelpantsize, setLebelpantsize] = useState(Waistsize || null);
  const [LebelShirtsize, setLebelShirtsize] = useState(shirt_size || null);
  const [LebelVestsize, setLebelVestsize] = useState(VestColor || null);
  const [LebelShoessize, setLebelShoessize] = useState(ShoesSize || null);

  const [LabelcategoryName, setLabelcategoryName] = useState(
    categoryName || null,
  );
  const [Veststyle, setVeststyle] = useState(VeststyleData || null);
  const [waistSizes, setWaistSizes] = useState([]);
  const [HipSizes, setHipSizes] = useState([]);
  const [NeckSizes, setNeckSizes] = useState([]);
  const [InsleeveSizes, setInsleeveSizes] = useState([]);
  // const [ShoesSizes, setshoesSizes] = useState([]);
  const [outseamSizes, setoutseamSizes] = useState([]);
  const [pantStyleSelected, setPantStyleSelected] = useState(false);
  // const [name, setname] = useState("")
  const [orderForState, setOrderForState] = useState(initialValues?.order_for);
  // const [uniqcoat, setuniqcoat] = useState([])
  const dispatch = useDispatch();
  const [MatchedItems, setMatchedItems] = useState([]);
  // const [coattype, setcoattype] = useState("")
  const [nonBoldMessage, setNonBoldMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [addaccount, setAddAccount] = useState("");
  const accountData = useSelector((state) => state.profile.alterAcc);
  useEffect(() => {
    setAddAccount(accountData);
  }, [accountData]);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [disableSleeve, setDisableSleeve] = useState(false); // Track if Sleeve should be disabled
  // const insleeveValidation = selectedCoatStyle ? { required: "Insleeve is required" } : {};
  // const [orderFor, setOrderFor] = useState(initialValues.order_for || "Men");
  const [shirtStyleSelected, setShirtStyleSelected] = useState(false);
  const [coatid, setCoatid] = useState(localStorage.getItem("coatid")) || null;
  const [sizeid, setSizeid] = useState(localStorage.getItem("size")) || null;
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [selectedCoatSize, setSelectedCoatSize] = useState(null);
  const [defaultsize, setdefaultsize] = useState(null);
  const [Stoprender, setStoprender] = useState(true);
  const [selectedNeckSize, setSelectedNeckSize] = useState(
    initialValues?.ShirtSize || null,
  );
  const [recommendationMessage, setRecommendationMessage] = useState("");
  // const [recommendedCategoryDisplay, setRecommendedCategoryDisplay] = useState('');
  // const [recommendedCategory, setRecommendedCategory] = useState(null);
  const weight = watch("Weight"); // Ensure weight updates
  const [shirtSize, setShirtSizes] = useState("");
  const [sizeRecommendationMsg, setSizeRecommendationMsg] = useState("");
  const [shirtSizeRecommendationMsg, setShirtSizeRecommendationMsg] =
    useState("");
  const [vestRecommendationMsg, setVestRecommendationMsg] = useState("");
  // const [category, setCategory] = useState("");
  const [allSizes, setAllSizes] = useState([]);
  const ID = location.state?.ID;
  const [originalCategory, setOriginalCategory] = useState(null);
  const [coatStyles, setCoatStyles] = useState([]);
  const [selectedStyle, setSelectedStyle] = useState(null);
  // const [coatStyleSizes, setCoatStyleSizes] = useState([]);
  // const [pantStyles, setPantStyles] = useState([]);
  const [pantStyleSizes, setPantStyleSizes] = useState([]);
  const [selectedPantStyle, setSelectedPantStyle] = useState(null);
  const [selectedShirtStyle, setSelectedShirtStyle] = useState(null);
  const [availableSizesForStyle, setAvailableSizesForStyle] = useState([]);
  // const [styleValidationMessage, setStyleValidationMessage] = useState('');
  const [categoryValidationMessage, setCategoryValidationMessage] =
    useState("");
  const [categorySizes, setCategorySizes] = useState({});
  // const [availableSizes, setAvailableSizes] = useState([]);
  const [coatSizeValidation, setCoatSizeValidation] = useState(null);
  const [selectedCoatStyleForPants, setSelectedCoatStyleForPants] =
    useState(null);
  const [shoeColors, setShoeColors] = useState([]); // to store shoe colors extracted from data
  const [matchedPantStyles, setMatchedPantStyles] = useState(null);
  const [pantValidationMessage, setPantValidationMessage] = useState(""); // NEW - single message
  const [categoryMappings, setCategoryMappings] = useState({});
  const [isVestManuallySelected, setIsVestManuallySelected] = useState(false);
  const coatStyleRaw = localStorage.getItem("coatStyle");
  const [recommendedVestSize, setRecommendedVestSize] = useState(null);

  let coatStyle = null;

  try {
    coatStyle = coatStyleRaw ? JSON.parse(coatStyleRaw) : null;
  } catch (error) { }

  console.log(coatStyle?.even_sizes_only, "coatStyle");

  const [ForEvenCoat, setForEvenCoat] = useState(
    coatStyle?.even_sizes_only || false,
  );

  const [RecomForEven, setRecomForEven] = useState(
    coatStyle?.even_sizes_only || false,
  );

  const lastCoatId = useRef(null);

  // useEffect(() => {
  //     if (!coatid) return;

  //     // 🚫 block duplicate calls
  //     if (lastCoatId.current === coatid) return;

  //     lastCoatId.current = coatid;

  //     FuncForNotVAlid();
  // }, [coatid]);

  useEffect(() => {
    setIsVestManuallySelected(false);
  }, [selectedHeight, coatid]);
  useEffect(() => {
    if (initialValues?.VestColor) {
      setValue("VestColor", initialValues.VestColor);
      setIsVestManuallySelected(true);
    }
  }, [initialValues?.VestColor]);

  useEffect(() => {
    setAddAccount(accountData);
  }, [accountData]);

  useEffect(() => {
    if (categoryName && !LabelcategoryName) {
      // Only set if categoryName exists and label isn't set yet
      setLabelcategoryName(categoryName);
    }
  }, [categoryName]);

  useEffect(() => {
    if (activeItem != 1) {
      setLebelCoat(CoatstyleData);
      setLebelCoatsize(CoatSizetext);
      setLabelcategoryName(categoryName);
    }
    if (activeItem != 2) {
      setLebelpant(pantstyleData);
      setLebelpantsize(Waistsize);
    }
    if (activeItem != 3) {
      setLebelShirt(shirtstyleData);
      setLebelShirtsize(shirt_size);
    }
    if (activeItem != 4) {
      setLebelVestsize(VestColor);
      setLebelVest(VeststyleData);
    }
    if (activeItem != 6) {
      setLebelShoes(Shoesstyle);
      setLebelShoessize(ShoesSize);
    }
  }, [activeItem]);

  // 🔄 Fetch matched pant style when coat style changes
  const fetchMatchedPantStyles = async (coatStyle) => {
    try {
      if (!coatStyle) {
        setMatchedPantStyles([]);
        return;
      }

      const api = `get-matched-pant-styles`;
      const response = await get(api);

      const allRows = response?.data || [];

      // ✅ Get ALL matching rows, not just one
      const matchedPantStyles = allRows
        .filter((item) => String(item.style) === String(coatStyle))
        .map((item) => item.match_pant_style);

      if (matchedPantStyles.length > 0) {
        setMatchedPantStyles(matchedPantStyles);
      } else {
        setMatchedPantStyles([]);
      }
    } catch (err) {
      setMatchedPantStyles([]);

      if (
        err?.message === "Invalid or expired token" ||
        err?.message === "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  // Or if you have the coat style from props/initial values:
  useEffect(() => {
    if (initialValues?.Coat) {
      fetchMatchedPantStyles(initialValues.Coat);
    }
  }, [initialValues?.Coat]);

  useEffect(() => {
    if (selectedCoatStyleForPants) {
      fetchMatchedPantStyles(selectedCoatStyleForPants);
    } else {
      setMatchedPantStyles([]);
    }
  }, [selectedCoatStyleForPants]);

  // 🧠 Generate options list: bold + top for matched
  const getPantOptions = () => {
    const sorted = [...pants].sort((a, b) =>
      a.style.localeCompare(b.style, undefined, { numeric: true }),
    );

    const options = sorted.map((item) => ({
      value: item.style,
      label: `${item.style} ${item.description}`,
      isMatched: matchedPantStyles.includes(item.style),
    }));

    const matched = options.filter((opt) => opt.isMatched);
    const others = options.filter((opt) => !opt.isMatched);

    return [...matched, ...others];
  };

  const reorderNeckSizes = (options, boldBaseValues) => {
    const boldOptions = [];
    const afterBold = [];
    const beforeBold = [];

    const sortedBold = [...boldBaseValues].sort((a, b) => a - b);
    const minBold = sortedBold[0] ?? -Infinity;
    const maxBold = sortedBold[sortedBold.length - 1] ?? -Infinity;

    for (const option of options) {
      if (boldBaseValues.includes(option.baseValue)) {
        boldOptions.push({ ...option, bold: true });
      } else if (option.baseValue > maxBold) {
        afterBold.push(option);
      } else if (option.baseValue < minBold) {
        beforeBold.push(option);
      }
    }
    afterBold.sort((a, b) => a.baseValue - b.baseValue);
    beforeBold.sort((a, b) => a.baseValue - b.baseValue);
    // Combine in order: bold → after bold → before bold
    return [...boldOptions, ...afterBold, ...beforeBold];
  };

  // Enhanced sorting function that implements: Bold -> Larger -> Smaller
  const sortVestSizesWithLogic = (availableCoatSizes, uniqueSizes) => {
    // Define size order for comparison
    const sizeOrder = {
      BS: 1,
      BM: 2,
      BL: 3,
      "4FB": 4,
      S: 10,
      M: 11,
      L: 12,
      XL: 13,
      XXL: 14,
      "3XL": 15,
      SL: 20,
      ML: 21,
      LL: 22,
      XLL: 23,
      "2LL": 24,
      "3LL": 25,
      "4LL": 26,
    };

    const getSizePriority = (size) => sizeOrder[size] || 999;

    const validUniqueSizes = Array.isArray(uniqueSizes)
      ? uniqueSizes.filter((size) => size != null && size !== "")
      : [];

    // Get the maximum priority among bold values to determine what's "larger"
    const boldPriorities = validUniqueSizes.map((size) =>
      getSizePriority(size),
    );
    const maxBoldPriority =
      boldPriorities.length > 0 ? Math.max(...boldPriorities) : 0;
    // Separate items into categories
    const boldItems = [];
    const largerItems = [];
    const smallerItems = [];

    availableCoatSizes.forEach((item) => {
      // Convert both values to strings for comparison to handle type mismatches
      const itemValue = String(item.value);
      const isBold = validUniqueSizes.some(
        (uniqueSize) => String(uniqueSize) === itemValue,
      );
      const priority = getSizePriority(item.value);

      if (isBold) {
        boldItems.push(item);
      } else if (priority > maxBoldPriority) {
        largerItems.push(item);
      } else {
        smallerItems.push(item);
      }
    });

    // Sort each category
    boldItems.sort(
      (a, b) => getSizePriority(a.value) - getSizePriority(b.value),
    ); // Bold: ascending
    largerItems.sort(
      (a, b) => getSizePriority(a.value) - getSizePriority(b.value),
    ); // Larger: ascending
    smallerItems.sort(
      (a, b) => getSizePriority(a.value) - getSizePriority(b.value),
    ); // Smaller: descending

    // Combine: Bold + Larger + Smaller
    const result = [...boldItems, ...largerItems, ...smallerItems];

    return result;
  };

  const getNeckOptions = (
    allSizes,
    selectedShirt,
    sizesCategory,
    NeckSizes,
  ) => {
    if (!allSizes?.length) return [];
    let options = generateNeckSizes(allSizes);

    // 🔎 Filter depending on selected shirt type
    if (selectedShirt) {
      const { type } = selectedShirt;
      options = options.filter((option) => {
        const base = option.baseValue;
        if (type === "Added Length") return base >= 18 && base <= 26;
        if (type === "Fitted") return base >= 14 && base <= 19;
        return true;
      });
    }

    // Determine bold base values
    let boldBaseValues = [];
    if (sizesCategory?.length) {
      const neckMin = parseFloat(sizesCategory[0]?.minNeck);
      const neckMax = parseFloat(sizesCategory[0]?.maxNeck);
      boldBaseValues = options
        .filter((opt) => opt.baseValue >= neckMin && opt.baseValue <= neckMax)
        .map((opt) => opt.baseValue);
    } else {
      boldBaseValues = NeckSizes || [];
    }
    const boldOptions = [];
    const otherOptions = [];
    for (const option of options) {
      if (boldBaseValues.includes(option.baseValue))
        boldOptions.push({ ...option, bold: true });
      else otherOptions.push(option);
    }
    boldOptions.sort((a, b) => a.baseValue - b.baseValue);
    otherOptions.sort((a, b) => a.baseValue - b.baseValue);

    return [...boldOptions, ...otherOptions];
    // return reorderNeckSizes(options, boldBaseValues);
  };

  useEffect(() => {
    const fetchShirtStyles = async () => {
      try {
        let selectedShirt = null;
        if (selectedShirtStyle) {
          const response = await get(`/all-inventories?size=1000`);
          const data = response?.data?.rows || [];
          selectedShirt = data.find((item) => item.id === selectedShirtStyle);
        } else {
          const stored = localStorage.getItem("shirtstyle");
          if (stored) selectedShirt = JSON.parse(stored);
        }

        const options = getNeckOptions(
          AllSize?.neckSizes,
          selectedShirt,
          sizesCategory,
          NeckSizes,
        );
        setNeckSizeOptions(options);
        setShirtStyleSelected(!!selectedShirt);
      } catch (error) {
        console.error(error);
        const options = getNeckOptions(
          AllSize?.neckSizes,
          null,
          sizesCategory,
          NeckSizes,
        );
        setNeckSizeOptions(options);
        setShirtStyleSelected(false);
      }
    };

    fetchShirtStyles();
  }, [selectedShirtStyle, AllSize]);

  useEffect(() => {
    if (shirtSize) {
      setValue("shirt_size", shirtSize);
    } else {
      setValue("shirt_size", null);
    }
  }, [shirtSize]);

  useEffect(() => {
    const savedStyle = localStorage.getItem("coatStyle");

    if (savedStyle && savedStyle != "undefined") {
      try {
        const parsedStyle = JSON.parse(savedStyle);
        if (parsedStyle?.id) {
          setSelectedStyle(parsedStyle.id);
        }
      } catch (error) {
        console.error("Error parsing coatStyle from localStorage:", error);
      }
    }
  }, []);

  const toggleItem = (id) => {
    setActiveItem((prevActive) => (prevActive === id ? null : id));
  };

  const AccordionItem = ({ id, title, children }) => {
    const [isHovered, setIsHovered] = useState(false);
    const isActive = activeItem === id;
    return (
      <div className="accordion-item">
        <button
          className={`accordion-button ${isActive ? "active" : ""}`}
          onClick={() => toggleItem(id)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <span>{title}</span>
          <span className="accordion-icon">
            {isActive ? (
              <em class="icon ni ni-upword-ios"></em>
            ) : (
              <em class="icon ni ni-downward-ios"></em>
            )}
          </span>
        </button>
        {/* {isActive && <div className="accordion-content">{children}</div>} */}
        <div
          className="accordion-content"
          style={{ display: isActive ? "block" : "none" }} // ✅ crucial change
        >
          {children}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setCoatSizeValidation({});

    const storedCoatStyle = localStorage.getItem("coatStyle") || null;
    let parsedStyle = null;

    if (storedCoatStyle && storedCoatStyle !== "null") {
      try {
        const parsed = JSON.parse(storedCoatStyle);
        parsedStyle = parsed?.style;
      } catch (error) {
        console.error("Error parsing coatStyle from localStorage", error);
      }
    }

    const isValidStyle = (value) => {
      return (
        value !== null &&
        value !== undefined &&
        value !== "null" &&
        value !== "" &&
        String(value).trim() !== ""
      );
    };

    const hasValidSelectedStyle = isValidStyle(selectedStyle);
    const hasValidParsedStyle = isValidStyle(parsedStyle);

    if (hasValidSelectedStyle || hasValidParsedStyle) {
      setCoatSizeValidation({ required: "Coat Size is required" });
    }
  }, [selectedStyle]);

  useEffect(() => {
    if (selectedCoatSize && !categoryValidationMessage) {
      setValue("categoryValidated", "valid");
    } else {
      setValue("categoryValidated", "");
    }
  }, [selectedCoatSize, categoryValidationMessage, setValue]);

  const fetchCoatStyles = async () => {
    try {
      const response = await get(
        `coat-pant-styles?inventory_category_id=1&inventory_id=${selectedStyle}`,
      );

      const data = response?.data || [];
      const sizesByCategory = {};
      data.forEach((item) => {
        sizesByCategory[item.category] = item.sizes || [];
      });

      setCategorySizes(sizesByCategory);

      const formattedStyles = data.map((item) => ({
        label: item.mapping?.style || item.mapping?.id?.toString(),
        value: item.mapping?.style,
        inventory_id: item.mapping?.inventory_id,
        category: item.category,
        sizes: item.sizes || [],
      }));

      // Merge all sizes for this inventory_id
      const allMatching = formattedStyles.filter(
        (style) => style.inventory_id == selectedStyle,
      );
      const mergedSizes = Array.from(
        new Set(allMatching.flatMap((s) => s.sizes)),
      ).sort((a, b) => a - b);

      // setCoatStyleSizes(mergedSizes); // Or however you're feeding it to dropdown
      setAvailableSizesForStyle(mergedSizes);

      setCoatStyles(formattedStyles);
      validateSizeWithCategory(
        selectedCoatSize,
        categoryName,
        sizesByCategory,
        selectedStyle,
      );

      if (selectedCoatSize && !mergedSizes.includes(Number(selectedCoatSize))) {
        const styleName = selectedStyle;
        const categoryInitial = categoryName
          ? categoryName.charAt(0).toUpperCase() === "E"
            ? "X"
            : categoryName.charAt(0)
          : "";

        // setStyleValidationMessage(`Selected Coat Style ${styleName} doesn't have coat size ${selectedCoatSize}${categoryInitial}.`);
      } else {
        // setStyleValidationMessage('');
      }
    } catch (err) {
      console.error("Error fetching coat styles:", err);
      setCoatStyles([]);
      if (
        err?.message === "Invalid or expired token" ||
        err?.message === "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  // Function to validate if the size is available in the selected category
  const validateSizeWithCategory = (
    size,
    category,
    sizesByCategory = categorySizes,
    style = selectedStyle,
  ) => {
    if (!size || !category || !style) {
      setCategoryValidationMessage("");
      // setAvailableSizes([]);
      return;
    }

    const sizeNum = Number(size);
    const categoryInitial =
      category.charAt(0).toUpperCase() === "E" ? "X" : category.charAt(0);
    // Find sizes available for this category
    const availableSizesForCategory = sizesByCategory[category] || [];
    // setAvailableSizes(availableSizesForCategory);

    // Find the style name/label
    const selectedStyleObj = coatStyles.find((s) => s.inventory_id == style);
    // const styleLabel = selectedStyleObj?.label || style;
    const styleLabel = selectedStyleObj?.label || Coatstyle?.style || style;
    if (!availableSizesForCategory.includes(sizeNum)) {
      // Sizes exist, but not this one
      setCategoryValidationMessage(
        `Coat size ${size}${categoryInitial} is not available for Coat Style ${styleLabel}.`,
      );
    } else {
      // Size is valid
      setCategoryValidationMessage("");
    }
  };

  // Add this effect to run validation when selections change
  useEffect(() => {
    if (selectedCoatSize && categoryName) {
      clearErrors("CoatSize");

      validateSizeWithCategory(
        selectedCoatSize,
        categoryName,
        categorySizes,
        selectedStyle,
      );
    }
  }, [selectedCoatSize, categoryName, categorySizes, selectedStyle]);
  useEffect(() => {
    if (
      selectedStyle &&
      selectedCoatSize &&
      availableSizesForStyle.length > 0
    ) {
      // Convert to number for comparison since sizes are likely stored as numbers
      const coatSizeNum = Number(selectedCoatSize);

      if (!availableSizesForStyle.includes(coatSizeNum)) {
        const categoryInitial = categoryName
          ? categoryName.charAt(0).toUpperCase() === "E"
            ? "X"
            : categoryName.charAt(0)
          : "";

        // Find the actual style label from coatStyles using selected inventory ID
        const selectedStyleObj = coatStyles.find(
          (style) => style.inventory_id == selectedStyle,
        );
        // const styleLabel = selectedStyleObj?.label || selectedStyle;
        const styleLabel =
          selectedStyleObj?.label || Coatstyle?.style || selectedStyle;

        // setStyleValidationMessage(`Selected Coat Style ${styleLabel} doesn't have coat size ${selectedCoatSize}${categoryInitial}.`);
      } else {
        // setStyleValidationMessage('');
      }
    } else {
      // setStyleValidationMessage('');
    }
  }, [
    selectedCoatSize,
    availableSizesForStyle,
    categoryName,
    selectedStyle,
    coatStyles,
  ]);

  useEffect(() => {
    if (selectedStyle) {
      fetchCoatStyles();
    } else {
      setCoatStyles([]);
    }
  }, [selectedStyle]);

  const fetchPantStyles = async () => {
    try {
      const response = await get(
        `coat-pant-styles?inventory_category_id=2&inventory_id=${selectedPantStyle}`,
      );

      const data = response?.data || [];

      const formattedStyles = data.map((item) => {
        const styleId = item.mapping?.id;
        const style = item.mapping?.style;
        const rawSizes = item.sizes || [];
        return {
          label: style || styleId?.toString(),
          value: styleId,
          inventory_id: item.mapping?.inventory_id,
          sizes: rawSizes,
          category: item.category, // "Boys" or "Short"
          updatedAt: item.mapping?.updatedAt
            ? new Date(item.mapping.updatedAt).getTime()
            : 0,
        };
      });

      // Merge all sizes for this inventory_id
      const allMatching = formattedStyles.filter(
        (style) => style.inventory_id == selectedPantStyle,
      );
      const mergedSizes = Array.from(
        new Set(allMatching.flatMap((s) => s.sizes)),
      );

      if (mergedSizes.length) {
        setPantStyleSizes({ waistSizes: mergedSizes });
      } else {
        setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
      }

      const mappingsByCategory = {};
      data.forEach((item) => {
        const category = item.category || "Unknown";
        // Always overwrite with the latest (last) item for this category
        mappingsByCategory[category] = {
          style: item.mapping?.style,
          sizes: item.sizes || [],
          category: category,
        };
      });
      setCategoryMappings(mappingsByCategory);
    } catch (err) {
      console.error("Error fetching pant styles:", err);
      setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
      if (
        err?.message === "Invalid or expired token" ||
        err?.message === "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  // Trigger API when pant style changes
  const validatePantSize = (selectedSize) => {
    if (
      !selectedSize ||
      !selectedPantStyle ||
      Object.keys(categoryMappings).length === 0
    ) {
      setPantValidationMessage("");
      return true;
    }

    const sizeNum = Number(selectedSize);

    // 🔥 Find mapping for SELECTED STYLE ONLY
    const selectedStyleMapping = Object.values(categoryMappings).find(
      (mapping) => mapping.style == selectedPantStyle,
    );

    // Safety fallback
    if (!selectedStyleMapping) {
      setPantValidationMessage("");
      return true;
    }

    const isAvailable = selectedStyleMapping.sizes.includes(sizeNum);

    if (!isAvailable) {
      setPantValidationMessage(
        `Pant size ${selectedSize} is not available for Pant Style ${selectedPantStyle}.`,
      );
      return false;
    }

    setPantValidationMessage("");
    return true;
  };

  useEffect(() => {
    if (selectedPantStyle) {
      localStorage.setItem("selectedPantStyle", selectedPantStyle);

      fetchPantStyles();
    } else {
      // Clear data correctly (set as object with empty waistSizes)
      setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
      setPantValidationMessage("");
    }
  }, [selectedPantStyle]);

  useEffect(() => {
    // On component mount, check if we have a saved selection
    const savedPantStyle = localStorage.getItem("selectedPantStyle") || null;
    const savedWaist = localStorage.getItem("savedWaist") || null;
    const savedHip = localStorage.getItem("savedHip") || null;
    const savedOutseam = localStorage.getItem("savedOutseam") || null;
    if (savedPantStyle && !selectedPantStyle) {
      // Restore the selected pant style from localStorage
      setSelectedPantStyle(savedPantStyle);
    }
    if (savedWaist) setValue("Waist", savedWaist);
    if (savedHip) setValue("hip", savedHip);
    if (savedOutseam) setValue("outseam", savedOutseam);
  }, []);

  useEffect(() => {
    const fetchBoysCoatSizeCategories = async () => {
      // Convert height to inches
      const computedHeightInInches =
        typeof selectedHeight === "string" && selectedHeight.includes("'")
          ? convertHeightToInches(selectedHeight)
          : selectedHeight;

      // First, fetch all available categories to display
      try {
        let allCategoriesApi = `all-size-chart-categories`;
        let allCategoriesResponse = await get(allCategoriesApi);

        if (allCategoriesResponse?.status === true) {
          setAllSizes(
            allCategoriesResponse.data.filter(
              (category) =>
                category.size_charts && category.size_charts.length > 0,
            ),
          );
        }

        // If height < 60 AND coatSize exists (for Boys only), fetch matched categories
        if (
          computedHeightInInches < 60 &&
          initialValues.coatSize &&
          initialValues.gender === "Boys"
        ) {
          let coatSizeApi = `all-size-chart-categories?coatSize=${initialValues.coatSize}`;
          let coatSizeResponse = await get(coatSizeApi);

          if (coatSizeResponse?.status === true) {
            // const validCategories = coatSizeResponse.data.filter(
            //     category => category.size_charts && category.size_charts.length > 0
            // );
          }
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    fetchBoysCoatSizeCategories();
  }, [selectedHeight, initialValues.coatSize, initialValues.gender]);
  useEffect(() => {
    setPantStyleSelected(!!watch("Pant")); // Using watch from react-hook-form
    if (!watch("Pant")) {
      // Reset all pant-related fields when Pant Style is deselected
      setValue("Waist", "");
      setValue("hip", "");
      setValue("outseam", "");
      setValue("belt", "");
      clearErrors(["Waist", "hip", "outseam", "belt"]);
      setSizeRecommendationMsg("");
      localStorage.removeItem("pantSizeRecommendationMsg");
    }
  }, [watch("Pant"), setValue, clearErrors]);

  useEffect(() => {
    const fetchSizeRecommendation = async () => {
      // const requestId = Date.now();
      // Reset recommendation message and category at the beginning of each run
      setRecommendationMessage("");
      // Validate inputs - exit early if required fields are missing
      if (
        !selectedHeight ||
        selectedHeight === "Unknown" ||
        !selectedCoatSize
      ) {
        return;
      }

      // Get unique coat sizes from the sizes array
      const uniqueCoatSizes = sizes
        .filter((category) => category.size_charts.length > 0)
        .flatMap((category) =>
          category.size_charts.map((size) => size.coatSize),
        );

      // Exit if the coat size is not highlighted (not in uniqueCoatSizes)
      if (!uniqueCoatSizes.includes(selectedCoatSize)) {
        return; // Don't display recommendation for non-highlighted coat sizes
      }

      try {
        // Convert height to inches if it's in feet'inches" format
        const heightInInches =
          typeof selectedHeight === "string" && selectedHeight.includes("'")
            ? convertHeightToInches(selectedHeight)
            : selectedHeight;
        const weight = watch("Weight"); // Ensure weight updates
        let matchingCategories = [];
        let usingWeightInRecommendation = false;

        // First attempt with weight parameter if available and valid
        if (weight && !isNaN(Number(weight))) {
          matchingCategories = await fetchCategoriesWithParams(
            heightInInches,
            selectedCoatSize,
            weight,
          );
          if (matchingCategories.length > 0) {
            usingWeightInRecommendation = true;
          }
        }

        // If no matching categories found with weight or weight not provided, try without weight
        if (matchingCategories.length === 0) {
          matchingCategories = await fetchCategoriesWithParams(
            heightInInches,
            selectedCoatSize,
            null,
          );
          usingWeightInRecommendation = false;
        }

        // Process matching categories if any found
        if (matchingCategories.length > 0) {
          // Get the first matching category
          const recommendedCategory = matchingCategories[0];

          // Replace category name if it starts with "E"
          if (
            recommendedCategory.name &&
            recommendedCategory.name.charAt(0).toUpperCase() === "E"
          ) {
            recommendedCategory.name = "X";
          }

          // Safety check for recommendedCategory.name
          if (!recommendedCategory.name) {
            return;
          }

          // Check if the recommended category matches the already selected category
          const isRecommendedCategoryAlreadySelected =
            recommendedCategory.name === categoryName;
          const isWeightValid =
            weight && !isNaN(Number(weight)) && weight !== "";
          const shouldShowNonBoldMessage =
            isWeightValid && selectedHeight && selectedHeight !== "Unknown";

          if (!isRecommendedCategoryAlreadySelected) {
            // Clear any existing messages before setting new ones
            setRecommendationMessage("");
            // setRecommendedCategory(null);

            // Small delay to ensure state is cleared
            setTimeout(() => {
              if (!nonBoldMessage || nonBoldMessage.trim() === "") {
                // setRecommendedCategory(recommendedCategory);

                // Create recommendation message
                const categoryInitial = recommendedCategory.name
                  ? recommendedCategory.name.charAt(0).toUpperCase()
                  : "";

                // setCategory(categoryInitial);

                // Create the message based on whether weight was used
                const recommendationMsg =
                  `<span style="font-size: 24px;">⚠️</span> Recommended Coat Size: ${selectedCoatSize}${categoryInitial} for Height: ${convertInchesToFeetInches(heightInInches)}` +
                  (usingWeightInRecommendation && weight
                    ? `, Weight: ${weight} `
                    : " ");

                setRecommendationMessage(recommendationMsg);
              }
            }, 50);
          }
        } else {
          // Clear any previous recommendations if no matches found
          // if (!recommendationMessage) {
          // setRecommendedCategory(null);
          // setRecommendedCategoryDisplay('');
          setRecommendationMessage("");
          // }
        }
      } catch (err) {
        // if (!recommendationMessage) {
        setRecommendationMessage("Error fetching size recommendations");
        // setRecommendedCategory(null);
        // setRecommendedCategoryDisplay('');
        // }
      }
    };

    // Helper function to fetch categories with specified parameters
    const fetchCategoriesWithParams = async (
      heightInInches,
      coatSize,
      weight,
    ) => {
      try {
        // Construct the API URL
        const apiParams = new URLSearchParams();
        apiParams.append("height", heightInInches);
        apiParams.append("coatSize", coatSize);

        // Only add weight if it's provided and valid
        if (weight && !isNaN(Number(weight))) {
          apiParams.append("weight", weight);
        }

        const api = `all-size-chart-categories?${apiParams.toString()}`;
        const response = await get(api);

        if (response?.status === true && response.data.length > 0) {
          // Filter categories that match the criteria
          return response.data.filter(
            (category) =>
              category.size_charts &&
              category.size_charts.some(
                (chart) =>
                  chart.coatSize === coatSize &&
                  (!chart.minHeight || heightInInches >= chart.minHeight) &&
                  (!chart.maxHeight || heightInInches <= chart.maxHeight) &&
                  // Only check weight if it's provided and valid
                  (weight && !isNaN(Number(weight))
                    ? (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                    : true),
              ),
          );
        }
        return [];
      } catch (err) {
        console.error("Error in fetchCategoriesWithParams:", err);
        return [];
      }
    };

    const convertInchesToFeetInches = (inches) => {
      const feet = Math.floor(inches / 12);
      const remainingInches = inches % 12;
      return `${feet}'${remainingInches}"`;
    };

    // Use a debounced version of the fetch function to prevent rapid multiple calls
    const debouncedFetch = debounce(fetchSizeRecommendation, 300);
    debouncedFetch();

    // Cleanup function to cancel any pending debounced calls when dependencies change
    return () => {
      debouncedFetch.cancel();
    };
  }, [
    selectedHeight,
    selectedCoatSize,
    watch,
    categoryName,
    MatchedItems,
    initialValues,
    nonBoldMessage,
  ]);

  // Debounce function to prevent multiple rapid executions
  function debounce(func, wait) {
    let timeout;
    const debounced = function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };

    debounced.cancel = function () {
      clearTimeout(timeout);
    };

    return debounced;
  }
  useEffect(() => {
    // Update the state based on whether Shirt Style is selected
    setShirtStyleSelected(!!shirtStyleValue);
  }, [shirtStyleValue]);

  const handleBack = () => {
    const currentValues = getValues();
    onBack(currentValues);
  };
  const ViewState = async () => {
    try {
      const api = `all-inventories?size=${1000}`;
      const response = await get(api);
      if (response?.status == true) {
        setdata(response.data?.rows);
        // Extract unique shoe colors from the response and filter out null/empty
        const colors = response.data?.rows
          .map((item) => item.shoe_color) // extract shoe_color from each item
          .filter((color) => color && color.trim() !== ""); // remove null/empty

        // Remove duplicates by converting to Set and back to array
        const uniqueColors = [...new Set(colors)];

        setShoeColors(uniqueColors);
      }
    } catch (err) {
      if (
        err?.message == "Invalid or expired token" ||
        err?.message == "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } finally {
    }
  };
  useEffect(() => {
    ViewState();
  }, []);

  const Allsize = async () => {
    try {
      const api = `all-size-charts`;
      const response = await get(api);
      localStorage.setItem("allSize", JSON.stringify(response?.data));
      setAllSize(response?.data);
    } catch (err) {
      if (
        err?.message == "Invalid or expired token" ||
        err?.message == "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };
  useEffect(() => {
    const cached = localStorage.getItem("allSize");
    if (cached) {
      setAllSize(JSON.parse(cached));
    }
    Allsize();
  }, []);
  useEffect(() => {
    setDebouncedWeight(debouncedWeightValue);
  }, [debouncedWeightValue]);

  const size = async () => {
    try {
      const heightInInches =
        typeof selectedHeight === "string" && selectedHeight.includes("'")
          ? convertHeightToInches(selectedHeight)
          : selectedHeight;
      // let weightValue = watch("Weight");
      let api =
        heightInInches < 60 // Less than 5' (60 inches)
          ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}&weight=${debouncedWeight}`
          : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}&weight=${debouncedWeight}`;

      let response = await get(api);

      if (response?.status == true) {
        // Filter out categories with empty size charts
        const filteredCategories = response.data.filter(
          (category) => category.size_charts && category.size_charts.length > 0,
        );
        // If we have valid categories, store the first one as our original
        if (filteredCategories.length > 0) {
          setOriginalCategory(filteredCategories[0].name);
        }

        if (!filteredCategories || filteredCategories.length === 0) {
          api =
            heightInInches < 60
              ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}`
              : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}`;

          response = await get(api);

          if (response?.status == true) {
            const newFilteredCategories = response.data.filter(
              (category) =>
                category.size_charts && category.size_charts.length > 0,
            );

            if (newFilteredCategories.length > 0 && !originalCategory) {
              setOriginalCategory(newFilteredCategories[0].name);
            }
            setsizes(response.data);
            // setMatchedItems(newFilteredCategories);
          }
        } else {
          setsizes(response.data);
          // setMatchedItems(filteredCategories);
        }

        response.data
          .filter((category) => category.size_charts.length > 0)
          .forEach((category) => {
            // setcoattype(category.name);
            // setuniqcoat(category.size_charts)
          });

        let idToStore = null;
        for (const item of response.data) {
          if (item.size_charts && item.size_charts.length > 0) {
            idToStore = item.id;
            break; // Exit the loop once we find the first matching object
          }
        }

        setSizeid(idToStore);
        setStoprender(true);
        dispatch(setSize(idToStore));
        setValue("size_chart_category_id", idToStore);
        // setsizefilterid(idToStore);
        if (coatid) {
          sizeChartCategory(idToStore, coatid); // ✅ same function, parameter pass karo
        }

        if (response?.data.length > 0) {
          // Find the first category that has size_charts with data
          const categoryWithCharts = response.data.find(
            (category) =>
              category.size_charts && category.size_charts.length > 0,
          );

          if (categoryWithCharts && categoryWithCharts.size_charts.length > 0) {
            const chart = categoryWithCharts.size_charts[0]; // Use the first chart from the category that has data

            // Waist Sizes
            if (chart.minWaist && chart.maxWaist) {
              const sizes = [];
              for (
                let i = parseInt(chart.minWaist);
                i <= parseInt(chart.maxWaist);
                i++
              ) {
                sizes.push(i);
              }
              setWaistSizes(sizes);
            }

            // Hip Sizes
            if (chart.minHip && chart.maxHip) {
              const sizes = [];
              for (
                let i = parseInt(chart.minHip);
                i <= parseInt(chart.maxHip);
                i++
              ) {
                sizes.push(i);
              }
              setHipSizes(sizes);
            }

            // Outseam Sizes
            if (chart.minOutseam && chart.maxOutseam) {
              const sizes = [];
              for (
                let i = parseInt(chart.minOutseam);
                i <= parseInt(chart.maxOutseam);
                i++
              ) {
                sizes.push(i);
              }
              setoutseamSizes(sizes);
            }

            // Insleeve/Shirt Sleeve Sizes
            if (chart.minShirtSleeve && chart.maxShirtSleeve) {
              const sizes = [];
              for (
                let i = parseInt(chart.minShirtSleeve);
                i <= parseInt(chart.maxShirtSleeve);
                i++
              ) {
                sizes.push(i);
              }
              setInsleeveSizes(sizes);
            }

            // Shoe Sizes
            if (chart.minShoe && chart.maxShoe) {
              const sizes = [];
              for (
                let i = parseInt(chart.minShoe);
                i <= parseInt(chart.maxShoe);
                i++
              ) {
                sizes.push(i);
              }
              // setshoesSizes(sizes);
            }

            // Neck Sizes
            if (chart.minNeck && chart.maxNeck) {
              const sizes = [];
              for (
                let i = parseInt(chart.minNeck);
                i <= parseInt(chart.maxNeck);
                i++
              ) {
                sizes.push(i);
              }
              setNeckSizes(sizes);
            }
          } else {
            // No categories with size charts found - clear bold sizes
            setWaistSizes([]);
            setHipSizes([]);
            setoutseamSizes([]);
            setInsleeveSizes([]);
            // setshoesSizes([]);
            setNeckSizes([]);
          }
        }
      }
    } catch (err) {
      if (
        err?.message == "Invalid or expired token" ||
        err?.message == "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      // console.error('Error:', err);
    } finally {
    }
  };

  useEffect(() => {
    const height = selectedHeight || initialValues?.Height;
    const currentWeight = watch("Weight");
    const currentCoatSize = watch("CoatSize");

    if (height) {
      let heightInInches;

      // Handle "Unknown" height
      if (height === "Unknown") {
        // Rule 1: If coat size is between 3 and 14, default to Boy
        if (currentCoatSize && currentCoatSize >= 3 && currentCoatSize <= 14) {
          setOrderForState("Boys");
          setValue("order_for", "Boys");
        }
        // Rule 2: If no coat selected but weight < 90, default to Boy
        else if (
          !currentCoatSize &&
          currentWeight &&
          Number(currentWeight) < 90
        ) {
          setOrderForState("Boys");
          setValue("order_for", "Boys");
        }
        // Default to Men if neither condition is met
        else {
          setOrderForState("Men");
          setValue("order_for", "Men");
        }
      } else {
        // Normal height-based logic
        if (typeof height === "string" && height.includes("'")) {
          heightInInches = convertHeightToInches(height);
        } else {
          heightInInches = parseInt(height, 10);
        }

        if (heightInInches < 61) {
          setOrderForState("Boys");
          setValue("order_for", "Boys");
        } else {
          // Even with normal height >= 61, check coat size
          if (
            currentCoatSize &&
            currentCoatSize >= 3 &&
            currentCoatSize <= 14
          ) {
            setOrderForState("Boys");
            setValue("order_for", "Boys");
          } else {
            setOrderForState("Men");
            setValue("order_for", "Men");
          }
        }
      }

      size();
    }
  }, [
    selectedHeight,
    initialValues?.Height,
    debouncedWeight,
    watch("CoatSize"),
  ]);

  useEffect(() => {
    const currentCoatSize = watch("CoatSize");
    const height = selectedHeight || initialValues?.Height;
    const currentWeight = watch("Weight");

    // When coat size changes, re-evaluate Boys vs Men
    if (currentCoatSize) {
      if (currentCoatSize >= 3 && currentCoatSize <= 14) {
        setOrderForState("Boys");
        setValue("order_for", "Boys");
      } else if (currentCoatSize >= 18) {
        // Coat sizes 18+ are typically Men's sizes
        setOrderForState("Men");
        setValue("order_for", "Men");
      }
    }
    // Handle case when coat is cleared but height is Unknown
    else if (
      height === "Unknown" &&
      currentWeight &&
      Number(currentWeight) < 90
    ) {
      setOrderForState("Boys");
      setValue("order_for", "Boys");
    }
  }, [watch("CoatSize")]);
  const convertHeightToInches = (heightString) => {
    const [feet, inches] = heightString
      .split("'")
      .map((part) => parseInt(part.replace(/['']/g, ""), 10));
    return feet * 12 + (inches || 0);
  };

  useEffect(() => {
    const height = selectedHeight || initialValues?.Height;
    if (height) {
      size();
    }
  }, [selectedHeight, initialValues?.Height, debouncedWeight]);

  const category1Data = data?.filter((item) => item.category_id === 1);
  const pants = data?.filter((item) => item.category_id === 2);
  const Shirt = data?.filter((item) => item.category_id === 3);
  const Vest = data?.filter((item) => item.category_id === 4);
  const Tie = data?.filter((item) => item.category_id === 5);
  const Shoes = data?.filter((item) => item.category_id === 7);
  const Pocket = data?.filter((item) => item.category_id === 8);
  const Jewelry = data?.filter((item) => item.category_id === 9);

  const heightOptions = [];
  for (let feet = 3; feet <= 6; feet++) {
    for (let inches = 1; inches <= 11; inches++) {
      const totalInches = feet * 12 + inches; // Convert to total inches
      heightOptions.push({
        display: `${feet}'${inches}''`, // Display format
        value: totalInches, // Value in inches
      });
    }
  }

  const weightValue = watch("Weight"); // Ensure weight updates

  useEffect(() => {
    if (
      !categoryName ||
      !selectedCoatSize ||
      !selectedHeight ||
      selectedHeight === "Unknown"
    ) {
      setNonBoldMessage("");
      return;
    }

    // Convert height to feet & inches format
    const feet = Math.floor(selectedHeight / 12);
    const inches = selectedHeight % 12;
    const formattedHeight = `${feet}'${inches}"`;

    let categoryInitial = "";
    const categoryToUse = originalCategory || categoryName;

    if (categoryToUse) {
      // For Extra Long, use XL, otherwise use first letter
      if (categoryToUse.startsWith("Extra")) {
        categoryInitial = "X";
      } else {
        categoryInitial = categoryToUse.charAt(0);
      }
    }

    const uniqueCoatSizes = sizes
      .filter((category) => category.size_charts.length > 0)
      .flatMap((category) => category.size_charts.map((size) => size.coatSize));
    if (uniqueCoatSizes.includes(selectedCoatSize)) {
      setNonBoldMessage("");
      return;
    }

    const isWeightValid =
      weightValue !== null &&
      weightValue !== undefined &&
      !isNaN(weightValue) &&
      weightValue !== "";

    const validSizeCharts = sizes
      .flatMap((category) => category.size_charts)
      .filter(
        (size) =>
          size.minHeight !== null &&
          size.maxHeight !== null &&
          selectedHeight >= size.minHeight &&
          selectedHeight <= size.maxHeight,
      );
    // Additional check to see if weight is within the range for any coat size
    let isWeightInRange = false;
    if (isWeightValid) {
      isWeightInRange = validSizeCharts.some(
        (chart) =>
          (!chart.minWeight || Number(weightValue) >= chart.minWeight) &&
          (!chart.maxWeight || Number(weightValue) <= chart.maxWeight),
      );
    }

    // Only include weight in the message if it's valid AND in range
    const weightText =
      isWeightValid && isWeightInRange ? `, Weight: ${weightValue}` : "";

    if (validSizeCharts.length === 0) {
      const allSizes = sizes
        .flatMap((category) =>
          category.size_charts.map((size) => size.coatSize),
        )
        .filter((size) => !isNaN(parseInt(size)))
        .map((size) => parseInt(size));

      if (allSizes.length > 0) {
        const minSize = Math.min(...allSizes);
        const maxSize = Math.max(...allSizes);
        if (minSize === maxSize) {
          setNonBoldMessage(
            `<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minSize}${categoryInitial} for height ${formattedHeight}${weightText}`,
          );
        } else {
          setNonBoldMessage(
            `<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minSize}${categoryInitial}  to ${maxSize}${categoryInitial}  for height ${formattedHeight}${weightText}`,
          );
        }
      }
      return;
    }

    const selectedSizeChart = validSizeCharts.find(
      (size) => size.coatSize === selectedCoatSize,
    );

    if (!selectedSizeChart) {
      // If selected coat size is not found, recommend the full range of valid coat sizes
      const availableSizes = validSizeCharts
        .map((size) => size.coatSize)
        .filter((size) => !isNaN(parseInt(size)))
        .map((size) => parseInt(size))
        .sort((a, b) => a - b);

      if (availableSizes.length > 0) {
        const minAvailableSize = availableSizes[0];
        const maxAvailableSize = availableSizes[availableSizes.length - 1];

        if (minAvailableSize === maxAvailableSize) {
          let recommendedSize = minAvailableSize;

          if (RecomForEven && minAvailableSize && minAvailableSize % 2 !== 0) {
            recommendedSize = Number(minAvailableSize) + 1;
          }

          setNonBoldMessage(
            `<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${recommendedSize}${categoryInitial} for height ${formattedHeight}${weightText}`,
          );
          if (RecomForEven) {
            const CoatSizeRaw = watch("CoatSize");
            const selectedCategory =
              localStorage.getItem("selectedCategoryName") || "";

            const selectedCategoryInitial = selectedCategory.startsWith("Extra")
              ? "X"
              : selectedCategory.charAt(0).toUpperCase();

            if (
              recommendedSize == CoatSizeRaw &&
              categoryInitial == selectedCategoryInitial
            ) {
              setNonBoldMessage("");
            }
            // this lojic for even size recomended message enddddd

            console.log(recommendedSize, "recommendedSize", CoatSizeRaw);
          }
        } else {
          setNonBoldMessage(
            `<span style="font-size: 24px;">⚠️</span> Recommended Category ${categoryToUse}   for height ${formattedHeight}${weightText}`,
          );
        }
      }
    }
  }, [categoryName, selectedHeight, weightValue, sizes]); // Ensure reactivity

  useEffect(() => {
    // Restore saved values when component mounts
    const savedCoatSize = localStorage.getItem("selectedCoatSize") || null;
    const savedCategoryName =
      localStorage.getItem("selectedCategoryName") || null;
    const savedRecommendationMessage =
      localStorage.getItem("recommendationMessage") || null;
    const savedNonBoldMessage = localStorage.getItem("nonBoldMessage") || null;

    // Only restore these values if there's actually a saved coat size
    if (savedCoatSize) {
      setSelectedCoatSize(savedCoatSize);
      // setcoat(savedCoatSize);
      setValue("CoatSize", savedCoatSize);
      setValue("coatsize_chart_id", savedCoatSize);
      setCoatid(savedCoatSize);

      // Only restore category name if coat size exists
      if (savedCategoryName && orderForState === "Boys") {
        setCategoryName(savedCategoryName);
      }

      // Only restore messages if coat size exists
      if (savedRecommendationMessage) {
        setRecommendationMessage(savedRecommendationMessage);
      }

      if (savedNonBoldMessage) {
        setNonBoldMessage(savedNonBoldMessage);
      }
    } else {
      // If no coat size is saved, clear all related values
      setCategoryName("");
      setRecommendationMessage("");
      setNonBoldMessage("");
      localStorage.removeItem("recommendationMessage");
      localStorage.removeItem("nonBoldMessage");
      localStorage.removeItem("selectedCategoryName");
    }

    // Clean up function
    return () => {
      // Only save messages to localStorage if there's a selected coat size
      if (selectedCoatSize) {
        if (recommendationMessage) {
          localStorage.setItem("recommendationMessage", recommendationMessage);
        }
        if (nonBoldMessage) {
          localStorage.setItem("nonBoldMessage", nonBoldMessage);
        }
      } else {
        localStorage.removeItem("recommendationMessage");
        localStorage.removeItem("nonBoldMessage");
      }
    };
  }, []); // Empty dependency array to run only on mount and unmount

  useEffect(() => {
    if (sizeid && categoryName) {
      // Only update if it's NOT the initial load
      const isAddForm = !initialValues?.CoatSize;
      // if (isAddForm || !isInitialLoad) {
      //     updateInsleeveDefault();
      // }
      if (categoryName === "Boys" && !isUserSelectedInsleeve) {
        updateInsleeveDefault();
      }
      // For other categories, only update if not initial load
      else if (isAddForm || !isInitialLoad) {
        updateInsleeveDefault();
      }
    }
  }, [sizeid, categoryName, coatid]);

  // Add useEffect to mark initial load as complete after first render
  useEffect(() => {
    // Mark initial load as complete after component has mounted and data is loaded
    if (coatid && categoryName) {
      const timer = setTimeout(() => {
        setIsInitialLoad(false);
      }, 500); // Small delay to ensure initial values are set

      return () => clearTimeout(timer);
    }
  }, [coatid, categoryName]);

  // Add this new function to update insleeve default
  const updateInsleeveDefault = () => {
    let defaultValue = "";

    // Determine default value based on category name
    switch (categoryName) {
      case "Short":
        defaultValue = "16";
        break;
      case "Long":
        defaultValue = "18";
        break;
      case "Extra Long":
        defaultValue = "19";
        break;
      case "Regular":
        defaultValue = "17";
        break;
      default:
        // If categoryName doesn't match, check coatid
        switch (coatid) {
          case "3":
            defaultValue = "9";
            break;
          case "4":
            defaultValue = "10";
            break;
          case "6":
            defaultValue = "11";
            break;
          case "8":
            defaultValue = "12.5";
            break;
          case "10":
            defaultValue = "13";
            break;
          case "12":
            defaultValue = "14";
            break;
          case "14":
            defaultValue = "15";
            break;
          case "16":
            defaultValue = "16";
            break;
          case "18":
            defaultValue = "16.5";
            break;
          default:
            defaultValue = "";
            break;
        }
        break;
    }

    if (defaultValue) {
      setdefaultsize(defaultValue);
      setValue("Insleeve", defaultValue);
    }
  };

  useEffect(() => {
    if (coatid) {
      // const timer = setTimeout(() => {
      sizeChartCategory();
      // }, 2000); // 300ms delay, adjust as needed

      // Cleanup in case coatid changes before timeout
      // return () => clearTimeout(timer);
    }
  }, [coatid]);
  useEffect(() => {
    if (coatid && categoryName) {
      FuncForNotVAlid();
    }
  }, [coatid, categoryName]);
  const sizeChartCategory = async (overrideSizeid, overrideCoatid) => {
    const activeSizeid = overrideSizeid || sizeid;
    const activeCoatid = overrideCoatid || coatid;
    if (!activeSizeid) return;
    try {
      const api = `view-size-chart-category/${sizeid}?coatSize=${coatid}`;
      const response = await get(api);
      if (response?.status == true) {
        if (response.data?.name && !isUserSelectedCategory) {
          setCategoryName(response.data.name || "");
          localStorage.setItem("selectedCategoryName", response.data.name);

          const isAddForm = !initialValues?.CoatSize;
          if (
            isAddForm &&
            !getValues("Insleeve") &&
            !isUserSelectedInsleeve &&
            response.data.name !== "Boys"
          ) {
            updateInsleeveDefault();
          }
        }
        setsizesCategory(response.data?.size_charts);
        FuncForNotVAlid(response.data.name); // ✅ Pass the correct name
        if (response.data?.name == "Boys") {
        } else {
        }
        setValue("coat_size_chart_id", response?.data.size_charts[0].id);

        if (!getValues("size_chart_category_id")) {
          setValue("size_chart_category_id", response?.data.size_charts[0].id);
        }

        if (response?.data.size_charts.length > 0) {
          const minWaist = parseInt(response?.data.size_charts[0].minWaist);
          const maxWaist = parseInt(response?.data.size_charts[0].maxWaist);
          const sizes = [];
          for (let i = minWaist; i <= maxWaist; i++) {
            sizes.push(i);
          }

          setWaistSizes(sizes);
        }
        if (response?.data.size_charts.length > 0) {
          const minNeck = parseInt(response?.data.size_charts[0].minNeck);
          const maxNeck = parseInt(response?.data.size_charts[0].maxNeck);
          const sizes = [];
          for (let i = minNeck; i <= maxNeck; i++) {
            sizes.push(i);
          }
          setNeckSizes(sizes);
        }
        if (response?.data.size_charts.length > 0) {
          const minShirtSleeve = parseInt(
            response?.data.size_charts[0].minShirtSleeve,
          );
          const maxShirtSleeve = parseInt(
            response?.data.size_charts[0].maxShirtSleeve,
          );
          const sizes = [];
          for (let i = minShirtSleeve; i <= maxShirtSleeve; i++) {
            sizes.push(i);
          }
          setInsleeveSizes(sizes);
        }
        if (response?.data.size_charts.length > 0) {
          const minShoe = parseInt(response?.data.size_charts[0].minShoe);
          const maxShoe = parseInt(response?.data.size_charts[0].maxShoe);
          const sizes = [];
          for (let i = minShoe; i <= maxShoe; i++) {
            sizes.push(i);
          }
          // setshoesSizes(sizes);
        }
        if (response?.data.size_charts.length > 0) {
          const minOutseam = parseInt(response?.data.size_charts[0].minOutseam);
          const maxOutseam = parseInt(response?.data.size_charts[0].maxOutseam);
          const sizes = [];
          for (let i = minOutseam; i <= maxOutseam; i++) {
            sizes.push(i);
          }
          setoutseamSizes(sizes);
        }
        // setshoesSizes
        if (response?.data.size_charts.length > 0) {
          const minHip = parseInt(response?.data.size_charts[0].minHip);
          const maxHip = parseInt(response?.data.size_charts[0].maxHip);
          const sizes = [];
          for (let i = minHip; i <= maxHip; i++) {
            sizes.push(i);
          }
          setHipSizes(sizes);
        }
      }
    } catch (err) {
      setWaistSizes([]);
      setHipSizes([]);
      setNeckSizes([]);
      setInsleeveSizes([]);
      // setshoesSizes([])
      setoutseamSizes([]);
      FuncForNotVAlid();
    } finally {
    }
  };
  const FuncForNotVAlid = async () => {
    try {
      const api = `all-size-chart-categories?coatSize=${coatid}`;
      const response = await get(api);
      if (response?.status == true) {
        let matchedItems = [];
        let recommendationMessage = "";
        let isFirstMatch = true;
        const storedCategoryName =
          localStorage.getItem("selectedCategoryName") || null;

        // Loop through each size category
        for (const item of response.data) {
          // Check if the item has size charts
          if (item.size_charts && item.size_charts.length > 0) {
            // Loop through the size charts of this category
            for (const sizeChart of item.size_charts) {
              // Check if the coat size matches the target ID
              if (sizeChart.coatSize === coatid) {
                // Add this entire size category to the matches
                matchedItems.push(item);
                if (isFirstMatch) {
                  const rever = localStorage.getItem("size") || null;

                  if (Stoprender) {
                    if (isFirstRun && rever) {
                      setValue("size_chart_category_id", rever);
                      dispatch(setSize(rever));
                      setSizeid(rever);
                      // If we're restoring a previous size, find and set the category name
                      const categoryItem = response.data.find(
                        (cat) => cat.id === rever,
                      );
                      if (categoryItem && !categoryName) {
                        setCategoryName(categoryItem.name);
                        localStorage.setItem(
                          "selectedCategoryName",
                          categoryItem.name,
                        );
                      } else if (storedCategoryName) {
                        // Use stored category name as fallback
                        setCategoryName(storedCategoryName);
                      }
                    } else {
                      // If stored category exists, find the matching category ID
                      if (storedCategoryName) {
                        const storedCategory = response.data.find(
                          (cat) => cat.name === storedCategoryName,
                        );
                        if (storedCategory) {
                          setValue("size_chart_category_id", storedCategory.id);
                          dispatch(setSize(storedCategory.id));
                          setSizeid(storedCategory.id);
                          // setCategoryName(storedCategoryName);
                          if (!categoryName)
                            setCategoryName(storedCategory.name);
                        } else {
                          setValue("size_chart_category_id", item.id);
                          dispatch(setSize(item.id));
                          setSizeid(item.id);
                        }
                      } else {
                        setValue("size_chart_category_id", item.id);
                        dispatch(setSize(item.id));
                        setSizeid(item.id);
                      }
                    }
                    setIsFirstRun(false); // Update state (triggers re-render if needed)
                    setStoprender(true);
                    isFirstMatch = false;
                  }
                }
                break; // Exit the size charts loop once a match is found in this category
              }
            }
          }
        }
        // Update the state with all matched items at once
        setMatchedItems(matchedItems);

        console.log("Current categoryName:", categoryName);
        console.log("API Response:", response.data);
        // Update recommended range when category changes
        // Update recommended range when category changes
        if (categoryName) {
          const matchedCategory = response.data.find(
            (cat) => cat.name === categoryName && cat.size_charts.length > 0,
          );

          if (matchedCategory && matchedCategory.size_charts[0]) {
            const chart = matchedCategory.size_charts[0];

            const newRange = {
              waistMin: chart.minWaistNumeric,
              waistMax: chart.maxWaistNumeric,
              hipMin: chart.minHipNumeric,
              hipMax: chart.maxHipNumeric,
              outseamMin: chart.minOutseamNumeric,
              outseamMax: chart.maxOutseamNumeric,
              sleeveMin: Number(chart.minShirtSleeveNumeric),
              sleeveMax: Number(chart.maxShirtSleeveNumeric),

              vestSize: chart.vestSize,
            };
            console.log("newRangenewRange", newRange);

            setRecommendedRange(newRange);
            setRecommendedVestSize(chart.vestSize);

            // ✅ Pass newRange as third parameter
            const waist = watch("Waist");
            if (waist) {
              checkPantSizeRanges(waist, "waist", newRange);
            }
            const currentVest = watch("VestColor");
            if (currentVest && vestStyleSelected) {
              checkVestSizeRanges(
                { value: currentVest, label: currentVest },
                "vest",
                newRange,
              );
            }
            const currentSleeve = watch("Sleeve");
            if (currentSleeve) {
              checkShirtSizeRanges(watch("ShirtSize"), "Sleeve", newRange);
            }
          }
        }
      }
    } catch (err) {
      if (
        err?.message == "Invalid or expired token" ||
        err?.message == "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } finally {
    }
  };
  const handlejwellaryChange = (e) => {
    const selectedStyle = Jewelry.find((item) => item.style === e.target.value);
    if (selectedStyle) {
      setValue("jewelryinventory_id", selectedStyle.id);
    }
  };

  const handleTie = (e) => {
    const selectedStyle = Tie.find((item) => item.style == e.target.value);
    if (selectedStyle) {
      setValue("TieInventory_id", selectedStyle.id);
    }
  };

  const handlePocket = (e) => {
    // Get the combined value from the event
    const selectedPocketString = e.target.value; // This is `${item.style} ${item.description}`
    // Find the matching pocket style in the Pocket array
    const selectedStyle = Pocket.find(
      (item) => `${item.style}` == selectedPocketString,
    );

    if (selectedStyle) {
      // Update the form state or other logic
      setValue("PocketInventory_id", selectedStyle.id); // Set the inventory ID
      setValue("Pocket", e.target.value, { shouldValidate: true });
    } else {
      // console.error("Selected pocket style not found in Pocket array.");
      // Handle the case where no matching pocket style is found
    }
  };
  const handleCoatChange = async (selectedOption) => {
    // selectedOption is the entire option object, not an event

    if (selectedOption) {
      // Find the selected item from category1Data
      const selectedStyle = category1Data.find(
        (item) => item.style === selectedOption.value,
      );
      const serializedData = JSON.stringify(selectedStyle);
      localStorage.setItem("coatStyle", serializedData);
      console.log(selectedStyle, "selectedOption..................");
      setForEvenCoat(selectedStyle.even_sizes_only);
      setRecomForEven(selectedStyle.even_sizes_only);

      // Do something with the selected style
      setValue("coatinventory_id", selectedStyle.id);
      setSelectedStyle(selectedStyle.id);
      setSelectedCoatSize(null);
      localStorage.removeItem("coatid");
      localStorage.removeItem("selectedCoatSize");
      setSelectedCoatSize(null);
      // setcoat(null);
      setCoatid(null);
      setValue("CoatSize", null); // Reset form field
      setValue("Insleeve", null);
      setValue("coatsize_chart_id", null);
      setCategoryName("");
      // localStorage.removeItem('selectedCategoryName');
      setMatchedItems([]);
      setCategoryValidationMessage("");
      setIsUserSelectedCategory(false);
      setCoatstyle(selectedStyle); // Update state with the selected style
      setSelectedCoatStyleForPants(selectedStyle.style);
      // Clear localStorage
      localStorage.removeItem("coatid");
      localStorage.removeItem("selectedCoatSize");
      localStorage.removeItem("selectedCategoryName");
      // Fetch related data
      try {
        await Promise.all([
          fetchCoatStyles(),
          fetchMatchedPantStyles(selectedStyle.style),
        ]);

        // Force refresh of size categories after style change
        // This ensures categories are available for the new style
        if (allSizes && allSizes.length > 0) {
          // Reset all size-related states to ensure fresh data
          setMatchedItems([]);
          setWaistSizes([]);
          setHipSizes([]);
          setNeckSizes([]);
          setInsleeveSizes([]);
          // setshoesSizes([]);
          setoutseamSizes([]);
        }
      } catch (error) {
        console.error("Error fetching style data:", error);
      }
    } else {
      // Handle the case where the selection is cleared
      setCoatstyle(null); // Reset the state
      setSelectedStyle(null); // Reset the selected style ID
      setValue("coatinventory_id", ""); // Clear the form value
      localStorage.removeItem("coatStyle");
      setCoatSizeValidation({});
      clearErrors("CoatSize");
      setSelectedCoatSize(null);
      localStorage.removeItem("coatid");
      localStorage.removeItem("selectedCoatSize");
      setValue("Insleeve", null);

      setSelectedCoatSize(null);
      // setcoat(null);
      setValue("CoatSize", null);
      setValue("coatsize_chart_id", "");
      setSelectedCoatStyleForPants(null);
      setCategoryName("");
      setCoatid(null);
      setMatchedItems([]);
      setIsUserSelectedCategory(false);
      localStorage.removeItem("coatid");
      localStorage.removeItem("selectedCoatSize");
      localStorage.removeItem("selectedCategoryName");
    }
  };

  const handlePaintChange = (e) => {
    // Split the combined value to extract the style
    const selectedStyleString = e.target.value; // This is the style value
    const selectedStyle = pants.find(
      (item) => item.style === selectedStyleString,
    );

    if (selectedStyle) {
      // Save complete pant data to localStorage
      const serializedData = JSON.stringify(selectedStyle);
      localStorage.setItem("pantStyle", serializedData); // Changed key to 'pantStyle' for consistency

      setValue("Paintinventory_id", selectedStyle.id);
      setPantstyle(selectedStyle); // Update state with the selected style
      setValue("Pant", selectedStyleString, { shouldValidate: true }); // Store just the style value
      setSelectedPantStyle(selectedStyle.id);
    } else {
      // Clear everything when no selection
      localStorage.removeItem("pantStyle");
      setValue("Paintinventory_id", "");
      setPantstyle(null);
      setValue("Pant", "");
      setSelectedPantStyle(null);
      setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
    }
  };
  const handleShirtChange = (e) => {
    // Get the combined value from the event
    const selectedShirtString = e.target.value; // This is `${item.style} ${item.description}`

    // Find the matching shirt in the shirts array
    const selectedShirt = sortedShirts.find(
      (item) => `${item.style}` == selectedShirtString,
    );

    if (selectedShirt) {
      // Update the form state or other logic
      setValue("shirtInventory_id", selectedShirt.id); // Set the inventory ID
      const serializedData = JSON.stringify(selectedShirt);
      localStorage.setItem("shirtstyle", serializedData); // Save to localStorage
      setValue("Shirt", e.target.value, { shouldValidate: true }); // Update form value
      setSelectedShirtStyle(selectedShirt.id);
      // Recalculate neck options immediately using selectedShirt
      const options = getNeckOptions(
        AllSize?.neckSizes,
        selectedShirt,
        sizesCategory,
        NeckSizes,
      );
      setNeckSizeOptions(options);
    } else {
      setValue("shirtInventory_id", ""); // Set the inventory ID
      setSelectedShirtStyle(null);
      localStorage.removeItem("shirtstyle"); // Save to localStorage
      setValue("Shirt", "");
      const options = getNeckOptions(
        AllSize?.neckSizes,
        null,
        sizesCategory,
        NeckSizes,
      );
      setNeckSizeOptions(options);
    }
  };
  const handleVestChange = (e) => {
    // Find the selected item from category1Data
    const selectedStyle =
      Vest.find((item) => item.style == e.target.value) || null;
    setValue("Vest", e.target.value, { shouldValidate: true });

    if (selectedStyle) {
      // Store valid JSON in localStorage
      localStorage.setItem("Veststyle", JSON.stringify(selectedStyle));

      // Safely set value if selectedStyle is not null
      setValue("VestInventory_id", selectedStyle.id);
      setVeststyle(selectedStyle);
    } else {
      // Handle case where user clears the selection
      setValue("Vest", "");

      localStorage.removeItem("Veststyle"); // Remove stored data
      setValue("VestInventory_id", ""); // Clear the ID
      setVeststyle(null); // Reset state
    }
  };
  const handleShoes = (e) => {
    // Get the combined value from the event
    // const selectedShoesString = e.target.value; // This is `${item.style} ${item.description}`

    // Find the matching shoes in the Shoes array
    const selectedStyle = Shoes.find((item) => item.style == e.target.value);

    if (selectedStyle) {
      localStorage.setItem("Shoes", JSON.stringify(selectedStyle));
      setShoesstyle(selectedStyle);
      // Update the form state or other logic
      setValue("ShoesInventory_id", selectedStyle.id); // Set the inventory ID
      setValue("Shoes", e.target.value, { shouldValidate: true });
    } else {
      setShoesstyle("");
      localStorage.removeItem("Shoes"); // Remove stored data
    }
  };

  const fetchInventoryDatatwi = async () => {
    try {
      const api = `all-inventory-categories`;
      const totalData = await get(api);
    } catch (err) {
      if (
        err?.message == "Invalid or expired token" ||
        err?.message == "Invalid Token"
      ) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } finally {
    }
  };
  useEffect(() => {
    fetchInventoryDatatwi();
  }, []);

  const options = [...category1Data]
    .sort((a, b) => a.style.localeCompare(b.style))
    .map((item) => ({
      value: item.style,
      label: `${item.style} ${item.description}`,
    }));

  const getHeightOptions = () => {
    const baseOptions = heightOptions.map((height) => {
      const heightValue = String(height.value);
      let heightInches = 0;

      if (heightValue === "Unknown") {
        heightInches = 0;
      } else if (typeof heightValue === "string" && heightValue.includes("'")) {
        const parts = heightValue.split("'");
        const feet = parseInt(parts[0], 10) || 0;
        const inches = parseInt(parts[1], 10) || 0;
        heightInches = feet * 12 + inches;
      } else if (typeof heightValue === "string") {
        heightInches = parseInt(heightValue, 10) || 0;
      }

      return {
        value: height.value,
        label: height.display,
      };
    });

    // Helper function to insert height if missing
    const insertHeightIfMissing = (value, label, nextValue) => {
      if (!baseOptions.find((opt) => opt.value === value)) {
        const index = baseOptions.findIndex((opt) => opt.value === nextValue);
        const newOption = { value, label, isDisabled: false };

        if (index !== -1) {
          baseOptions.splice(index, 0, newOption);
        } else {
          baseOptions.push(newOption);
        }
      }
    };

    // Ensure required heights exist
    insertHeightIfMissing(36, "3'0\"", 37); // 3'0"
    insertHeightIfMissing(48, "4'0\"", 49); // 4'0"
    insertHeightIfMissing(60, "5'0\"", 61); // already in your code
    insertHeightIfMissing(72, "6'0\"", 73); // already in your code
    insertHeightIfMissing(84, "7'0\"", 85); // 7'0"

    return [
      { value: "Unknown", label: "Unknown", isDisabled: false },
      ...baseOptions,
    ];
  };

  const sortedOptions = [...options].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { numeric: true }),
  );
  const sortedPants = [...pants].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );

  const sortedShirts = [...Shirt].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );
  const sortedVest = [...Vest].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );
  const sortedTie = [...Tie].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );
  const sortedPocketSquare = [...Pocket].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );
  const sortedJewelry = [...Jewelry].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );
  const sortedShoes = [...Shoes].sort((a, b) =>
    a.style.localeCompare(b.style, undefined, { numeric: true }),
  );

  const customComponents = {
    DropdownIndicator: (props) => (
      <div
        {...props}
        style={{ padding: "5px", display: "flex", alignItems: "center" }}
      >
        <Search size={16} />
      </div>
    ),
  };
  // Add this function to your component
  const getShirtSize = (neck, sleeve) => {
    if (!neck) return "";

    const neckValue = Number(neck);

    const sleeveValue = sleeve ? Number(sleeve) : null; // Convert only if sleeve exists

    if (neckValue < 13) {
      if (neckValue >= 10 && neckValue <= 10.5) return "BXS";
      if (neckValue >= 11 && neckValue <= 11.5) return "BS";
      if (neckValue >= 12 && neckValue <= 12.5) return "BM";
      //   if (neckValue >= 13 && neckValue <= 13.5)return "BL";
      return ""; // Return empty if no match
    }
    // ✅ Special case: 13 / 13.5 without sleeve = Boys' Large (BL)
    if ((neckValue === 13 || neckValue === 13.5) && !sleeveValue) {
      return "BL";
    }
    // if ((neckValue === 14 || neckValue === 14.5) && !sleeveValue) {
    //   return "BL";
    // }
    // if ((neckValue === 15 || neckValue === 15.5) && !sleeveValue) {
    //   return "S";
    // }

    const shirtMapping = {
      13: { 30: "XS1", 32: "XS3" },
      14: { 30: "S1", 32: "S3", 34: "S5", 36: "S7" },
      15: { 30: "M1", 32: "M3", 34: "M5", 36: "M7", 38: "M9" },
      16: { 30: "L1", 32: "L3", 34: "L5", 36: "L7", 38: "L9" },
      17: { 30: "XL1", 32: "XL3", 34: "XL5", 36: "XL7", 38: "XL9" },
      18: { 30: "2XL1", 32: "2XL3", 34: "2XL5", 36: "2XL7", 38: "2XL9" },
      19: { 32: "3XL3", 34: "3XL5", 36: "3XL7", 38: "3XL9" },
      20: { 32: "4XL3", 34: "4XL5", 36: "4XL7", 38: "4XL9" },
      22: { 32: "5XL3", 34: "5XL5", 36: "5XL7", 38: "5XL9" },
      24: { 34: "6XL5", 36: "6XL7", 38: "6XL9" },
      26: { 34: "7XL5", 36: "7XL7", 38: "7XL9" },
    };

    const neckKey = Math.round(neckValue);
    // Find the closest mapping for sleeve size (floor to nearest even number)
    const sleeveKey = sleeveValue ? Math.round(sleeveValue / 2) * 2 : null;
    return shirtMapping[neckKey]?.[sleeveKey] || "";
  };
  // Add these arrays to your component, outside any function

  const ShoeSizes = [
    "1K",
    "2K",
    "3K",
    "4K",
    "5K",
    "6K",
    "8K",
    "9K",
    "10K",
    "11K",
    "12K",
    "13K",
    " 6.5D",
    "7D",
    "7.5D",
    "8D",
    "8W",
    "8.5D",
    "8.5W",
    "9D",
    "9W",
    "9.5D",
    "9.5W",
    "10D",
    "10W",
    "10.5D",
    "10.5W",
    "11D",
    "11W",
    "11.5D",
    "11.5W",
    "12D",
    "12W",
    "13D",
    "13W",
    "14D",
    "14W",
    "15D",
    "15W",
    "16D",
    "16W",
    "17D",
    "17W",
    "18D",
    "18W",
  ];

  useEffect(() => {
    // Get current values from the form
    const neckValueRaw = watch("ShirtSize");
    const sleeveValue = watch("Sleeve");

    const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null;

    // let calculatedShirtSize = isBoyOrder
    //   ? getShirtSize(neckValue, null)
    //   : getShirtSize(neckValue, sleeveValue);
    let calculatedShirtSize = getShirtSize(neckValue, sleeveValue);

    setDisableSleeve(false); // Ensure the sleeve dropdown remains enabled
    setShirtSizes(calculatedShirtSize || "");
    dispatch(setShirtSize(calculatedShirtSize));
    // }
  }, [
    watch("ShirtSize"),
    watch("Sleeve"),
    coatid,
    selectedHeight,
    initialValues.Height,
  ]);

  const isBoyOrder = useMemo(() => {
    const coatSizeValue = watch("CoatSize");

    if (!coatSizeValue) return false; // Default to Men's order if no size is selected

    if (coatSizeValue >= 3 && coatSizeValue <= 18) {
      return true; // Boy Order
    }
    return false; // Otherwise, it's a Men's order
  }, [watch("CoatSize")]);

  useEffect(() => {
    const neckValueRaw = watch("ShirtSize"); // Get the selected neck size
    const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null; // Extract valid number
    const coatSizeValue = watch("CoatSize");
    const heightValue = watch("Height");
    const heightInInches = heightValue ? parseInt(heightValue, 10) : null;

    const isBoyOrder =
      neckValue !== null &&
      neckValue <= 13 &&
      //   coatSizeValue &&
      //   coatSizeValue >= 3 &&
      //   coatSizeValue <= 18 &&
      orderForState === "Boys"; // Boys' order condition

    // const shouldAffectSleeve = isBoyOrder && neckValue < 13;
    // const shouldAffectSleeve = isBoyOrder
    //     ? (neckValue !== null && neckValue <= 13)  // Boys: hide for 13/13.5 and below
    //     : (neckValue !== null && neckValue < 13);
    // ✅ Sleeve logic
    let shouldAffectSleeve;

    if (
      neckValue === 13 &&
      heightInInches !== null &&
      heightInInches < 60 &&
      orderForState === "Boys"
    ) {
      // Only for neck 13/13.5 & height < 60 & boys → hide sleeve
      shouldAffectSleeve = true;
    } else {
      // Existing logic
      shouldAffectSleeve = isBoyOrder
        ? neckValue !== null && neckValue <= 13 // Boys: hide for 13/13.5 and below
        : neckValue !== null && neckValue < 13;
    }

    setDisableSleeve(shouldAffectSleeve); //  Only disable for neck < 13
    setShowSleeve(!shouldAffectSleeve);
    if (shouldAffectSleeve) {
      clearErrors("Sleeve");
    }
  }, [watch("ShirtSize"), watch("Height")]);

  useEffect(() => {
    setShirtStyleSelected(!!shirtStyleValue);
    if (!shirtStyleValue) {
      // Reset Neck and Sleeve fields when Shirt Style is deselected
      setValue("ShirtSize", "");
      setValue("Sleeve", "");
      clearErrors(["ShirtSize", "Sleeve"]); // Clear any validation errors
    }
  }, [shirtStyleValue, setValue, clearErrors]);

  const [vestStyleSelected, setVestStyleSelected] = useState(false);

  // Add this useEffect hook for vest style handling
  useEffect(() => {
    setVestStyleSelected(!!selectedVestStyle); // Assuming vestStyleValue is your vest style state
    if (!selectedVestStyle) {
      // Reset Vest Color field when Vest Style is deselected
      setValue("VestColor", "");
      clearErrors(["VestColor"]); // Clear any validation errors
      setVestRecommendationMsg("");
      localStorage.removeItem("vestRecommendationMsg");
    }
  }, [selectedVestStyle, setValue, clearErrors]);

  useEffect(() => {
    console.log("AUTO DEFAULT VALUES:", {
      coatid,
      categoryName,
      recommendedRange,
      vestSize: recommendedVestSize,
    });

    if (!vestStyleSelected) return;
    if (isVestManuallySelected) return;

    let uniqueSizes = [];
    console.log("---- AUTO DEFAULT DEBUG START ----");

    if (coatid && recommendedVestSize) {
      uniqueSizes = [recommendedVestSize];
      console.log("Coat Based Recommended Size:", recommendedVestSize);
    }

    // Case 2: No coat, but Height + Weight are valid
    else if (!coatid && selectedHeight && selectedHeight !== "Unknown") {
      const weight = watch("Weight");
      console.log("---- HEIGHT + WEIGHT DEBUG ----");
      console.log("Selected Height:", selectedHeight);
      console.log("Selected Weight:", weight);
      const isWeightValid =
        weight !== null &&
        weight !== undefined &&
        !isNaN(weight) &&
        weight !== "";
      console.log("Is Weight Valid:", isWeightValid);
      if (isWeightValid) {
        const validSizeCharts = sizes
          .flatMap((category) => category.size_charts)
          .filter(
            (size) =>
              size.minHeight !== null &&
              size.maxHeight !== null &&
              selectedHeight >= size.minHeight &&
              selectedHeight <= size.maxHeight,
          );
        console.log("Valid Charts (Height Match):", validSizeCharts);
        const isWeightInRange = validSizeCharts.some(
          (chart) =>
            (!chart.minWeight || Number(weight) >= chart.minWeight) &&
            (!chart.maxWeight || Number(weight) <= chart.maxWeight),
        );
        console.log("Is Weight In Range:", isWeightInRange);
        if (isWeightInRange && validSizeCharts.length > 0) {
          // let foundChart = null;
          // for (const category of sizes || []) {
          //     if (category.size_charts && category.size_charts.length > 0) {
          //         foundChart = category.size_charts[0];
          //         break;
          //     }
          // }
          let foundChart = validSizeCharts.find(
            (chart) =>
              (!chart.minWeight || Number(weight) >= chart.minWeight) &&
              (!chart.maxWeight || Number(weight) <= chart.maxWeight),
          );

          console.log("Found Chart:", foundChart);
          console.log("Recommended Vest Size:", foundChart?.vestSize);
          // if (foundChart && foundChart.vestSize) {
          //     uniqueSizes = [foundChart.vestSize];
          // }
          if (foundChart?.vestSize) {
            uniqueSizes = [foundChart.vestSize];
          }
        }
      }
    }
    // Case 3: Height = "Unknown" AND no coat selected → DO NOT set default
    // This is intentionally left empty - no default will be set

    uniqueSizes = [...new Set(uniqueSizes)];
    console.log("Final uniqueSizes (BOLD SIZE):", uniqueSizes);

    const defaultVestSize = uniqueSizes[0];
    console.log("Default Vest Size:", defaultVestSize);

    // if (defaultVestSize) {
    //     setValue("VestColor", defaultVestSize, { shouldValidate: true });
    // }
    if (!defaultVestSize) return;
    console.log("Setting Default Vest Size:", defaultVestSize);

    // if (isVestManuallySelected) {
    //     // ✅ Manually selected hai - sirf msg update karo, value mat badlo
    //     checkVestSizeRanges({ value: watch("VestColor"), label: watch("VestColor") }, "vest");
    //     return;
    // }

    // Auto-set default
    setValue("VestColor", defaultVestSize);
    console.log("---- AUTO DEFAULT DEBUG END ----");
  }, [
    coatid,
    categoryName,
    recommendedRange,
    vestStyleSelected,
    selectedHeight,
    watch("Weight"),
    sizes,
    isVestManuallySelected,
  ]);
  const [shoesStyleSelected, setShoesStyleSelected] = useState(false);

  // Add this useEffect hook for shoes style handling
  useEffect(() => {
    setShoesStyleSelected(!!selectedShoesStyle); // Assuming shoesStyleValue is your shoes style state
    if (!selectedShoesStyle) {
      // Reset Shoes Size field when Shoes Style is deselected
      setValue("ShoesSize", "");
      clearErrors(["ShoesSize"]); // Clear any validation errors
    }
  }, [selectedShoesStyle, setValue, clearErrors]);

  const generateNeckSizes = (sizes) => {
    return [...new Set(sizes.map((size) => Math.floor(size)))] // Remove duplicates
      .sort((a, b) => a - b) // Sort ascending
      .map((baseSize) => {
        if (baseSize >= 10 && baseSize < 20) {
          return {
            value: `${baseSize}/${baseSize + 0.5}`,
            label: `${baseSize}/${baseSize + 0.5}`,
            baseValue: baseSize,
          }; // 10/10.5, 11/11.5, etc.
        } else if (baseSize >= 20 && baseSize % 2 === 0) {
          return {
            value: `${baseSize}/${baseSize + 1}`,
            label: `${baseSize}/${baseSize + 1}`,
            baseValue: baseSize, // Store original base number for comparison
          }; // 20/21, 22/23, 24/25 (Skipping alternate)
        }
        return null;
      })
      .filter((option) => option !== null); // Remove null values
  };

  // Add this useEffect in your component to update bold values

  useEffect(() => {
    let options = generateNeckSizes(AllSize?.neckSizes || []);
    const stored = localStorage.getItem("shirtstyle");
    if (stored) {
      try {
        const storedShirt = JSON.parse(stored);
        const shirtType = storedShirt?.type;
        if (shirtType === "Fitted") {
          options = options.filter(
            (opt) => opt.baseValue >= 14 && opt.baseValue <= 19,
          );
        } else if (shirtType === "Added Length") {
          options = options.filter(
            (opt) => opt.baseValue >= 18 && opt.baseValue <= 26,
          );
        }
      } catch (e) { }
    }
    let boldBaseValues = [];
    const weight = watch("Weight");
    const isWeightValid =
      weight !== null &&
      weight !== undefined &&
      !isNaN(weight) &&
      weight !== "";

    // Check if sizes array has data
    if (!sizes || sizes.length === 0) {
      setNeckSizeOptions(options.sort((a, b) => a.baseValue - b.baseValue));
      return;
    }

    const validSizeCharts = sizes
      .flatMap((category) => category.size_charts)
      .filter(
        (size) =>
          size.minHeight !== null &&
          size.maxHeight !== null &&
          selectedHeight >= size.minHeight &&
          selectedHeight <= size.maxHeight,
      );

    let isWeightInRange = false;
    if (isWeightValid) {
      isWeightInRange = validSizeCharts.some(
        (chart) =>
          (!chart.minWeight || Number(weight) >= chart.minWeight) &&
          (!chart.maxWeight || Number(weight) <= chart.maxWeight),
      );
    }

    const isHeightAndWeightValid =
      selectedHeight && isWeightValid && isWeightInRange;

    if (coatid && sizesCategory && sizesCategory[0]) {
      const neckMin = parseFloat(sizesCategory[0]?.minNeck);
      const neckMax = parseFloat(sizesCategory[0]?.maxNeck);

      if (!isNaN(neckMin) && !isNaN(neckMax)) {
        boldBaseValues = options
          .filter((opt) => opt.baseValue >= neckMin && opt.baseValue <= neckMax)
          .map((opt) => opt.baseValue);
      }
    }
    // Priority 2: Height and weight (only if NO coat size)
    else if (isHeightAndWeightValid) {
      let foundChart = null;
      for (const category of sizes || []) {
        if (category.size_charts && category.size_charts.length > 0) {
          foundChart = category.size_charts[0];
          break;
        }
      }

      if (foundChart) {
        const neckMin = parseFloat(foundChart?.minNeck);
        const neckMax = parseFloat(foundChart?.maxNeck);

        if (!isNaN(neckMin) && !isNaN(neckMax)) {
          boldBaseValues = options
            .filter(
              (opt) => opt.baseValue >= neckMin && opt.baseValue <= neckMax,
            )
            .map((opt) => opt.baseValue);
        }
      }
    }

    const finalOptions =
      boldBaseValues.length > 0
        ? reorderNeckSizes(options, boldBaseValues)
        : options.sort((a, b) => a.baseValue - b.baseValue);

    setNeckSizeOptions(finalOptions);
  }, [
    coatid,
    sizesCategory,
    selectedHeight,
    watch("Weight"),
    sizes,
    AllSize?.neckSizes,
  ]);
  // const [neckSizeOptions, setNeckSizeOptions] = useState(generateNeckSizes(AllSize?.neckSizes || []));
  const [neckSizeOptions, setNeckSizeOptions] = useState(
    reorderNeckSizes(generateNeckSizes(AllSize?.neckSizes || []), NeckSizes),
  );

  const sleeveSizeMapping = {
    "13/13.5": [30, 32],
    "14/14.5": [30, 32, 34, 36],
    "15/15.5": [30, 32, 34, 36, 38],
    "16/16.5": [30, 32, 34, 36, 38],
    "17/17.5": [30, 32, 34, 36, 38],
    "18/18.5": [30, 32, 34, 36, 38],
    "19/19.5": [32, 34, 36, 38],
    "20/21": [32, 34, 36, 38],
    "22/23": [32, 34, 36, 38],
    "24/25": [32, 34, 36, 38],
    "26/27": [32, 34, 36, 38],
  };

  const handleNeckChange = (selectedOption) => {
    setSelectedNeckSize(selectedOption ? selectedOption.value : null);
    setValue("ShirtSize", selectedOption ? selectedOption.value : ""); // Update form state
  };

  // Enhanced filteredSleeveOptions with custom sorting
  const filteredSleeveOptions = useMemo(() => {
    if (!selectedNeckSize) return [];
    // Get the current selected shirt style - extract just the style number
    const shirtValue = watch("Shirt");
    const currentShirtStyle = shirtValue ? shirtValue.split(" ")[0] : null; // Extract style number only

    // Define styles that should only show specific sleeves
    const restrictedStyles = ["606", "610", "614"];

    // Define the restricted sleeve sizes for those styles
    const restrictedSleeves = [34, 36];

    let availableSizes = [];

    // Check if current style is in restricted list
    if (currentShirtStyle && restrictedStyles.includes(currentShirtStyle)) {
      // For restricted styles, only show 34/35 and 36/37
      availableSizes = restrictedSleeves;
    } else {
      // For other styles, use the normal mapping
      availableSizes = sleeveSizeMapping[selectedNeckSize] || [];
    }

    const options = availableSizes.map((size) => {
      let isRecommended = false;

      // if (coatid && sizesCategory[0]) {
      //     // Coat selected → use recommended sleeve range from msg
      //     const sleeveMin = parseFloat(sizesCategory[0].minShirtSleeve);
      //     const sleeveMax = parseFloat(sizesCategory[0].maxShirtSleeve);
      //     // Check both numbers in label range
      //     const labelNums = [size, size + 1];
      //     isRecommended = labelNums.some(val => val >= sleeveMin && val <= sleeveMax);
      // }
      if (
        coatid &&
        categoryName &&
        recommendedRange?.sleeveMin &&
        recommendedRange?.sleeveMax
      ) {
        const labelNums = [size, size + 1];
        isRecommended = labelNums.some(
          (val) =>
            val >= recommendedRange.sleeveMin &&
            val <= recommendedRange.sleeveMax,
        );
      } else {
        isRecommended =
          InsleeveSizes.includes(size) || InsleeveSizes.includes(size + 1);
      }
      //         else {
      //     // Coat not selected → old bold logic
      //     isRecommended = InsleeveSizes.includes(size) || InsleeveSizes.includes(size + 1);
      // }

      return {
        value: size,
        label: `${size}/${size + 1}`,
        baseValue: size,
        isBold: isRecommended,
      };
    });
    // Separate bold and normal options
    const boldOptions = options
      .filter((option) => option.isBold)
      .sort((a, b) => a.value - b.value);
    const normalOptions = options.filter((option) => !option.isBold);
    console.log(options, "optionsoptions");

    console.log(boldOptions, "boldOptionsboldOptions");
    console.log(normalOptions, "normalOptionsnormalOptions");

    // Sort normal options: larger first, then smaller
    const largerNormals = normalOptions
      .filter(
        (option) =>
          boldOptions.length === 0 ||
          option.value > Math.max(...boldOptions.map((b) => b.value)),
      )
      .sort((a, b) => a.value - b.value);

    const smallerNormals = normalOptions
      .filter(
        (option) =>
          boldOptions.length > 0 &&
          option.value < Math.min(...boldOptions.map((b) => b.value)),
      )
      .sort((a, b) => b.value - a.value);

    // Combine: bold first, then larger normals, then smaller normals
    return [...boldOptions, ...largerNormals, ...smallerNormals];
  }, [
    selectedNeckSize,
    InsleeveSizes,
    watch("Shirt"),
    coatid,
    categoryName,
    recommendedRange,
  ]);

  useEffect(() => {
    const savedPantMsg =
      localStorage.getItem("pantSizeRecommendationMsg") || null;
    const savedShirtMsg =
      localStorage.getItem("shirtSizeRecommendationMsg") || null;
    const savedVestMsg = localStorage.getItem("vestRecommendationMsg") || null;

    if (savedPantMsg) setSizeRecommendationMsg(savedPantMsg);
    if (savedShirtMsg) setShirtSizeRecommendationMsg(savedShirtMsg);
    if (savedVestMsg) setVestRecommendationMsg(savedVestMsg);
  }, []);
  useEffect(() => {
    const waist = watch("Waist");
    const shirtSize = watch("ShirtSize");
    const selectedVestSize = watch("VestColor"); // <-- this line fixes the error

    if (pantStyleSelected) {
      checkPantSizeRanges(waist || null, "waist");
    }
    if (shirtSize) {
      checkShirtSizeRanges(shirtSize, "neck");
    }

    const vestValue = selectedVestSize
      ? { value: selectedVestSize, label: selectedVestSize.toString() }
      : null;
    if (vestValue) {
      checkVestSizeRanges(vestValue, "vest");
    }
  }, [
    coatid,
    categoryName,
    selectedHeight,
    watch("Vest"),
    watch("Waist"),
    pantStyleSelected,
    watch("outseam"),
    watch("hip"),
    watch("Sleeve"),
    watch("ShirtSize"),
  ]);
  useEffect(() => {
    if (
      selectedHeight &&
      weight &&
      LebelShirt?.style &&
      sizes &&
      sizes.length > 0
    ) {
      checkShirtSizeRanges(watch("ShirtSize"), "init");
    }
  }, [
    selectedHeight,
    weight,
    LebelShirt, // REQUIRED
    sizes, // REQUIRED (so it reruns when size ranges load)
    watch("ShirtSize"),
  ]);
  useEffect(() => {
    if (
      selectedHeight &&
      weight &&
      pantStyleSelected &&
      sizes &&
      sizes.length > 0
    ) {
      checkPantSizeRanges(watch("Waist"), "init");
    }
  }, [selectedHeight, weight, pantStyleSelected, sizes, watch("Waist")]);

  const checkPantSizeRanges = (
    selectedValue,
    fieldType,
    customRange = null,
  ) => {
    const activeRange = customRange || recommendedRange;
    // Clear existing message first
    setSizeRecommendationMsg("");

    console.log("checkPantSizeRanges called with:", {
      selectedValue,
      fieldType,
      recommendedRange,
      categoryName,
      coatid,
    });
    // Get user input values
    const waist = Number(watch("Waist"));
    const outseam = Number(watch("outseam"));
    const hip = Number(watch("hip"));
    const weight = watch("Weight");
    // Convert height to feet & inches format
    const feet = Math.floor(selectedHeight / 12);
    const inches = selectedHeight % 12;
    const formattedHeight = `${feet}'${inches}"`;

    // Waist Validation (Only if pantStyle is selected)
    let waistWarning = "";

    if (fieldType === "waist" && (!selectedValue || selectedValue === "")) {
      const updatedMsg = sizeRecommendationMsg
        .replace(/Recommended Waist sizes: [^,.]+,?\s?/g, "")
        .replace(/Recommended Waist: [^,.]+,?\s?/g, "")
        .trim();

      const finalMsg = updatedMsg ? `${updatedMsg}.` : "";
      setSizeRecommendationMsg(finalMsg);
      localStorage.setItem("pantSizeRecommendationMsg", finalMsg);
      // return;
    }

    if (pantStyleSelected && selectedValue && fieldType === "waist") {
      if (selectedValue.includes("/")) {
        const splitValues = selectedValue.split("/").map(Number);
        const waistMin = sizesCategory[0]?.minWaist;
        const waistMax = sizesCategory[0]?.maxWaist;
        const anyValid = splitValues.some(
          (val) => val >= waistMin && val <= waistMax,
        );

        if (!anyValid) {
          if (
            waistMin !== null &&
            waistMax !== null &&
            waistMin !== undefined &&
            waistMax !== undefined
          ) {
            const waistText = `${waistMin}-${waistMax}`;
            waistWarning = `Recommended Waist sizes: ${waistText}`;
            const msg = `<span style="font-size: 24px;">⚠️</span> ${waistWarning}`;
            setSizeRecommendationMsg(msg);
            localStorage.setItem("pantSizeRecommendationMsg", msg);
          }
          // return;
        } else {
          setSizeRecommendationMsg("");
          localStorage.removeItem("pantSizeRecommendationMsg");
        }
      }
    }

    // Case 1: Coat size is selected - use existing logic
    if (coatid && activeRange) {
      // const coatSize = coatid;
      // const waistMin = sizesCategory[0]?.minWaist;
      // const waistMax = sizesCategory[0]?.maxWaist;
      // const outseamMin = sizesCategory[0]?.minOutseam;
      // const outseamMax = sizesCategory[0]?.maxOutseam;
      // const hipMin = sizesCategory[0]?.minHip;
      // const hipMax = sizesCategory[0]?.maxHip;
      const waistMin = activeRange?.waistMin;
      const waistMax = activeRange?.waistMax;
      const outseamMin = activeRange?.outseamMin;
      const outseamMax = activeRange?.outseamMax;
      const hipMin = activeRange?.hipMin;
      const hipMax = activeRange?.hipMax;

      console.log("Using ranges:", {
        waistMin,
        waistMax,
        outseamMin,
        outseamMax,
        hipMin,
        hipMax,
      }); // ✅ Verify

      // if (waistMin && waistMax) {
      //     setRecommendedRange({
      //         waistMin, waistMax, hipMin,
      //         hipMax,
      //         outseamMin,
      //         outseamMax,
      //     });
      // }
      if (waistMin && waistMax) {
        setRecommendedRange((prev) => ({
          ...prev, // ✅ sleeveMin, sleeveMax, vestSize preserve
          waistMin,
          waistMax,
          hipMin,
          hipMax,
          outseamMin,
          outseamMax,
        }));
      }
      const noValidSizeData = [
        waistMin,
        waistMax,
        outseamMin,
        outseamMax,
        hipMin,
        hipMax,
      ].every((val) => val === null || val === undefined);

      if (noValidSizeData) {
        setSizeRecommendationMsg("");
        localStorage.removeItem("pantSizeRecommendationMsg");
        return;
      }
      const isWaistOut = waist && (waist < waistMin || waist > waistMax);
      const isOutseamOut =
        outseam && (outseam < outseamMin || outseam > outseamMax);
      const isHipOut = hip && (hip < hipMin || hip > hipMax);

      let categoryInitial = categoryName?.charAt(0) || "";
      if (categoryName?.includes("E")) {
        categoryInitial = "X";
      }

      const previousMsg = sizeRecommendationMsg || "";
      const hasPreviousWaistWarning =
        pantStyleSelected && previousMsg.includes("Recommended Waist sizes");
      if (
        isWaistOut ||
        isOutseamOut ||
        isHipOut ||
        waistWarning ||
        hasPreviousWaistWarning
      ) {
        let msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatid}${categoryInitial}: `;
        const parts = [];
        if (waistWarning) {
          parts.push(waistWarning);
        }
        if (waist && isWaistOut && waistMin != null && waistMax != null)
          parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
        if (outseam && isOutseamOut && outseamMin != null && outseamMax != null)
          parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
        if (hip && isHipOut && hipMin != null && hipMax != null)
          parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);
        const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
        setSizeRecommendationMsg(finalMsg);
        localStorage.setItem("pantSizeRecommendationMsg", finalMsg);
      } else {
        setSizeRecommendationMsg("");
        localStorage.removeItem("pantSizeRecommendationMsg", "");
      }
    }
    // Case 2: No coat size but have valid height and weight
    else if (selectedHeight && weight) {
      const isWeightValid =
        weight !== null &&
        weight !== undefined &&
        !isNaN(weight) &&
        weight !== "";

      const validSizeCharts = sizes
        .flatMap((category) => category.size_charts)
        .filter(
          (size) =>
            size.minHeight !== null &&
            size.maxHeight !== null &&
            selectedHeight >= size.minHeight &&
            selectedHeight <= size.maxHeight,
        );

      let isWeightInRange = false;
      if (isWeightValid) {
        isWeightInRange = validSizeCharts.some(
          (chart) =>
            (!chart.minWeight || Number(weight) >= chart.minWeight) &&
            (!chart.maxWeight || Number(weight) <= chart.maxWeight),
        );
      }

      if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
        const sizeData = sizes || [];
        if (sizeData.length > 0) {
          let foundChart = null;
          for (const category of sizeData) {
            if (category.size_charts && category.size_charts.length > 0) {
              foundChart = category.size_charts[0];
              break;
            }
          }

          if (foundChart) {
            const waistMin = foundChart.minWaist;
            const waistMax = foundChart.maxWaist;
            const outseamMin = foundChart.minOutseam;
            const outseamMax = foundChart.maxOutseam;
            const hipMin = foundChart.minHip;
            const hipMax = foundChart.maxHip;
            if (waistMin && waistMax) {
              setRecommendedRange({
                waistMin,
                waistMax,
                hipMin,
                hipMax,
                outseamMin,
                outseamMax,
              });
            }
            const isWaistOut = waist && (waist < waistMin || waist > waistMax);
            const isOutseamOut =
              outseam && (outseam < outseamMin || outseam > outseamMax);
            const isHipOut = hip && (hip < hipMin || hip > hipMax);

            let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
            const parts = [];
            if (waistWarning) {
              parts.push(waistWarning);
            }

            // Check each field independently - don't require all fields to be filled
            if (waist && isWaistOut)
              parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
            if (outseam && isOutseamOut)
              parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
            if (
              hip &&
              isHipOut &&
              hipMin != null &&
              hipMax != null &&
              hipMin !== undefined &&
              hipMax !== undefined
            )
              parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);

            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
            setSizeRecommendationMsg(finalMsg);
            localStorage.setItem("pantSizeRecommendationMsg", finalMsg);

            const isAllSelected = waist && outseam && hip;

            // Show message only if all three are selected
            if (isAllSelected) {
              let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
              const parts = [];
              if (waistWarning) parts.push(waistWarning);

              if (isWaistOut)
                parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
              if (isOutseamOut)
                parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
              if (isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);
              const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
              setSizeRecommendationMsg(finalMsg);
              localStorage.setItem("pantSizeRecommendationMsg", finalMsg);
            } else {
              let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;

              // If only one or two fields selected, show message only for those
              const parts = [];
              if (waistWarning) parts.push(waistWarning);
              if (waist && isWaistOut)
                parts.push(` Recommended Waist: ${waistMin}-${waistMax}`);
              if (outseam && isOutseamOut)
                parts.push(` Recommended Outseam:${outseamMin}-${outseamMax}`);
              if (
                hip &&
                isHipOut &&
                hipMin != null &&
                hipMax != null &&
                hipMin !== undefined &&
                hipMax !== undefined
              )
                parts.push(` Recommended Hip: ${hipMin}-${hipMax}`);
              const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
              setSizeRecommendationMsg(finalMsg);
              localStorage.setItem("pantSizeRecommendationMsg", finalMsg);
            }
          }
        }
      } else {
        setSizeRecommendationMsg("");
      }
    }
  };

  const checkShirtSizeRanges = (
    selectedValue,
    fieldType,
    customRange = null,
  ) => {
    setShirtSizeRecommendationMsg(""); // Clear any existing message

    // Only enforce this rule when NOT picking neck or sleeve
    if (fieldType !== "Shirt" && !LebelShirt?.style) {
    } else if (!LebelShirt?.style && !LebelShirtsize) {
      localStorage.removeItem("shirtSizeRecommendationMsg");
      return;
    }

    const neckRaw = watch("ShirtSize");
    const sleeveRaw = watch("Sleeve");
    const neckValue = neckRaw ? Number(neckRaw.split("/")[0]) : null;
    const sleeveValue = sleeveRaw ? Number(sleeveRaw) : null;
    const weight = watch("Weight");
    const currentHeight =
      selectedHeight ||
      (() => {
        const heightValue = watch("Height");
        if (heightValue) {
          if (typeof heightValue === "string" && heightValue.includes("'")) {
            return convertHeightToInches(heightValue);
          }
          return parseInt(heightValue, 10);
        }
        return null;
      })();

    // Convert height to feet & inches format
    const feet = Math.floor(selectedHeight / 12);
    const inches = selectedHeight % 12;
    const formattedHeight = `${feet}'${inches}"`;

    const isNeckProvided = neckValue !== null && neckRaw !== "";
    const isSleeveProvided = sleeveValue !== null && sleeveRaw !== "";

    const isWeightValid =
      weight !== null &&
      weight !== undefined &&
      !isNaN(weight) &&
      weight !== "";

    // Check if sizes array has data
    if (!sizes || sizes.length === 0) {
      // Try to call API or reload sizes data here if needed
      return;
    }
    const validSizeCharts = sizes
      .flatMap((category) => category.size_charts)
      .filter(
        (size) =>
          size.minHeight !== null &&
          size.maxHeight !== null &&
          selectedHeight >= size.minHeight &&
          selectedHeight <= size.maxHeight,
      );

    let isWeightInRange = false;
    if (isWeightValid) {
      isWeightInRange = validSizeCharts.some(
        (chart) =>
          (!chart.minWeight || Number(weight) >= chart.minWeight) &&
          (!chart.maxWeight || Number(weight) <= chart.maxWeight),
      );
    }

    const isHeightAndWeightValid =
      selectedHeight && isWeightValid && isWeightInRange;

    if (coatid && sizesCategory[0]) {
      const activeRange = customRange || recommendedRange;
      const neckMin = sizesCategory[0]?.minNeck;
      const neckMax = sizesCategory[0]?.maxNeck;
      const sleeveMin =
        activeRange?.sleeveMin ?? Number(sizesCategory[0]?.minShirtSleeve);
      const sleeveMax =
        activeRange?.sleeveMax ?? Number(sizesCategory[0]?.maxShirtSleeve);

      const isNeckOutOfRange =
        isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
      const isSleeveOutOfRange =
        isSleeveProvided &&
        (sleeveValue + 1 < sleeveMin || sleeveValue > sleeveMax);

      let categoryInitial = categoryName?.charAt(0) || "";
      if (categoryName?.includes("E")) {
        categoryInitial = "X";
      }
      const coatSize = coatid;

      let msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatSize}${categoryInitial}: `;
      const parts = [];

      if (isNeckProvided && isNeckOutOfRange) {
        parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
      }

      if (
        isSleeveProvided &&
        isSleeveOutOfRange &&
        sleeveMin !== null &&
        sleeveMin !== undefined &&
        sleeveMax !== null &&
        sleeveMax !== undefined
      ) {
        parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
      }

      const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
      setShirtSizeRecommendationMsg(finalMsg);
      localStorage.setItem("shirtSizeRecommendationMsg", finalMsg);
    } else if (isHeightAndWeightValid) {
      let foundChart = null;
      for (const category of sizes || []) {
        if (category.size_charts && category.size_charts.length > 0) {
          foundChart = category.size_charts[0];
          break;
        }
      }

      if (foundChart) {
        const neckMin = foundChart?.minNeck;
        const neckMax = foundChart?.maxNeck;
        const sleeveMin = foundChart?.minShirtSleeve;
        const sleeveMax = foundChart?.maxShirtSleeve;

        const isNeckOutOfRange =
          isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
        const isSleeveOutOfRange =
          isSleeveProvided &&
          (sleeveValue < sleeveMin || sleeveValue > sleeveMax);

        let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
        const parts = [];

        if (isNeckProvided && isNeckOutOfRange) {
          parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
        }

        if (isSleeveProvided && isSleeveOutOfRange) {
          parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
        }

        const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";

        setShirtSizeRecommendationMsg(finalMsg);
        localStorage.setItem("shirtSizeRecommendationMsg", finalMsg);
      }
    } else {
      setShirtSizeRecommendationMsg("");
      localStorage.removeItem("shirtSizeRecommendationMsg");
    }
  };

  const checkVestSizeRanges = (
    selectedValue,
    fieldType,
    customRange = null,
  ) => {
    const activeRange = customRange || recommendedRange;
    // Clear any existing message
    if (!selectedValue?.value) return;

    const weight = watch("Weight");
    // Convert height to feet & inches format
    const feet = Math.floor(selectedHeight / 12);
    const inches = selectedHeight % 12;
    const formattedHeight = `${feet}'${inches}"`;
    // Case 1: If coat ID exists, use standard chart logic
    // if (coatid && sizesCategory[0]) {
    //     // Validate selected value
    //     if (!selectedValue || selectedValue.value === undefined) return;

    //     const selectedVestSize = String(selectedValue.value);
    //     const recommendedVest = String(sizesCategory[0]?.vestSize || "").trim();
    //     let categoryInitial = categoryName?.charAt(0) || "";
    //     if (categoryName?.includes("E")) {
    //         categoryInitial = "X";
    //     }
    //     const isVestOutOfRange = selectedVestSize !== recommendedVest;

    //     if (isVestOutOfRange) {

    //         const msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatid}${categoryInitial}: Recommended Vest ${recommendedVest}.`;
    //         setVestRecommendationMsg(msg);
    //         localStorage.setItem('vestRecommendationMsg', msg);
    //     }

    //     return; // Exit here so it doesn't run height-weight logic
    // }
    // Case 1: If coat ID exists, use coatSize + category chart first

    const selectedVestSize = String(selectedValue.value).trim();
    if (coatid && activeRange?.vestSize) {
      // if (!selectedValue?.value) return;

      // const selectedVestSize = String(selectedValue.value).trim();
      const recommendedVest = String(activeRange.vestSize).trim();

      const categoryInitial = categoryName?.includes("E")
        ? "X"
        : categoryName?.charAt(0) || "";

      if (selectedVestSize !== recommendedVest) {
        const msg = `<span style="font-size: 24px;">⚠️</span> 
                For Coat Size ${coatid}${categoryInitial}: Recommended Vest ${recommendedVest}.`;
        setVestRecommendationMsg(msg); // ✅ show only if wrong
      } else {
        setVestRecommendationMsg(""); // ✅ clear only if correct
      }
      return;
    }

    // Case 2: No coat size, but height and valid weight present
    if (!coatid && selectedHeight && weight) {
      const isWeightValid =
        weight !== null &&
        weight !== undefined &&
        !isNaN(weight) &&
        weight !== "";

      const validSizeCharts = sizes
        .flatMap((category) => category.size_charts)
        .filter(
          (size) =>
            size.minHeight !== null &&
            size.maxHeight !== null &&
            selectedHeight >= size.minHeight &&
            selectedHeight <= size.maxHeight,
        );

      let isWeightInRange = false;
      if (isWeightValid) {
        isWeightInRange = validSizeCharts.some(
          (chart) =>
            (!chart.minWeight || Number(weight) >= chart.minWeight) &&
            (!chart.maxWeight || Number(weight) <= chart.maxWeight),
        );
      }

      if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
        let foundChart = null;

        for (const category of sizes || []) {
          if (category.size_charts && category.size_charts.length > 0) {
            foundChart = category.size_charts[0];
            break;
          }
        }

        if (foundChart) {
          const recommendedVest = String(foundChart?.vestSize || "").trim();

          if (
            selectedValue?.value &&
            String(selectedValue.value) !== recommendedVest
          ) {
            const msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): Recommended Vest ${recommendedVest}.`;
            setVestRecommendationMsg(msg);
            localStorage.setItem("vestRecommendationMsg", msg);
          } else {
            setVestRecommendationMsg(""); // ✅ clear only if correct
          }
        }
      }
    }
  };

  // Add this function to your component
  const openAccordionWithErrors = (
    errors,
    hasCategoryValidationMessage = false,
  ) => {
    // Check which accordion tabs have errors
    const errorFields = Object.keys(errors);

    // Check if Coat section has errors
    const coatErrors =
      ["Coat", "CoatSize", "Insleeve"].some((field) =>
        errorFields.includes(field),
      ) || hasCategoryValidationMessage;

    const pantErrors = ["Pant", "Waist", "hip", "outseam"].some((field) =>
      errorFields.includes(field),
    );

    const shirtErrors =
      ["Shirt", "ShirtSize"].some((field) => errorFields.includes(field)) ||
      (showSleeve && errorFields.includes("Sleeve"));

    const vestErrors = ["Vest", "VestColor"].some((field) =>
      errorFields.includes(field),
    );
    const tieErrors = ["Tie", "Pocket", "Jewelry"].some((field) =>
      errorFields.includes(field),
    );
    const shoesErrors = ["Shoes", "ShoesSize"].some((field) =>
      errorFields.includes(field),
    );

    if (coatErrors) {
      setActiveItem(1); // Use the ID that corresponds to your coat accordion
    } else if (pantErrors) {
      setActiveItem(2); // Use the ID that corresponds to your pant accordion
    } else if (shirtErrors) {
      setActiveItem(3); // Use the ID that corresponds to your shirt accordion
    } else if (vestErrors) {
      setActiveItem(4); // Use the ID that corresponds to your vest accordion
    } else if (tieErrors) {
      setActiveItem(5); // Use the ID that corresponds to your tie accordion
    } else if (shoesErrors) {
      setActiveItem(6); // Use the ID that corresponds to your shoes accordion
    }
  };

  // Modify your onNext function to include this check
  const handleNext = (data) => {
    if (Object.keys(formState.errors).length > 0 || categoryValidationMessage) {
      openAccordionWithErrors(formState.errors, !!categoryValidationMessage);
      return; // Prevent calling the parent onNext
    }
    onNext(data);
  };

  const pantStyle = watch("Pant");
  const currentBeltValue = watch("belt");
  const [hasUserSelected, setHasUserSelected] = useState(false);
  const [hasInitialLoadCompleted, setHasInitialLoadCompleted] = useState(false);

  // Get allowed pant styles
  const allowedPantStyles = sortedPants
    .filter((data) => data?.style && data?.belt !== null)
    .map((data) => data.style.toString());

  // Check if we should show belt
  const shouldShowBelt =
    pantStyle && allowedPantStyles.includes(pantStyle.toString());

  // Create belt color map
  const beltColorMap = {};
  sortedPants.forEach((data) => {
    if (data?.style && data?.belt !== null) {
      beltColorMap[data.style] = data.belt;
    }
  });

  // Available colors and default mapping
  const availableColors = ["Black", "Brown", "Cognac", "White"];
  const mappedDefaultColor = beltColorMap[pantStyle] || availableColors[0];
  dispatch(setMappedDefaultColor(mappedDefaultColor));

  // Handle initial load and default logic
  useEffect(() => {
    if (!shouldShowBelt) return;

    // On first load only
    if (!hasInitialLoadCompleted) {
      // Priority 1: Use initial value if exists
      if (initialValues?.belt) {
        setValue("belt", initialValues.belt, { shouldValidate: true });
        setHasUserSelected(true);
      }
      // Priority 2: Use mapped default color
      else if (mappedDefaultColor && !currentBeltValue) {
        setValue("belt", mappedDefaultColor, { shouldValidate: true });
      }
      setHasInitialLoadCompleted(true);
      return;
    }

    // After initial load, handle pant changes
    if (
      !hasUserSelected &&
      mappedDefaultColor &&
      (!currentBeltValue || currentBeltValue !== mappedDefaultColor)
    ) {
      setValue("belt", mappedDefaultColor, { shouldValidate: true });
    }
  }, [
    shouldShowBelt,
    pantStyle,
    initialValues,
    hasInitialLoadCompleted,
    hasUserSelected,
    currentBeltValue,
    setValue,
    mappedDefaultColor,
  ]);

  // Reset user selection when pant changes
  useEffect(() => {
    setHasUserSelected(false);
  }, [pantStyle]);

  // Clear belt if pant style doesn't allow belts
  useEffect(() => {
    if (
      pantStyle &&
      !allowedPantStyles.includes(pantStyle.toString()) &&
      currentBeltValue
    ) {
      setValue("belt", "", { shouldValidate: true });
    }
  }, [pantStyle, allowedPantStyles, currentBeltValue, setValue]);

  return (
    <>
      <Container>
        <div class="nk-content ">
          <div class="container-fluid">
            <div class="nk-content-inner">
              <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                  <div class="nk-block-between">
                    <div class="nk-block-head-content">
                      <h3 class="nk-block-title page-title">
                        {location.pathname == "/add-order" ? "Add" : "Update"}{" "}
                        {profile?.name === "Admin" &&
                          (location.pathname === "/add-order"
                            ? addaccount && `#${addaccount.substring(0, 2)}`
                            : account &&
                            `#${account?.substring(0, 2) || ""}`)}{" "}
                        Order{" "}
                        {ticket &&
                          location.pathname != "/add-order" &&
                          `#${ticket}`}
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="card card-full">
                  <div class="card-inner">
                    <div class="stepperLeft">
                      <div className="row">
                        <Progessbar />

                        <div className="col-md-8">
                          <div className="row">
                            <div className="d-flex align-items-center justify-content-between w-100 ">
                              <h4>
                                {location.pathname == "/add-order"
                                  ? "Add"
                                  : "Update"}{" "}
                                Styles and Measurements{" "}
                                {location.pathname !== "/add-order" &&
                                  initialValues?.Firstname && (
                                    <>
                                      {" "}
                                      - {initialValues.Firstname}{" "}
                                      {initialValues.Lastname}
                                    </>
                                  )}
                              </h4>
                            </div>
                          </div>
                          <form onSubmit={handleSubmit(handleNext)}>
                            <div className="inputCardBox mt-4">
                              <div className="row">
                                <div className="col-6 col-md-6 mb-3 stateSelect">
                                  <label>
                                    Height{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Controller
                                    name="Height"
                                    control={control}
                                    rules={{ required: "Height is required" }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={getHeightOptions()}
                                        placeholder="Select height"
                                        isClearable
                                        onChange={(selectedOption) => {
                                          if (!selectedOption) {
                                            field.onChange("");
                                            setSelectedHeight("");
                                            setSelectedCoatSize("");
                                            setValue("Weight", "");
                                            setValue("coatsize_chart_id", "");
                                            setValue("CoatSize", "");
                                            setValue("Insleeve", "");
                                            setValue("Waist", "");
                                            setValue("hip", "");
                                            setValue("outseam", "");
                                            setValue("ShirtSize", "");
                                            setValue("VestColor", "");
                                            setValue("Sleeve", "");
                                            setMatchedItems([]);
                                            setCategoryName("");
                                            setSizeRecommendationMsg("");
                                            setShirtSizeRecommendationMsg("");
                                            setVestRecommendationMsg("");

                                            // Also clear localStorage
                                            localStorage.removeItem(
                                              "pantSizeRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "shirtSizeRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "vestRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "selectedCoatSize",
                                            );
                                            localStorage.removeItem("coatid");
                                            localStorage.removeItem(
                                              "selectedCategoryName",
                                            );
                                          } else {
                                            field.onChange(
                                              selectedOption.value,
                                            );
                                            setSelectedHeight(
                                              selectedOption.value,
                                            );
                                            const heightVal =
                                              selectedOption.value;
                                            let heightInInches;
                                            if (
                                              typeof heightVal === "string" &&
                                              heightVal.includes("'")
                                            ) {
                                              heightInInches =
                                                convertHeightToInches(
                                                  heightVal,
                                                );
                                            } else {
                                              heightInInches = parseInt(
                                                heightVal,
                                                10,
                                              );
                                            }

                                            if (heightInInches < 61) {
                                              // Less than 5'1"
                                              setOrderForState("Boys");
                                              setValue("order_for", "Boys");
                                            } else {
                                              setOrderForState("Men");
                                              setValue("order_for", "Men");
                                            }
                                            setSelectedCoatSize("");
                                            setValue("Weight", "");
                                            setValue("coatsize_chart_id", "");
                                            setValue("CoatSize", "");
                                            setValue("Insleeve", "");
                                            setValue("Waist", "");
                                            setValue("hip", "");
                                            setValue("outseam", "");
                                            setValue("ShirtSize", "");
                                            setValue("VestColor", "");
                                            setValue("Sleeve", "");
                                            setMatchedItems([]);
                                            setCategoryName("");
                                            setSizeRecommendationMsg("");
                                            setShirtSizeRecommendationMsg("");
                                            setVestRecommendationMsg("");

                                            // Clear localStorage
                                            localStorage.removeItem(
                                              "pantSizeRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "shirtSizeRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "vestRecommendationMsg",
                                            );
                                            localStorage.removeItem(
                                              "selectedCoatSize",
                                            );
                                            localStorage.removeItem("coatid");
                                            localStorage.removeItem(
                                              "selectedCategoryName",
                                            );
                                          }
                                        }}
                                        value={
                                          getHeightOptions().find(
                                            (option) =>
                                              option.value === field.value,
                                          ) || null
                                        }
                                        isOptionDisabled={(option) =>
                                          option.isDisabled
                                        }
                                      />
                                    )}
                                  />
                                  {errors.Height && (
                                    <p className="red">
                                      {errors.Height.message}
                                    </p>
                                  )}
                                </div>
                                <div className="col-6 col-md-6 mb-3">
                                  <label>
                                    Weight <small>( 2 or 3 Digits Only )</small>
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    class=""
                                    type="text"
                                    placeholder="Enter weight"
                                    {...register("Weight", {
                                      required: "Weight is required",
                                      pattern: {
                                        value:
                                          /^[1-9]$|^[1-9][0-9]$|^[1-9][0-9]{2}$/, // This regex ensures 1, 2, or 3 digits (from 1 to 999)
                                        message:
                                          "Weight must be a maximum of 3 digits",
                                      },
                                      onChange: () => { },
                                    })}
                                  />
                                  {errors.Weight && (
                                    <p className="red">
                                      {errors.Weight.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-6 col-md-6 mb-3">
                                  <label>
                                    Chest <small>( 2 Digits Only )</small>{" "}
                                    <span className="text-red-500"></span>
                                  </label>
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder="Enter chest"
                                    maxLength={2}
                                    onKeyPress={(e) => {
                                      // Allow only numeric keys, backspace, delete, tab, enter
                                      if (
                                        !/[0-9]/.test(e.key) &&
                                        ![
                                          "Backspace",
                                          "Delete",
                                          "Tab",
                                          "Enter",
                                        ].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (/^\d{0,2}$/.test(val)) {
                                        setValue("Chest", val); // from react-hook-form
                                      }
                                    }}
                                    value={watch("Chest")}
                                    {...register("Chest", {
                                      required: false,
                                      validate: (value) => {
                                        if (value) {
                                          if (!/^\d{1,2}$/.test(value)) {
                                            return "Chest must be 1-2 digits (1-99)";
                                          }
                                          const num = parseInt(value, 10);
                                          if (num < 1 || num > 99) {
                                            return "Chest must be between 1-99";
                                          }
                                        }
                                        return true;
                                      },
                                    })}
                                  />
                                  {errors.Chest && (
                                    <p className="red">
                                      {errors.Chest.message}
                                    </p>
                                  )}
                                </div>

                                <div className="col-6 col-md-6 mb-3">
                                  <label>
                                    Overarm <small>( 2 Digits Only) </small>{" "}
                                    <span className="text-red-500"></span>
                                  </label>
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder="Enter overarm"
                                    maxLength={2}
                                    onKeyPress={(e) => {
                                      // Allow only numeric keys, backspace, delete, tab, enter
                                      if (
                                        !/[0-9]/.test(e.key) &&
                                        ![
                                          "Backspace",
                                          "Delete",
                                          "Tab",
                                          "Enter",
                                        ].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (/^\d{0,2}$/.test(val)) {
                                        setValue("Overarm", val);
                                      }
                                    }}
                                    value={watch("Overarm")}
                                    {...register("Overarm", {
                                      required: false,
                                      validate: (value) => {
                                        if (value && !/^\d{2}$/.test(value)) {
                                          return "Overarm must be a 2-Digits number";
                                        }
                                        const num = parseInt(value, 10);
                                        if (num < 1 || num > 99) {
                                          return "Chest must be between 1-99";
                                        }
                                        return true;
                                      },
                                    })}
                                  />
                                  {errors.Overarm && (
                                    <p className="red">
                                      {errors.Overarm.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="newAccordion">
                                  <div className={"accordionContainer"}>
                                    <AccordionItem
                                      id={1}
                                      open={activeItem === 1}
                                      title={
                                        LebelCoat?.style ? (
                                          <span className="fw-400">
                                            <strong className="fw-700">
                                              Coat Style
                                            </strong>{" "}
                                            ({LebelCoat?.style}{" "}
                                            {LebelCoat?.description} -
                                            <span>
                                              <strong className="fw-700">
                                                {LebelCoatsize
                                                  ? LebelCoatsize
                                                  : "N/A"}
                                                {LabelcategoryName === "Short"
                                                  ? "S"
                                                  : LabelcategoryName ===
                                                    "Regular"
                                                    ? "R"
                                                    : LabelcategoryName ===
                                                      "Long"
                                                      ? "L"
                                                      : LabelcategoryName ===
                                                        "Extra Long"
                                                        ? "X"
                                                        : LabelcategoryName ===
                                                          "Boys"
                                                          ? "B"
                                                          : LabelcategoryName}
                                                )
                                              </strong>
                                            </span>
                                          </span>
                                        ) : (
                                          <span>
                                            <strong className="fw-700">
                                              Coat Style
                                            </strong>
                                          </span>
                                        )
                                      }
                                    >
                                      <div className="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-8 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Coat Style
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Coat"
                                                  control={control}
                                                  render={({ field }) => {
                                                    const selectedOption =
                                                      options.find(
                                                        (option) =>
                                                          option.value ===
                                                          field.value,
                                                      );

                                                    const isValueNotInOptions =
                                                      field.value &&
                                                      !selectedOption;

                                                    // Try to get description from localStorage or category1Data
                                                    let displayLabel =
                                                      field.value;

                                                    if (isValueNotInOptions) {
                                                      // First, try to find in category1Data (in case it still exists)
                                                      const originalItem =
                                                        category1Data?.find(
                                                          (item) =>
                                                            item.style ===
                                                            field.value,
                                                        );

                                                      if (originalItem) {
                                                        displayLabel = `${originalItem.style} ${originalItem.description}`;
                                                      } else {
                                                        // Try to get from localStorage if previously saved
                                                        const savedCoatStyle =
                                                          localStorage.getItem(
                                                            "coatStyle",
                                                          );
                                                        if (savedCoatStyle) {
                                                          const parsedStyle =
                                                            JSON.parse(
                                                              savedCoatStyle,
                                                            );
                                                          if (
                                                            parsedStyle.style ===
                                                            field.value
                                                          ) {
                                                            displayLabel = `${parsedStyle.style} ${parsedStyle.description || ""}`;
                                                          }
                                                        }
                                                      }
                                                    }

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={options}
                                                        placeholder="Select"
                                                        components={
                                                          customComponents
                                                        }
                                                        isClearable={
                                                          !isValueNotInOptions
                                                        } // prevent clear
                                                        isDisabled={
                                                          isValueNotInOptions
                                                        } // disable dropdown
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          field.onChange(
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "",
                                                          );
                                                          handleCoatChange(
                                                            selectedOption,
                                                          );
                                                        }}
                                                        value={
                                                          selectedOption ||
                                                          (isValueNotInOptions
                                                            ? {
                                                              label:
                                                                displayLabel,
                                                              value:
                                                                field.value,
                                                            }
                                                            : null)
                                                        }
                                                      />
                                                    );
                                                  }}
                                                />

                                                {errors.Coat && (
                                                  <p className="red">
                                                    {errors.Coat.message}
                                                  </p>
                                                )}
                                              </div>
                                              <div className="col-md-6 mb-3">
                                                <h6 className="mb-0 mt-1">
                                                  {Coatstyle?.style
                                                    ? `#${Coatstyle.style} `
                                                    : ""}
                                                </h6>
                                                <p className="coatTxtPra">
                                                  <small>
                                                    {Coatstyle?.description}
                                                  </small>
                                                </p>
                                              </div>

                                              <div>
                                                <a
                                                  href=""
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#alterationsCoatModal"
                                                ></a>
                                              </div>
                                              <div className="col-12 col-md-6 mb-3">
                                                <label>
                                                  Coat Size
                                                  <span className="text-red-500">
                                                    *
                                                  </span>
                                                </label>
                                                <Controller
                                                  name="CoatSize"
                                                  control={control}
                                                  rules={{
                                                    validate: (value) => {
                                                      if (
                                                        Object.keys(
                                                          coatSizeValidation,
                                                        ).length === 0
                                                      ) {
                                                        return true;
                                                      }
                                                      if (
                                                        coatSizeValidation.required &&
                                                        (value === null ||
                                                          value === undefined ||
                                                          value === "")
                                                      ) {
                                                        return coatSizeValidation.required;
                                                      }
                                                      if (
                                                        value &&
                                                        !categoryName
                                                      ) {
                                                        return "Please select a category before continuing.";
                                                      }
                                                      // Custom validation for category message
                                                      if (
                                                        value &&
                                                        categoryValidationMessage
                                                      ) {
                                                        return categoryValidationMessage; // Show custom error message
                                                      }

                                                      return true; // Validation pass
                                                    },
                                                  }}
                                                  render={({ field }) => {
                                                    // Get all unique coat sizes from the sizes array
                                                    let uniqueCoatSizes = sizes
                                                      .filter(
                                                        (category) =>
                                                          category.size_charts
                                                            .length > 0,
                                                      )
                                                      .flatMap(
                                                        (category) =>
                                                          category.size_charts.map(
                                                            (size) =>
                                                              size.coatSize,
                                                          ) || [],
                                                      );

                                                    console.log(
                                                      "EDIT MODE sizes:",
                                                      sizes,
                                                      "uniqueCoatSizes:",
                                                      uniqueCoatSizes,
                                                    );

                                                    if (ForEvenCoat === true) {
                                                      uniqueCoatSizes =
                                                        uniqueCoatSizes.map(
                                                          (size) => {
                                                            let numericSize =
                                                              Number(size); // convert only for math

                                                            if (
                                                              numericSize %
                                                              2 !==
                                                              0
                                                            ) {
                                                              numericSize =
                                                                numericSize + 1;
                                                            }

                                                            return numericSize.toString(); // back to string
                                                          },
                                                        );

                                                      uniqueCoatSizes = [
                                                        ...new Set(
                                                          uniqueCoatSizes,
                                                        ),
                                                      ];
                                                    }

                                                    // Filter only categories that have size charts
                                                    const filteredCategories =
                                                      sizes.filter(
                                                        (category) =>
                                                          category.size_charts
                                                            .length > 0,
                                                      );
                                                    const availableCoatSizes =
                                                      !selectedHeight
                                                        ? []
                                                        : (
                                                          AllSize?.coatSizes ||
                                                          []
                                                        ).map((size) => ({
                                                          value: size,
                                                          label:
                                                            size.toString(),
                                                        }));

                                                    const heightInInches =
                                                      typeof selectedHeight ===
                                                        "string" &&
                                                        selectedHeight.includes(
                                                          "'",
                                                        )
                                                        ? convertHeightToInches(
                                                          selectedHeight,
                                                        )
                                                        : selectedHeight;
                                                    let api =
                                                      heightInInches < 60;
                                                    // Get the maximum bold value
                                                    const maxBoldValue =
                                                      Math.max(
                                                        ...uniqueCoatSizes,
                                                      );

                                                    // First filter values based on ForEvenCoat
                                                    let filteredCoatSizes = [
                                                      ...availableCoatSizes,
                                                    ];

                                                    if (ForEvenCoat) {
                                                      if (heightInInches < 60) {
                                                        const evenSizes =
                                                          filteredCoatSizes.filter(
                                                            (item) =>
                                                              item.value % 2 ===
                                                              0,
                                                          );

                                                        const oddSizeThree =
                                                          filteredCoatSizes.filter(
                                                            (item) =>
                                                              String(
                                                                item.value,
                                                              ) === "3",
                                                          );

                                                        filteredCoatSizes = [
                                                          ...evenSizes,
                                                          ...oddSizeThree,
                                                        ];
                                                      } else {
                                                        filteredCoatSizes =
                                                          filteredCoatSizes.filter(
                                                            (item) =>
                                                              item.value % 2 ===
                                                              0,
                                                          );
                                                      }
                                                    }

                                                    const sortedOptions =
                                                      filteredCoatSizes.sort(
                                                        (a, b) => {
                                                          const aIsBold =
                                                            uniqueCoatSizes.includes(
                                                              a.value,
                                                            ) || a.value === 3;
                                                          const bIsBold =
                                                            uniqueCoatSizes.includes(
                                                              b.value,
                                                            ) || b.value === 3;

                                                          if (
                                                            aIsBold !== bIsBold
                                                          ) {
                                                            return aIsBold
                                                              ? -1
                                                              : 1;
                                                          }

                                                          const aIsAfterMaxBold =
                                                            a.value >
                                                            maxBoldValue;
                                                          const bIsAfterMaxBold =
                                                            b.value >
                                                            maxBoldValue;

                                                          if (
                                                            aIsAfterMaxBold !==
                                                            bIsAfterMaxBold
                                                          ) {
                                                            return aIsAfterMaxBold
                                                              ? -1
                                                              : 1;
                                                          }

                                                          return (
                                                            a.value - b.value
                                                          );
                                                        },
                                                      );

                                                    const isStyleDisabled =
                                                      Coatstyle?.style &&
                                                      !options.some(
                                                        (opt) =>
                                                          opt.value ===
                                                          Coatstyle.style,
                                                      );

                                                    console.log(
                                                      sortedOptions,
                                                      "sortedOptions///////////////////////",
                                                    );
                                                    return (
                                                      <>
                                                        <Select
                                                          {...field}
                                                          options={
                                                            sortedOptions
                                                          }
                                                          placeholder="Select coat size"
                                                          isClearable={
                                                            !isStyleDisabled
                                                          }
                                                          isDisabled={
                                                            isStyleDisabled
                                                          }
                                                          value={
                                                            sortedOptions.find(
                                                              (option) =>
                                                                option.value ===
                                                                selectedCoatSize,
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption,
                                                          ) => {
                                                            if (
                                                              !selectedOption
                                                            ) {
                                                              field.onChange(
                                                                null,
                                                              );
                                                              setValue(
                                                                "coatsize_chart_id",
                                                                null,
                                                              );
                                                              // setcoat(null);
                                                              setMatchedItems(
                                                                [],
                                                              );
                                                              setCategoryName(
                                                                "",
                                                              );
                                                              // setTempCoatSize(null);
                                                              setNonBoldMessage(
                                                                "",
                                                              );
                                                              localStorage.removeItem(
                                                                "selectedCategoryName",
                                                              ); // Make sure to remove category name when coat is cleared
                                                              localStorage.removeItem(
                                                                "coatid",
                                                              );
                                                              setSelectedCoatSize(
                                                                null,
                                                              );
                                                              setSizeRecommendationMsg(
                                                                "",
                                                              );
                                                              setShirtSizeRecommendationMsg(
                                                                "",
                                                              );
                                                              setVestRecommendationMsg(
                                                                "",
                                                              );
                                                              setCoatid(null);
                                                              setRecommendationMessage(
                                                                "",
                                                              );
                                                              localStorage.removeItem(
                                                                "selectedCoatSize",
                                                              );
                                                              localStorage.removeItem(
                                                                "recommendationMessage",
                                                              ); // Add this line to remove from localStorage
                                                              localStorage.removeItem(
                                                                "nonBoldMessage",
                                                              ); // Add this line to remove from localStorage
                                                              localStorage.removeItem(
                                                                "selectedCategoryName",
                                                              );

                                                              if (
                                                                selectedHeight &&
                                                                weight
                                                              ) {
                                                                setWaistSizes(
                                                                  [],
                                                                );
                                                                setHipSizes([]);
                                                                setoutseamSizes(
                                                                  [],
                                                                );
                                                              }
                                                              field.onChange(
                                                                null,
                                                              );
                                                              setCategoryValidationMessage(
                                                                "",
                                                              ); // Clear validation message when coat size is cleared
                                                              return;
                                                            }

                                                            setSelectedCoatSize(
                                                              selectedOption.value,
                                                            );
                                                            const selectedSize =
                                                              selectedOption.value;
                                                            const isBold =
                                                              uniqueCoatSizes.includes(
                                                                selectedSize,
                                                              );

                                                            setValue(
                                                              "coatsize_chart_id",
                                                              selectedOption.value,
                                                            );
                                                            // setcoat(selectedOption.value);
                                                            setCoatid(
                                                              selectedOption.value,
                                                            );
                                                            setStoprender(true);

                                                            if (categoryName) {
                                                              validateSizeWithCategory(
                                                                selectedOption.value,
                                                                categoryName,
                                                                categorySizes,
                                                                selectedStyle,
                                                              );
                                                            }
                                                            let recommendationMessage =
                                                              "";
                                                            if (
                                                              selectedHeight
                                                            ) {
                                                              const feet =
                                                                Math.floor(
                                                                  selectedHeight /
                                                                  12,
                                                                );
                                                              const inches =
                                                                selectedHeight %
                                                                12;
                                                              const formattedHeight = `${feet}'${inches}''`;
                                                              const sortedBoldSizes =
                                                                [
                                                                  ...uniqueCoatSizes,
                                                                ].sort(
                                                                  (a, b) =>
                                                                    a - b,
                                                                );
                                                              const firstBoldSize =
                                                                sortedBoldSizes[0];
                                                              const lastBoldSize =
                                                                sortedBoldSizes[
                                                                sortedBoldSizes.length -
                                                                1
                                                                ];

                                                              const selectedSizeChart =
                                                                sizes
                                                                  .flatMap(
                                                                    (
                                                                      category,
                                                                    ) =>
                                                                      category.size_charts,
                                                                  )
                                                                  .find(
                                                                    (size) =>
                                                                      size.coatSize ===
                                                                      selectedCoatSize,
                                                                  );
                                                              const minWeight =
                                                                selectedSizeChart?.minWeight ||
                                                                null;
                                                              const maxWeight =
                                                                selectedSizeChart?.maxWeight ||
                                                                null;
                                                            }

                                                            if (!isBold) {
                                                              setNonBoldMessage(
                                                                recommendationMessage,
                                                              );
                                                            } else {
                                                              if (
                                                                !recommendationMessage
                                                              ) {
                                                                setNonBoldMessage(
                                                                  "",
                                                                );
                                                              }
                                                            }

                                                            localStorage.setItem(
                                                              "selectedCoatSize",
                                                              selectedSize,
                                                            );
                                                            localStorage.setItem(
                                                              "selectedCategoryName",
                                                              categoryName,
                                                            );
                                                            field.onChange(
                                                              selectedOption.value,
                                                            );
                                                            if (
                                                              selectedStyle &&
                                                              availableSizesForStyle.length >
                                                              0
                                                            ) {
                                                              const coatSizeNum =
                                                                Number(
                                                                  selectedOption.value,
                                                                );

                                                              if (
                                                                !availableSizesForStyle.includes(
                                                                  coatSizeNum,
                                                                )
                                                              ) {
                                                                const categoryInitial =
                                                                  categoryName
                                                                    ? categoryName
                                                                      .charAt(
                                                                        0,
                                                                      )
                                                                      .toUpperCase() ===
                                                                      "E"
                                                                      ? "X"
                                                                      : categoryName.charAt(
                                                                        0,
                                                                      )
                                                                    : "";

                                                                const selectedStyleObj =
                                                                  coatStyles.find(
                                                                    (style) =>
                                                                      style.inventory_id ==
                                                                      selectedStyle,
                                                                  );
                                                                const styleLabel =
                                                                  selectedStyleObj?.label ||
                                                                  selectedStyle;

                                                                // setStyleValidationMessage(`Selected Coat Style ${styleLabel} doesn't have coat size ${selectedOption.value}${categoryInitial}.`);
                                                              } else {
                                                                // setStyleValidationMessage('');
                                                              }
                                                            }
                                                          }}
                                                          formatOptionLabel={(
                                                            option,
                                                            { context },
                                                          ) => (
                                                            <div
                                                              style={
                                                                uniqueCoatSizes.includes(
                                                                  option.value,
                                                                )
                                                                  ? {
                                                                    fontWeight:
                                                                      "bold",
                                                                  }
                                                                  : {}
                                                              }
                                                            >
                                                              {option.label}
                                                            </div>
                                                          )}
                                                        />
                                                        {errors.CoatSize && (
                                                          <span
                                                            style={{
                                                              backgroundColor:
                                                                "red",
                                                              color: "white",
                                                              marginTop: "8px",
                                                            }}
                                                          >
                                                            {
                                                              errors.CoatSize
                                                                .message
                                                            }
                                                          </span>
                                                        )}
                                                        {categoryValidationMessage && (
                                                          <p
                                                            style={{
                                                              backgroundColor:
                                                                "#FF0000",
                                                              color: "#FFFFFF",
                                                              fontSize: "12px",
                                                              whiteSpace:
                                                                "nowrap",
                                                            }}
                                                            className="font-bold mt-2"
                                                          >
                                                            {
                                                              categoryValidationMessage
                                                            }
                                                          </p>
                                                        )}

                                                        {orderForState ===
                                                          "Boys" &&
                                                          field.value && (
                                                            <p className="text-blue-600 font-bold mt-2"></p>
                                                          )}

                                                        <div className="col-md-12">
                                                          <div className="d-flex flex-wrap mt-3">
                                                            {coatid &&
                                                              allSizes.map(
                                                                (
                                                                  category,
                                                                  index,
                                                                ) => {
                                                                  const isMatchedCategory =
                                                                    MatchedItems.some(
                                                                      (
                                                                        matched,
                                                                      ) =>
                                                                        matched.id ===
                                                                        category.id,
                                                                    );
                                                                  const isShortCategory =
                                                                    category
                                                                      .name
                                                                      .length <
                                                                    3;
                                                                  const isCurrentCategory =
                                                                    category.name ===
                                                                    categoryName &&
                                                                    !!categoryName;
                                                                  const hasData =
                                                                    category.size_charts &&
                                                                    category
                                                                      .size_charts
                                                                      .length >
                                                                    0;
                                                                  const isStyleDisabled =
                                                                    Coatstyle?.style &&
                                                                    !options.some(
                                                                      (opt) =>
                                                                        opt.value ===
                                                                        Coatstyle.style,
                                                                    );

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        index
                                                                      }
                                                                      className={`coatSizeCategorySize px-2 py-1 rounded-lg mx-1 
                        ${hasData && coatid ? (isMatchedCategory || isCurrentCategory ? "bg-green-500 selectedBox" : "disableSize text-black") : "bg-gray-300 text-gray-500 cursor-not-allowed"}
                        ${isCurrentCategory ? "bg-blue-600 text-white border-2 border-blue-700 font-bold transform scale-110 z-10" : ""} 
                        ${isShortCategory && !isCurrentCategory ? "border-blue-500 border-2" : ""} 
                        ${isCurrentCategory ? "blueSelected" : ""}
                                                ${isStyleDisabled ? "opacity-50 pointer-events-none" : ""} // <-- disable box if style disabled

                    `}
                                                                      onClick={
                                                                        coatid &&
                                                                          hasData &&
                                                                          isMatchedCategory &&
                                                                          !isStyleDisabled
                                                                          ? () => {
                                                                            setIsUserSelectedCategory(
                                                                              true,
                                                                            );
                                                                            setSizeid(
                                                                              category.id,
                                                                            );
                                                                            setValue(
                                                                              "size_chart_category_id",
                                                                              category?.id,
                                                                            );
                                                                            setCategoryName(
                                                                              category.name,
                                                                            );
                                                                            localStorage.setItem(
                                                                              "selectedCategoryName",
                                                                              category.name,
                                                                            );
                                                                            setStoprender(
                                                                              false,
                                                                            );
                                                                            clearErrors(
                                                                              "CoatSize",
                                                                            );
                                                                            if (
                                                                              selectedCoatSize
                                                                            ) {
                                                                              validateSizeWithCategory(
                                                                                selectedCoatSize,
                                                                                category.name,
                                                                                categorySizes,
                                                                                selectedStyle,
                                                                              );
                                                                            }
                                                                          }
                                                                          : undefined
                                                                      }
                                                                    >
                                                                      {category.name
                                                                        .charAt(
                                                                          0,
                                                                        )
                                                                        .toUpperCase() ===
                                                                        "E"
                                                                        ? "X"
                                                                        : category.name.charAt(
                                                                          0,
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}

                                                            {coatid &&
                                                              categoryName && (
                                                                <p className="text-lg font-bold text-blue-700 mt-3">
                                                                  <strong>
                                                                    Size:
                                                                  </strong>{" "}
                                                                  {categoryName}
                                                                </p>
                                                              )}
                                                          </div>
                                                        </div>
                                                      </>
                                                    );
                                                  }}
                                                />
                                              </div>

                                              <div className="col-12 col-md-6 mb-3">
                                                <label>
                                                  Insleeve
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Insleeve"
                                                  control={control}
                                                  render={({ field }) => {
                                                    const insleeveTimes = [];
                                                    for (
                                                      let time = 8.0;
                                                      time <= 20.5;
                                                      time += 0.5
                                                    ) {
                                                      insleeveTimes.push({
                                                        value: time.toString(),
                                                        label: time.toString(),
                                                      });
                                                    }

                                                    if (
                                                      !insleeveTimes.some(
                                                        (option) =>
                                                          option.value === "14",
                                                      )
                                                    ) {
                                                      insleeveTimes.push({
                                                        value: "14",
                                                        label: "14",
                                                      });
                                                    }
                                                    const isStyleDisabled =
                                                      Coatstyle?.style &&
                                                      !options.some(
                                                        (opt) =>
                                                          opt.value ===
                                                          Coatstyle.style,
                                                      );

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={insleeveTimes}
                                                        placeholder="Select"
                                                        isClearable={
                                                          !isStyleDisabled
                                                        }
                                                        isDisabled={
                                                          isStyleDisabled
                                                        }
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          setIsUserSelectedInsleeve(
                                                            true,
                                                          );
                                                          field.onChange(
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "",
                                                          );

                                                          // Save the user's selection to localStorage
                                                          if (selectedOption) {
                                                            localStorage.setItem(
                                                              "savedInsleeve",
                                                              selectedOption.value,
                                                            );
                                                          } else {
                                                            localStorage.removeItem(
                                                              "savedInsleeve",
                                                            );
                                                            setIsUserSelectedInsleeve(
                                                              false,
                                                            ); // Reset if cleared
                                                          }

                                                          if (!selectedOption) {
                                                            setdefaultsize(
                                                              null,
                                                            );
                                                            return;
                                                          }
                                                          if (
                                                            selectedOption &&
                                                            selectedOption.value !==
                                                            defaultsize
                                                          ) {
                                                            if (
                                                              profile?.insleeve_alteration
                                                            ) {
                                                              document
                                                                .querySelector(
                                                                  '[data-bs-target="#alterationsCoatModal"]',
                                                                )
                                                                ?.click();
                                                            }
                                                          }
                                                        }}
                                                        value={
                                                          field.value
                                                            ? insleeveTimes.find(
                                                              (option) =>
                                                                option.value ===
                                                                field.value,
                                                            )
                                                            : null
                                                        }
                                                      />
                                                    );
                                                  }}
                                                />
                                                {errors.Insleeve && (
                                                  <p className="red">
                                                    {errors.Insleeve.message}
                                                  </p>
                                                )}
                                                {defaultsize && (
                                                  <p className="sleeveTxt">
                                                    <small>
                                                      {profile?.insleeve_alteration
                                                        ? `Sleeve alterations: $6.00/coat, except default size ${defaultsize}.`
                                                        : `Default size ${defaultsize}`}
                                                    </small>
                                                  </p>
                                                )}
                                              </div>

                                              {/* Messages – Accordion ke bahar hi */}
                                              {Coatstyle?.style &&
                                                !options?.some(
                                                  (opt) =>
                                                    opt.value === Coatstyle.style,
                                                ) ? (
                                                <SubRentalWarning />
                                              ) : (
                                                <>
                                                  {selectedCoatSize &&
                                                    nonBoldMessage && (
                                                      <p className="text-red-600 mt-2">
                                                        <span
                                                          className="highlight-message"
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              nonBoldMessage,
                                                          }}
                                                        />
                                                      </p>
                                                    )}

                                                  {selectedCoatSize &&
                                                    recommendationMessage && (
                                                      <p className="text-red-600 mt-2">
                                                        <span
                                                          className="highlight-message"
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              recommendationMessage,
                                                          }}
                                                        />
                                                      </p>
                                                    )}
                                                </>
                                              )}
                                            </div>
                                          </div>

                                          <div className="col-md-4 addStyleMobileImg">
                                            {Coatstyle?.image ? (
                                              <Image
                                                src={`${ImageUrl}${Coatstyle?.image}`}
                                                className="noSelectCoatImg"
                                                alt=""
                                              />
                                            ) : (
                                              <img
                                                src="/assets/images/no-photo.png"
                                                className="selectCoatImg"
                                                alt=""
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </AccordionItem>

                                    <AccordionItem
                                      id={2}
                                      open={activeItem === 2}
                                      title={
                                        Lebelpant?.style ? (
                                          <span className="fw-400">
                                            <strong className="fw-700">
                                              Pant Style
                                            </strong>{" "}
                                            ({Lebelpant?.style}{" "}
                                            {Lebelpant?.description} -
                                            <span>
                                              <strong className="fw-700">
                                                {" "}
                                                {Lebelpantsize
                                                  ? Lebelpantsize
                                                  : "N/A"}
                                              </strong>
                                            </span>
                                            )
                                          </span>
                                        ) : (
                                          <span>
                                            <strong className="fw-700">
                                              Pant Style
                                            </strong>
                                          </span>
                                        )
                                      }
                                    >
                                      <div className="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-8 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Pant Style
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Pant"
                                                  control={control}
                                                  render={({ field }) => {
                                                    const pantOptions =
                                                      getPantOptions();
                                                    // 🔎 check if current value exists in dropdown
                                                    const selectedOption =
                                                      pantOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          field.value,
                                                      );

                                                    // 🧠 fallback autofilled value (FULL LABEL)
                                                    const fallbackValue =
                                                      field.value
                                                        ? {
                                                          value: field.value,
                                                          label: `${field.value} ${Pantstyle?.description || ""}`,
                                                          // 👆 backend se aa raha: "000 Sub-Rental Coat Style"
                                                        }
                                                        : null;

                                                    const isValueMissing =
                                                      field.value &&
                                                      !selectedOption;

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={pantOptions}
                                                        placeholder="Select"
                                                        components={
                                                          customComponents
                                                        }
                                                        isClearable={
                                                          !isValueMissing
                                                        }
                                                        isDisabled={
                                                          isValueMissing
                                                        }
                                                        formatOptionLabel={(
                                                          option,
                                                        ) => (
                                                          <div
                                                            style={
                                                              option.isMatched
                                                                ? {
                                                                  fontWeight:
                                                                    "bold",
                                                                }
                                                                : {}
                                                            }
                                                          >
                                                            {option.label}
                                                          </div>
                                                        )}
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          const selectedValue =
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "";

                                                          field.onChange(
                                                            selectedValue,
                                                          ); // Update form value
                                                          const syntheticEvent =
                                                          {
                                                            target: {
                                                              value:
                                                                selectedValue,
                                                            },
                                                          };
                                                          handlePaintChange(
                                                            syntheticEvent,
                                                          ); // Trigger change handler
                                                          setValue("Waist", "");
                                                          setValue("hip", "");
                                                          setValue(
                                                            "outseam",
                                                            "",
                                                          );

                                                          // Optional: clear validation & messages
                                                          clearErrors([
                                                            "Waist",
                                                            "hip",
                                                            "outseam",
                                                          ]);
                                                          setPantValidationMessage(
                                                            "",
                                                          );
                                                          setSizeRecommendationMsg(
                                                            "",
                                                          );
                                                          localStorage.removeItem(
                                                            "pantSizeRecommendationMsg",
                                                          );
                                                        }}
                                                        value={
                                                          selectedOption ||
                                                          fallbackValue
                                                        }
                                                      />
                                                    );
                                                  }}
                                                />
                                                {errors.Pant && (
                                                  <p className="red">
                                                    {errors.Pant.message}
                                                  </p>
                                                )}
                                              </div>

                                              {/* Display Pant Style Details */}
                                              <div className="col-md-6 mb-3">
                                                <h6 className="mb-0 mt-1">
                                                  {Pantstyle?.style
                                                    ? `#${Pantstyle.style}`
                                                    : ""}
                                                </h6>
                                                <p className="coatTxtPra">
                                                  <small>
                                                    {Pantstyle?.description}
                                                  </small>
                                                </p>
                                              </div>

                                              {/* Waist Field */}
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Waist{" "}
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Waist"
                                                  control={control}
                                                  rules={{
                                                    required: pantStyleSelected
                                                      ? {
                                                        value: true,
                                                        message: (
                                                          <span className="size-error">
                                                            {" "}
                                                            Waist is required
                                                          </span>
                                                        ),
                                                      }
                                                      : false,
                                                    validate: (value) => {
                                                      return validatePantSize(
                                                        value,
                                                      );
                                                    },
                                                  }}
                                                  render={({ field }) => {
                                                    const boldSizes =
                                                      waistSizes.map(Number); // e.g. [28, 29, 30, 31]
                                                    const allSizes =
                                                      pantStyleSizes?.waistSizes
                                                        ?.length
                                                        ? pantStyleSizes.waistSizes
                                                        : AllSize?.waistSizes ||
                                                        [];

                                                    const numericAllSizes =
                                                      allSizes.map(Number);
                                                    const maxBold = Math.max(
                                                      ...boldSizes,
                                                    );
                                                    const minBold = Math.min(
                                                      ...boldSizes,
                                                    );
                                                    let boldOptions = [];
                                                    let afterBoldOptions = [];
                                                    let beforeBoldOptions = [];

                                                    if (
                                                      recommendedRange?.waistMin &&
                                                      recommendedRange?.waistMax
                                                    ) {
                                                      // Recommended range exists → use your bold logic
                                                      boldOptions =
                                                        numericAllSizes
                                                          .filter(
                                                            (size) =>
                                                              size >=
                                                              recommendedRange.waistMin &&
                                                              size <=
                                                              recommendedRange.waistMax,
                                                          )
                                                          .map((size) => ({
                                                            value:
                                                              size.toString(),
                                                            label:
                                                              size.toString(),
                                                          }));

                                                      afterBoldOptions =
                                                        numericAllSizes
                                                          .filter(
                                                            (size) =>
                                                              size >
                                                              recommendedRange.waistMax,
                                                          )
                                                          .map((size) => ({
                                                            value:
                                                              size.toString(),
                                                            label:
                                                              size.toString(),
                                                          }));

                                                      beforeBoldOptions =
                                                        numericAllSizes
                                                          .filter(
                                                            (size) =>
                                                              size <
                                                              recommendedRange.waistMin,
                                                          )
                                                          .map((size) => ({
                                                            value:
                                                              size.toString(),
                                                            label:
                                                              size.toString(),
                                                          }));
                                                    } else {
                                                      // No recommended range → show all sizes ONCE
                                                      boldOptions =
                                                        numericAllSizes.map(
                                                          (size) => ({
                                                            value:
                                                              size.toString(),
                                                            label:
                                                              size.toString(),
                                                          }),
                                                        );

                                                      afterBoldOptions = [];
                                                      beforeBoldOptions = [];
                                                    }

                                                    // Final sorted options:
                                                    const sortedOptions = [
                                                      {
                                                        value: "category",
                                                        label: categoryName,
                                                        isDisabled: true,
                                                      },
                                                      ...boldOptions,
                                                      ...afterBoldOptions,
                                                      ...beforeBoldOptions,
                                                    ];
                                                    const isPantStyleDisabled =
                                                      Pantstyle?.style &&
                                                      !getPantOptions().some(
                                                        (opt) =>
                                                          opt.value ===
                                                          Pantstyle.style,
                                                      );

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={sortedOptions}
                                                        placeholder="Select Waist Size"
                                                        isDisabled={
                                                          isPantStyleDisabled
                                                        }
                                                        isClearable={
                                                          !isPantStyleDisabled
                                                        }
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          const selectedValue =
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "";
                                                          field.onChange(
                                                            selectedValue,
                                                          );
                                                          if (!selectedValue) {
                                                            setSizeRecommendationMsg(
                                                              "",
                                                            );
                                                            checkPantSizeRanges(
                                                              null,
                                                              "waist",
                                                            );
                                                            localStorage.removeItem(
                                                              "pantSizeRecommendationMsg",
                                                            );
                                                            setPantValidationMessage(
                                                              "",
                                                            );
                                                            return;
                                                          }
                                                          checkPantSizeRanges(
                                                            selectedValue,
                                                            "waist",
                                                          );
                                                          validatePantSize(
                                                            selectedValue,
                                                          );
                                                        }}
                                                        value={
                                                          field.value
                                                            ? {
                                                              value:
                                                                field.value,
                                                              label:
                                                                field.value.toString(),
                                                            }
                                                            : null
                                                        }
                                                        formatOptionLabel={(
                                                          option,
                                                        ) => {
                                                          let isBold = false;

                                                          if (
                                                            recommendedRange
                                                          ) {
                                                            const {
                                                              waistMin,
                                                              waistMax,
                                                            } =
                                                              recommendedRange;
                                                            if (
                                                              Number(
                                                                option.value,
                                                              ) >= waistMin &&
                                                              Number(
                                                                option.value,
                                                              ) <= waistMax
                                                            ) {
                                                              isBold = true;
                                                            }
                                                          }

                                                          return (
                                                            <div
                                                              style={
                                                                isBold
                                                                  ? {
                                                                    fontWeight:
                                                                      "bold",
                                                                  }
                                                                  : {}
                                                              }
                                                            >
                                                              {option.label}
                                                            </div>
                                                          );
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                />
                                                {pantStyleSelected &&
                                                  errors.Waist && (
                                                    <p className="red">
                                                      {errors.Waist.message}
                                                    </p>
                                                  )}
                                                {pantValidationMessage && (
                                                  <p className="pantvalidation-error">
                                                    {pantValidationMessage}
                                                  </p>
                                                )}
                                              </div>

                                              {/* Hip Field */}
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Hip
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="hip"
                                                  control={control}
                                                  rules={{ required: false }}
                                                  render={({ field }) => {
                                                    const getSortedHipOptions =
                                                      () => {
                                                        const boldSizes =
                                                          HipSizes.map(Number); // Bold sizes from backend
                                                        const allSizes = (
                                                          AllSize?.hipSizes ||
                                                          []
                                                        ).map(Number); // All hip sizes

                                                        const hipMin =
                                                          recommendedRange?.hipMin;
                                                        const hipMax =
                                                          recommendedRange?.hipMax;

                                                        let boldOptions = [];
                                                        let afterBoldOptions =
                                                          [];
                                                        let beforeBoldOptions =
                                                          [];

                                                        if (hipMin && hipMax) {
                                                          // ✅ Coat/Height+Weight recommended range
                                                          boldOptions = allSizes
                                                            .filter(
                                                              (size) =>
                                                                size >=
                                                                hipMin &&
                                                                size <= hipMax,
                                                            )
                                                            .map((size) => ({
                                                              value:
                                                                size.toString(),
                                                              label:
                                                                size.toString(),
                                                            }));

                                                          afterBoldOptions =
                                                            allSizes
                                                              .filter(
                                                                (size) =>
                                                                  size > hipMax,
                                                              )
                                                              .map((size) => ({
                                                                value:
                                                                  size.toString(),
                                                                label:
                                                                  size.toString(),
                                                              }));

                                                          beforeBoldOptions =
                                                            allSizes
                                                              .filter(
                                                                (size) =>
                                                                  size < hipMin,
                                                              )
                                                              .map((size) => ({
                                                                value:
                                                                  size.toString(),
                                                                label:
                                                                  size.toString(),
                                                              }));
                                                        } else {
                                                          // ✅ No recommended range — show all sizes normally
                                                          boldOptions =
                                                            allSizes.map(
                                                              (size) => ({
                                                                value:
                                                                  size.toString(),
                                                                label:
                                                                  size.toString(),
                                                              }),
                                                            );
                                                          afterBoldOptions = [];
                                                          beforeBoldOptions =
                                                            [];
                                                        }
                                                        return [
                                                          {
                                                            value: "category",
                                                            label: categoryName,
                                                            isDisabled: true,
                                                          },
                                                          ...boldOptions,
                                                          ...afterBoldOptions,
                                                          ...beforeBoldOptions,
                                                        ];
                                                      };
                                                    const isPantStyleDisabled =
                                                      Pantstyle?.style &&
                                                      !getPantOptions().some(
                                                        (opt) =>
                                                          opt.value ===
                                                          Pantstyle.style,
                                                      );

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={getSortedHipOptions()}
                                                        placeholder="Select Hip Size"
                                                        isDisabled={
                                                          isPantStyleDisabled
                                                        }
                                                        isClearable={
                                                          !isPantStyleDisabled
                                                        }
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          const selectedValue =
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "";
                                                          field.onChange(
                                                            selectedValue,
                                                          );
                                                          if (!selectedValue) {
                                                            checkPantSizeRanges(
                                                              null,
                                                              "Hip",
                                                            );
                                                            localStorage.removeItem(
                                                              "pantSizeRecommendationMsg",
                                                            );
                                                            return;
                                                          }
                                                          checkPantSizeRanges(
                                                            selectedValue,
                                                            "Hip",
                                                          );
                                                        }}
                                                        value={
                                                          field.value
                                                            ? {
                                                              value:
                                                                field.value,
                                                              label:
                                                                field.value.toString(),
                                                              isDisabled: false,
                                                            }
                                                            : null
                                                        }
                                                        formatOptionLabel={(
                                                          option,
                                                        ) => {
                                                          const hipMin =
                                                            recommendedRange?.hipMin;
                                                          const hipMax =
                                                            recommendedRange?.hipMax;
                                                          const size = Number(
                                                            option.value,
                                                          );

                                                          const isBold =
                                                            hipMin &&
                                                            hipMax &&
                                                            size >= hipMin &&
                                                            size <= hipMax;

                                                          return (
                                                            <div
                                                              style={
                                                                isBold
                                                                  ? {
                                                                    fontWeight:
                                                                      "bold",
                                                                  }
                                                                  : {}
                                                              }
                                                            >
                                                              {option.label}
                                                            </div>
                                                          );
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                />
                                                {pantStyleSelected &&
                                                  errors.hip && (
                                                    <p className="red">
                                                      {errors.hip.message}
                                                    </p>
                                                  )}
                                              </div>

                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Outseam
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="outseam"
                                                  control={control}
                                                  rules={{
                                                    required: pantStyleSelected
                                                      ? {
                                                        value: true,
                                                        message: (
                                                          <span className="size-error">
                                                            {" "}
                                                            Outseam is
                                                            required
                                                          </span>
                                                        ),
                                                      }
                                                      : false,
                                                  }}
                                                  render={({ field }) => {
                                                    const getSortedOutseamOptions =
                                                      () => {
                                                        const boldSizes =
                                                          outseamSizes.map(
                                                            Number,
                                                          ); // from API — e.g., [34, 35, 36, 37, 38, 39]

                                                        // Generate full range from 19 to 60 in 0.5 increments
                                                        const fullRangeSizes =
                                                          Array.from(
                                                            { length: 83 },
                                                            (_, i) =>
                                                              19 + i * 0.5,
                                                          ); // 19 to 60 inclusive

                                                        // Merge API-provided sizes with the full range, ensuring uniqueness
                                                        const allSizes =
                                                          Array.from(
                                                            new Set([
                                                              ...(AllSize?.outseamSizes ||
                                                                []),
                                                              ...fullRangeSizes,
                                                            ]),
                                                          )
                                                            .map(Number)
                                                            .sort(
                                                              (a, b) => a - b,
                                                            );

                                                        const outseamMin =
                                                          recommendedRange?.outseamMin;
                                                        const outseamMax =
                                                          recommendedRange?.outseamMax;

                                                        let boldOptions = [];
                                                        let afterBoldOptions =
                                                          [];
                                                        let beforeBoldOptions =
                                                          [];

                                                        if (
                                                          outseamMin &&
                                                          outseamMax
                                                        ) {
                                                          // ✅ Coat/Height+Weight based recommendation
                                                          boldOptions = allSizes
                                                            .filter(
                                                              (size) =>
                                                                size >=
                                                                outseamMin &&
                                                                size <=
                                                                outseamMax,
                                                            )
                                                            .map((size) => ({
                                                              value:
                                                                size.toString(),
                                                              label:
                                                                size.toString(),
                                                            }));

                                                          afterBoldOptions =
                                                            allSizes
                                                              .filter(
                                                                (size) =>
                                                                  size >
                                                                  outseamMax,
                                                              )
                                                              .map((size) => ({
                                                                value:
                                                                  size.toString(),
                                                                label:
                                                                  size.toString(),
                                                              }));

                                                          beforeBoldOptions =
                                                            allSizes
                                                              .filter(
                                                                (size) =>
                                                                  size <
                                                                  outseamMin,
                                                              )
                                                              .map((size) => ({
                                                                value:
                                                                  size.toString(),
                                                                label:
                                                                  size.toString(),
                                                              }));
                                                        }
                                                        // 🧩 Fallback: If no recommended range, show AllSize values by default
                                                        // if (
                                                        //   !outseamMin ||
                                                        //   !outseamMax
                                                        // ) {
                                                        //   boldOptions = (
                                                        //     AllSize?.outseamSizes ||
                                                        //     []
                                                        //   ).map((size) => ({
                                                        //     value:
                                                        //       size.toString(),
                                                        //     label:
                                                        //       size.toString(),
                                                        //   }));
                                                        // }
                                                        if (!outseamMin || !outseamMax) {
                                                          const sizesFromApi = AllSize?.outseamSizes || [];

                                                          const sizesWithHalf = sizesFromApi.flatMap((size) => [
                                                            Number(size),
                                                            Number(size) + 0.5,
                                                          ]);

                                                          const uniqueSortedSizes = [...new Set(sizesWithHalf)].sort((a, b) => a - b);

                                                          boldOptions = uniqueSortedSizes.map((size) => ({
                                                            value: size.toString(),
                                                            label: size.toString(),
                                                          }));
                                                        }
                                                        return [
                                                          {
                                                            value: "category",
                                                            label: categoryName,
                                                            isDisabled: true,
                                                          },
                                                          ...boldOptions,
                                                          ...afterBoldOptions,
                                                          ...beforeBoldOptions,
                                                        ];
                                                      };
                                                    const isPantStyleDisabled =
                                                      Pantstyle?.style &&
                                                      !getPantOptions().some(
                                                        (opt) =>
                                                          opt.value ===
                                                          Pantstyle.style,
                                                      );

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={getSortedOutseamOptions()}
                                                        placeholder="Select Outseam Size"
                                                        isDisabled={
                                                          isPantStyleDisabled
                                                        }
                                                        isClearable={
                                                          !isPantStyleDisabled
                                                        }
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          const selectedValue =
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "";
                                                          field.onChange(
                                                            selectedValue,
                                                          );
                                                          if (!selectedValue) {
                                                            checkPantSizeRanges(
                                                              null,
                                                              "outseam",
                                                            );
                                                            localStorage.removeItem(
                                                              "pantSizeRecommendationMsg",
                                                            );
                                                            return;
                                                          }
                                                          checkPantSizeRanges(
                                                            selectedValue,
                                                            "Outseam",
                                                          );
                                                        }}
                                                        value={
                                                          field.value
                                                            ? {
                                                              value:
                                                                field.value,
                                                              label:
                                                                field.value.toString(),
                                                            }
                                                            : null
                                                        }
                                                        formatOptionLabel={(
                                                          option,
                                                        ) => {
                                                          const outseamMin =
                                                            recommendedRange?.outseamMin;
                                                          const outseamMax =
                                                            recommendedRange?.outseamMax;
                                                          const size = Number(
                                                            option.value,
                                                          );

                                                          const isBold =
                                                            outseamMin &&
                                                            outseamMax &&
                                                            size >=
                                                            outseamMin &&
                                                            size <= outseamMax;

                                                          return (
                                                            <div
                                                              style={
                                                                isBold
                                                                  ? {
                                                                    fontWeight:
                                                                      "bold",
                                                                  }
                                                                  : {}
                                                              }
                                                            >
                                                              {option.label}
                                                            </div>
                                                          );
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                />
                                                {pantStyleSelected &&
                                                  errors.outseam && (
                                                    <p className="red">
                                                      {errors.outseam.message}
                                                    </p>
                                                  )}
                                              </div>
                                              <div className="col-md-6 mb-3">
                                                {shouldShowBelt && (
                                                  <>
                                                    <label>Belt Color</label>
                                                    <select
                                                      {...register("belt")}
                                                      value={
                                                        currentBeltValue || ""
                                                      }
                                                      onChange={(e) => {
                                                        setHasUserSelected(
                                                          true,
                                                        );
                                                        setValue(
                                                          "belt",
                                                          e.target.value,
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                      }}
                                                    >
                                                      <option value="">
                                                        Select color
                                                      </option>
                                                      {availableColors.map(
                                                        (color) => (
                                                          <option
                                                            value={color}
                                                            key={color}
                                                          >
                                                            {color}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-4 addStyleMobileImg">
                                            {Pantstyle?.image ? (
                                              <Image
                                                src={`${ImageUrl}${Pantstyle?.image}`}
                                                className="noSelectCoatImg"
                                                alt=""
                                              />
                                            ) : (
                                              <img
                                                src="/assets/images/no-photo.png"
                                                className="selectCoatImg"
                                                alt=""
                                              />
                                            )}
                                          </div>

                                          {Pantstyle?.style &&
                                            !getPantOptions()?.some(
                                              (opt) =>
                                                opt.value === Pantstyle.style,
                                            ) ? (
                                            <SubRentalWarning />
                                          ) : (
                                            <>
                                              {selectedHeight &&
                                                sizeRecommendationMsg && (
                                                  <div className="col-12 mb-3">
                                                    <p className="text-red-600">
                                                      <span
                                                        className="highlight-message"
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            sizeRecommendationMsg,
                                                        }}
                                                      />
                                                    </p>
                                                  </div>
                                                )}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </AccordionItem>

                                    <AccordionItem
                                      id={3}
                                      open={activeItem === 3}
                                      title={
                                        LebelShirt?.style ? (
                                          <span className="fw-400">
                                            <strong className="fw-700">
                                              Shirt Style
                                            </strong>{" "}
                                            ({LebelShirt?.style}{" "}
                                            {LebelShirt?.description} -
                                            <span>
                                              <strong className="fw-700">
                                                {LebelShirtsize
                                                  ? LebelShirtsize
                                                  : "N/A"}
                                              </strong>
                                            </span>
                                            )
                                          </span>
                                        ) : (
                                          <span>
                                            <strong className="fw-700">
                                              Shirt Style
                                            </strong>
                                          </span>
                                        )
                                      }
                                    >
                                      <div class="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-8 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Shirt Style
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Shirt"
                                                  control={control}
                                                  render={({ field }) => (
                                                    <Select
                                                      {...field}
                                                      options={sortedShirts.map(
                                                        (item) => ({
                                                          value: `${item.style}`, // Combined value
                                                          label: `${item.style} ${item.description}`, // Combined label
                                                        }),
                                                      )}
                                                      placeholder="Select"
                                                      components={
                                                        customComponents
                                                      }
                                                      isClearable
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        const selectedValue =
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "";
                                                        field.onChange(
                                                          selectedValue,
                                                        ); // Update react-hook-form value
                                                        const syntheticEvent = {
                                                          target: {
                                                            value:
                                                              selectedValue,
                                                          },
                                                        };
                                                        handleShirtChange(
                                                          syntheticEvent,
                                                        );
                                                        setValue(
                                                          "ShirtSize",
                                                          "",
                                                        ); // Clears Neck
                                                        setValue("Sleeve", ""); // Clears Sleeve
                                                        setShirtSizeRecommendationMsg(
                                                          "",
                                                        );
                                                      }}
                                                      value={
                                                        sortedShirts
                                                          .map((item) => ({
                                                            value: `${item.style}`,
                                                            label: `${item.style} ${item.description}`,
                                                          }))
                                                          .find(
                                                            (option) =>
                                                              option.value ===
                                                              field.value,
                                                          ) || null
                                                      }
                                                    />
                                                  )}
                                                />
                                                {errors.Shirt && (
                                                  <p className="red">
                                                    {errors.Shirt.message}
                                                  </p>
                                                )}
                                              </div>

                                              <div className="col-md-6 mb-3">
                                                <h6 className="mb-0 mt-1">
                                                  {shirtstyleData?.style
                                                    ? `#${shirtstyleData?.style}`
                                                    : ""}
                                                </h6>
                                                <p className="coatTxtPra">
                                                  <small>
                                                    {
                                                      shirtstyleData?.description
                                                    }
                                                  </small>
                                                </p>

                                                {shirtSize && (
                                                  <p
                                                    className="coatTxtPra"
                                                    title={`Shirt Size: ${shirtSize}`}
                                                  >
                                                    <small>
                                                      <strong
                                                        style={{
                                                          fontSize: "16px",
                                                        }}
                                                      >
                                                        Shirt Size:
                                                      </strong>{" "}
                                                      <span
                                                        style={{
                                                          fontSize: "16px",
                                                        }}
                                                      >
                                                        {shirtSize}
                                                      </span>
                                                    </small>
                                                  </p>
                                                )}
                                              </div>
                                              {orderForState === "Boys" &&
                                                watch("Shirt") &&
                                                (() => {
                                                  const style = watch("Shirt")
                                                    .toString()
                                                    .toUpperCase();
                                                  if (style.includes("ILF")) {
                                                    return (
                                                      <p
                                                        style={{
                                                          backgroundColor:
                                                            "lightyellow", // or use 'rgb(255, 255, 224)'
                                                          padding: "2px 12px",
                                                          borderRadius: "4px",
                                                          color: "black",
                                                          width: "fit-content",
                                                        }}
                                                      >
                                                        ⚠️ ILF styles are not
                                                        available for boys.
                                                        Please use style 414
                                                        instead.
                                                      </p>
                                                    );
                                                  } else if (
                                                    style.includes("BLF")
                                                  ) {
                                                    return (
                                                      <p
                                                        style={{
                                                          backgroundColor:
                                                            "lightyellow", // or use 'rgb(255, 255, 224)'
                                                          padding: "2px 12px",
                                                          borderRadius: "4px",
                                                          color: "black",
                                                          width: "fit-content",
                                                        }}
                                                      >
                                                        ⚠️ BLF styles are not
                                                        available for boys.
                                                        Please use style 406
                                                        instead.
                                                      </p>
                                                    );
                                                  } else if (
                                                    style.includes("WLF")
                                                  ) {
                                                    return (
                                                      <p
                                                        style={{
                                                          backgroundColor:
                                                            "lightyellow", // or use 'rgb(255, 255, 224)'
                                                          padding: "2px 12px",
                                                          borderRadius: "4px",
                                                          color: "black",
                                                          width: "fit-content",
                                                        }}
                                                      >
                                                        ⚠️ WLF styles are not
                                                        available for boys.
                                                        Please use style 410
                                                        instead.
                                                      </p>
                                                    );
                                                  }
                                                  return null;
                                                })()}
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Neck
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="ShirtSize"
                                                  control={control}
                                                  rules={{
                                                    required: shirtStyleSelected
                                                      ? {
                                                        value: true,
                                                        message: (
                                                          <span className="size-error">
                                                            {" "}
                                                            Neck size is
                                                            required
                                                          </span>
                                                        ),
                                                      }
                                                      : false,
                                                  }}
                                                  render={({ field }) => (
                                                    <Select
                                                      {...field}
                                                      options={neckSizeOptions}
                                                      placeholder="Select Neck Size"
                                                      isClearable
                                                      value={
                                                        field.value
                                                          ? {
                                                            value:
                                                              field.value,
                                                            label:
                                                              field.value,
                                                          }
                                                          : null
                                                      }
                                                      formatOptionLabel={(
                                                        option,
                                                      ) => (
                                                        <div
                                                          style={
                                                            option.bold
                                                              ? {
                                                                fontWeight:
                                                                  "bold",
                                                              }
                                                              : {}
                                                          }
                                                        >
                                                          {option.label}
                                                        </div>
                                                      )}
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        const selectedValue =
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "";

                                                        field.onChange(
                                                          selectedValue,
                                                        );
                                                        handleNeckChange(
                                                          selectedOption,
                                                        );
                                                        setValue("Sleeve", "");
                                                        if (!selectedValue) {
                                                          setShirtSizeRecommendationMsg(
                                                            "",
                                                          );
                                                          localStorage.removeItem(
                                                            "shirtSizeRecommendationMsg",
                                                          );
                                                          return;
                                                        }
                                                        checkShirtSizeRanges(
                                                          selectedOption,
                                                          "ShirtSize",
                                                        );
                                                      }}
                                                    />
                                                  )}
                                                />
                                                {errors.ShirtSize && (
                                                  <p className="red">
                                                    {errors.ShirtSize.message}
                                                  </p>
                                                )}
                                              </div>

                                              <div className="col-6 col-md-6 mb-3">
                                                {showSleeve && (
                                                  <>
                                                    <label>
                                                      Sleeve
                                                      <span className="text-red-500"></span>
                                                    </label>
                                                    <Controller
                                                      name="Sleeve"
                                                      control={control}
                                                      rules={{
                                                        required:
                                                          !disableSleeve &&
                                                            shirtStyleSelected
                                                            ? {
                                                              value: true,
                                                              message: (
                                                                <span className="error-label mt-3">
                                                                  {" "}
                                                                  Sleeve is
                                                                  required
                                                                </span>
                                                              ),
                                                            }
                                                            : false,
                                                      }}
                                                      render={({ field }) => (
                                                        <Select
                                                          {...field}
                                                          options={
                                                            filteredSleeveOptions
                                                          }
                                                          placeholder="Select Sleeve Size"
                                                          isClearable
                                                          isDisabled={
                                                            disableSleeve
                                                          }
                                                          onChange={(
                                                            selectedOption,
                                                          ) => {
                                                            if (
                                                              selectedOption?.isBold
                                                            ) {
                                                              console.log(
                                                                "User selected bold sleeve:",
                                                                selectedOption.value,
                                                              );
                                                            }
                                                            checkShirtSizeRanges(
                                                              selectedOption,
                                                              "Sleeve",
                                                            );
                                                            field.onChange(
                                                              selectedOption
                                                                ? selectedOption.value
                                                                : "",
                                                            );
                                                          }}
                                                          value={
                                                            field.value
                                                              ? {
                                                                value: Number(
                                                                  field.value,
                                                                ),
                                                                label: `${Number(field.value)}/${Number(field.value) + 1}`,
                                                              }
                                                              : null
                                                          }
                                                          formatOptionLabel={(
                                                            option,
                                                          ) => (
                                                            <div
                                                              style={
                                                                option.isBold
                                                                  ? {
                                                                    fontWeight:
                                                                      "bold",
                                                                  }
                                                                  : {}
                                                              }
                                                            >
                                                              {option.label}
                                                            </div>
                                                          )}
                                                        />
                                                      )}
                                                    />
                                                    {errors.Sleeve && (
                                                      <p className="red">
                                                        {errors.Sleeve.message}
                                                      </p>
                                                    )}
                                                  </>
                                                )}
                                              </div>
                                              {shirtSizeRecommendationMsg && (
                                                <div className="col-12 mb-3">
                                                  <p className="text-red-600">
                                                    <span
                                                      className="highlight-message"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          shirtSizeRecommendationMsg,
                                                      }}
                                                    ></span>
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div className="col-md-4 addStyleMobileImg">
                                            {shirtstyleData?.image ? (
                                              <Image
                                                src={`${ImageUrl}${shirtstyleData?.image}`}
                                                className="noSelectCoatImg"
                                                alt=""
                                              />
                                            ) : (
                                              <img
                                                src="/assets/images/no-photo.png"
                                                className="selectCoatImg"
                                                alt
                                              />
                                            )}
                                          </div>
                                          {/* {shirtSizeRecommendationMsg && (
                                                                                        <div className="col-12 mb-3">
                                                                                            <p className="text-red-600">
                                                                                                <span
                                                                                                    className="highlight-message" dangerouslySetInnerHTML={{ __html: shirtSizeRecommendationMsg }}></span></p>
                                                                                        </div>
                                                                                    )} */}
                                        </div>
                                      </div>
                                    </AccordionItem>

                                    <AccordionItem
                                      id={4}
                                      title={
                                        LebelVest?.style ? (
                                          <span className="fw-400">
                                            <strong className="fw-700">
                                              Vest Style
                                            </strong>{" "}
                                            ({LebelVest?.style}{" "}
                                            {LebelVest?.description} -
                                            <span>
                                              <strong className="fw-700">
                                                {LebelVestsize
                                                  ? LebelVestsize
                                                  : "N/A"}
                                              </strong>
                                            </span>
                                            )
                                          </span>
                                        ) : (
                                          <span>
                                            <strong className="fw-700">
                                              Vest Style
                                            </strong>
                                          </span>
                                        )
                                      }
                                    >
                                      <div class="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-12 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-8 mb-3">
                                                <div className="row">
                                                  <div className="col-md-6 mb-3">
                                                    <label>
                                                      Vest Style{" "}
                                                      <span className="text-red-500"></span>
                                                    </label>
                                                    <Controller
                                                      name="Vest"
                                                      control={control}
                                                      render={({ field }) => {
                                                        const options =
                                                          sortedVest.map(
                                                            (item) => ({
                                                              value: item.style,
                                                              label: `${item.style} ${item.description}`,
                                                            }),
                                                          );

                                                        // Check if current value exists in options
                                                        const selectedOption =
                                                          options.find(
                                                            (option) =>
                                                              option.value ===
                                                              field.value,
                                                          );

                                                        // If not found, create a fallback display value
                                                        const fallbackValue =
                                                          field.value
                                                            ? {
                                                              value:
                                                                field.value,
                                                              label: `${field.value} ${Vest?.[0]?.description || ""}`,
                                                            }
                                                            : null;

                                                        const isValueMissing =
                                                          field.value &&
                                                          !selectedOption;

                                                        return (
                                                          <Select
                                                            {...field}
                                                            options={options}
                                                            placeholder="Select"
                                                            components={
                                                              customComponents
                                                            }
                                                            isClearable={
                                                              !isValueMissing
                                                            }
                                                            isDisabled={
                                                              isValueMissing
                                                            } // 🔴 Disable when not in options
                                                            value={
                                                              selectedOption ||
                                                              fallbackValue
                                                            }
                                                            onChange={(
                                                              selectedOption,
                                                            ) => {
                                                              field.onChange(
                                                                selectedOption
                                                                  ? selectedOption.value
                                                                  : "",
                                                              );

                                                              const syntheticEvent =
                                                              {
                                                                target: {
                                                                  value:
                                                                    selectedOption
                                                                      ? selectedOption.value
                                                                      : "",
                                                                },
                                                              };
                                                              handleVestChange(
                                                                syntheticEvent,
                                                              );
                                                            }}
                                                          />
                                                        );
                                                      }}
                                                    />

                                                    {errors.Vest && (
                                                      <p className="red">
                                                        {errors.Vest.message}
                                                      </p>
                                                    )}
                                                  </div>

                                                  <div className="col-md-6 mb-3">
                                                    <h6 className="mb-0 mt-1">
                                                      {Veststyle?.style
                                                        ? `#${Veststyle?.style}`
                                                        : ""}
                                                    </h6>
                                                    <p className="coatTxtPra">
                                                      <small>
                                                        {Veststyle?.description}
                                                      </small>
                                                    </p>
                                                  </div>
                                                  <div className="col-md-6 mb-3">
                                                    <label>
                                                      Vest Size
                                                      <span className="text-red-500">
                                                        *
                                                      </span>
                                                    </label>
                                                    <Controller
                                                      name="VestColor"
                                                      control={control}
                                                      rules={{
                                                        required:
                                                          vestStyleSelected
                                                            ? "Vest size is required"
                                                            : false,
                                                      }}
                                                      render={({
                                                        field,
                                                        fieldState: { error },
                                                        formState,
                                                      }) => {
                                                        let uniqueSizes = [];

                                                        if (
                                                          coatid &&
                                                          recommendedVestSize
                                                        ) {
                                                          uniqueSizes = [
                                                            recommendedVestSize,
                                                          ];
                                                        } else if (
                                                          selectedHeight &&
                                                          watch("Weight")
                                                        ) {
                                                          const weight =
                                                            watch("Weight");
                                                          const isWeightValid =
                                                            weight !== null &&
                                                            weight !==
                                                            undefined &&
                                                            !isNaN(weight) &&
                                                            weight !== "";

                                                          if (isWeightValid) {
                                                            const validSizeCharts =
                                                              sizes
                                                                .flatMap(
                                                                  (category) =>
                                                                    category.size_charts,
                                                                )
                                                                .filter(
                                                                  (size) =>
                                                                    size.minHeight !==
                                                                    null &&
                                                                    size.maxHeight !==
                                                                    null &&
                                                                    selectedHeight >=
                                                                    size.minHeight &&
                                                                    selectedHeight <=
                                                                    size.maxHeight,
                                                                );

                                                            const isWeightInRange =
                                                              validSizeCharts.some(
                                                                (chart) =>
                                                                  (!chart.minWeight ||
                                                                    Number(
                                                                      weight,
                                                                    ) >=
                                                                    chart.minWeight) &&
                                                                  (!chart.maxWeight ||
                                                                    Number(
                                                                      weight,
                                                                    ) <=
                                                                    chart.maxWeight),
                                                              );

                                                            if (
                                                              isWeightInRange &&
                                                              validSizeCharts.length >
                                                              0
                                                            ) {
                                                              // Find the first valid category with size charts
                                                              let foundChart =
                                                                null;
                                                              for (const category of sizes ||
                                                                []) {
                                                                if (
                                                                  category.size_charts &&
                                                                  category
                                                                    .size_charts
                                                                    .length > 0
                                                                ) {
                                                                  foundChart =
                                                                    category
                                                                      .size_charts[0];
                                                                  break;
                                                                }
                                                              }

                                                              if (
                                                                foundChart &&
                                                                foundChart.vestSize
                                                              ) {
                                                                uniqueSizes = [
                                                                  foundChart.vestSize,
                                                                ];
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          // Case 3: No coat size and no valid height/weight
                                                          uniqueSizes = [];
                                                        }

                                                        // Remove duplicates
                                                        uniqueSizes = [
                                                          ...new Set(
                                                            uniqueSizes,
                                                          ),
                                                        ];

                                                        // Filter only categories that have size charts
                                                        const filteredCategories =
                                                          sizes.filter(
                                                            (category) =>
                                                              category
                                                                .size_charts
                                                                .length > 0,
                                                          );

                                                        // Get available vest sizes from AllSize
                                                        const availableCoatSizes =
                                                          (
                                                            AllSize?.vestSizes ||
                                                            []
                                                          ).map((size) => ({
                                                            value: size,
                                                            label:
                                                              size.toString(),
                                                          }));

                                                        const sortedAvailableCoatSizes =
                                                          sortVestSizesWithLogic(
                                                            availableCoatSizes,
                                                            uniqueSizes,
                                                          );
                                                        const selectedVestStyle =
                                                          watch("Vest");

                                                        const isVestStyleDisabled =
                                                          !!selectedVestStyle &&
                                                          !sortedVest.some(
                                                            (opt) =>
                                                              opt.style ===
                                                              selectedVestStyle,
                                                          );

                                                        return (
                                                          <>
                                                            <Select
                                                              {...field}
                                                              options={
                                                                sortedAvailableCoatSizes
                                                              }
                                                              placeholder="Select vest size"
                                                              isClearable
                                                              isDisabled={
                                                                isVestStyleDisabled
                                                              } // 🔴 SAME CONDITION
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                const selectedValue =
                                                                  selectedOption
                                                                    ? selectedOption.value
                                                                    : "";
                                                                field.onChange(
                                                                  selectedValue,
                                                                );
                                                                trigger(
                                                                  "VestColor",
                                                                );
                                                                setIsVestManuallySelected(
                                                                  true,
                                                                );

                                                                if (
                                                                  !selectedValue
                                                                ) {
                                                                  checkVestSizeRanges(
                                                                    {
                                                                      value:
                                                                        selectedValue,
                                                                    },
                                                                    "Vest",
                                                                  );
                                                                  localStorage.removeItem(
                                                                    "vestRecommendationMsg",
                                                                  );
                                                                  return;
                                                                }

                                                                checkVestSizeRanges(
                                                                  selectedOption,
                                                                  "Vest",
                                                                );
                                                              }}
                                                              value={
                                                                sortedAvailableCoatSizes.find(
                                                                  (option) =>
                                                                    option.value ===
                                                                    field.value,
                                                                ) || null
                                                              }
                                                              formatOptionLabel={(
                                                                option,
                                                                { context },
                                                              ) => (
                                                                <div
                                                                  style={
                                                                    uniqueSizes.includes(
                                                                      option.value,
                                                                    )
                                                                      ? {
                                                                        fontWeight:
                                                                          "bold",
                                                                      }
                                                                      : {}
                                                                  }
                                                                >
                                                                  {option.label}
                                                                </div>
                                                              )}
                                                            />
                                                            {error && (
                                                              <span className="size-error">
                                                                {" "}
                                                                {error.message}
                                                              </span>
                                                            )}
                                                          </>
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="col-md-4 addStyleMobileImg">
                                                {Veststyle?.image ? (
                                                  <Image
                                                    src={`${ImageUrl}${Veststyle?.image}`}
                                                    className="noSelectCoatImg"
                                                    alt=""
                                                  />
                                                ) : (
                                                  <img
                                                    src="/assets/images/no-photo.png"
                                                    className="selectCoatImg"
                                                    alt
                                                  />
                                                )}
                                              </div>
                                            </div>

                                            {Veststyle?.style &&
                                              !sortedVest?.some(
                                                (opt) =>
                                                  opt.style === Veststyle.style,
                                              ) ? (
                                              <SubRentalWarning />
                                            ) : (
                                              <>
                                                {selectedHeight &&
                                                  vestRecommendationMsg && (
                                                    <div className="col-12 mb-3">
                                                      <p className="text-red-600">
                                                        <span
                                                          className="highlight-message"
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              vestRecommendationMsg,
                                                          }}
                                                        />
                                                      </p>
                                                    </div>
                                                  )}
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </AccordionItem>

                                    <AccordionItem
                                      id={5}
                                      title={
                                        <span>
                                          <strong className="fw-700">
                                            Tie, Pocket Square, Jewelry Style
                                          </strong>
                                        </span>
                                      }
                                    >
                                      <div className="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-12 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Tie{" "}
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Tie"
                                                  control={control}
                                                  render={({ field }) => {
                                                    const tieOptions =
                                                      sortedTie.map((item) => ({
                                                        value: item.style,
                                                        label: `${item.style} ${item.description}`,
                                                      }));

                                                    // Check if current value exists in options
                                                    const selectedOption =
                                                      tieOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          field.value,
                                                      );

                                                    // Fallback value for autofilled Tie
                                                    const fallbackValue =
                                                      field.value
                                                        ? {
                                                          value: field.value,
                                                          label: `${field.value} ${Tie?.[0]?.description || ""}`,
                                                          // full label from backend or existing state
                                                        }
                                                        : null;

                                                    const isValueMissing =
                                                      field.value &&
                                                      !selectedOption;

                                                    return (
                                                      <Select
                                                        {...field}
                                                        options={tieOptions}
                                                        placeholder="Select Tie"
                                                        components={
                                                          customComponents
                                                        }
                                                        isClearable={
                                                          !isValueMissing
                                                        }
                                                        // ✅ Dropdown should stay enabled
                                                        isDisabled={
                                                          isValueMissing
                                                        }
                                                        value={
                                                          selectedOption ||
                                                          fallbackValue
                                                        }
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          field.onChange(
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "",
                                                          );
                                                          const syntheticEvent =
                                                          {
                                                            target: {
                                                              value:
                                                                selectedOption
                                                                  ? selectedOption.value
                                                                  : "",
                                                            },
                                                          };
                                                          handleTie(
                                                            syntheticEvent,
                                                          );
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                />
                                                {errors.Tie && (
                                                  <p className="red">
                                                    {errors.Tie.message}
                                                  </p>
                                                )}
                                              </div>

                                              <div className="col-md-4 mb-3 ">
                                                <label class="d-block">
                                                  Ordered For
                                                </label>
                                                <ul className="custom-control-group">
                                                  <li>
                                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                      <input
                                                        type="radio"
                                                        className="custom-control-input"
                                                        name="btnRadio"
                                                        id="btnRadio1"
                                                        value="Men"
                                                        {...register(
                                                          "order_for",
                                                        )}
                                                        checked={
                                                          orderForState == "Men"
                                                        }
                                                        onChange={(e) => {
                                                          setOrderForState(
                                                            e.target.value,
                                                          );
                                                        }}
                                                      />
                                                      <label
                                                        className="custom-control-label"
                                                        htmlFor="btnRadio1"
                                                      >
                                                        Men
                                                      </label>
                                                    </div>
                                                  </li>
                                                  <li>
                                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                      <input
                                                        type="radio"
                                                        className="custom-control-input"
                                                        name="btnRadio"
                                                        id="btnRadio2"
                                                        value="Boys"
                                                        {...register(
                                                          "order_for",
                                                        )}
                                                        checked={
                                                          orderForState ==
                                                          "Boys"
                                                        }
                                                        onChange={(e) => {
                                                          setOrderForState(
                                                            e.target.value,
                                                          );
                                                        }}
                                                      />
                                                      <label
                                                        className="custom-control-label"
                                                        htmlFor="btnRadio2"
                                                      >
                                                        Boy
                                                      </label>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>

                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Pocket{" "}
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Pocket"
                                                  control={control}
                                                  render={({ field }) => (
                                                    <Select
                                                      {...field}
                                                      options={sortedPocketSquare.map(
                                                        (item) => ({
                                                          value: `${item.style}`,
                                                          label: `${item.style} ${item.description}`,
                                                        }),
                                                      )}
                                                      placeholder="Select Pocket Square "
                                                      components={
                                                        customComponents
                                                      }
                                                      isClearable
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        field.onChange(
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "",
                                                        );
                                                        const syntheticEvent = {
                                                          target: {
                                                            value:
                                                              selectedOption
                                                                ? selectedOption.value
                                                                : "",
                                                          },
                                                        };
                                                        handlePocket(
                                                          syntheticEvent,
                                                        );
                                                      }}
                                                      value={
                                                        Pocket.map((item) => ({
                                                          value: `${item.style}`,
                                                          label: `${item.style} ${item.description}`,
                                                        })).find(
                                                          (option) =>
                                                            option.value ===
                                                            field.value,
                                                        ) || null
                                                      }
                                                    />
                                                  )}
                                                />
                                                {errors.Pocket && (
                                                  <p className="red">
                                                    {errors.Pocket.message}
                                                  </p>
                                                )}
                                              </div>

                                              <div className="col-md-6 mb-3">
                                                <label>
                                                  Jewelry
                                                  <span className="text-red-500"></span>
                                                </label>
                                                <Controller
                                                  name="Jewelry"
                                                  control={control}
                                                  render={({ field }) => (
                                                    <Select
                                                      {...field}
                                                      options={sortedJewelry.map(
                                                        (item) => ({
                                                          value: item.style,
                                                          label: `${item.style} ${item.description}`,
                                                        }),
                                                      )}
                                                      placeholder="Select Jewelry"
                                                      components={
                                                        customComponents
                                                      }
                                                      isClearable
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        field.onChange(
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "",
                                                        );
                                                        const syntheticEvent = {
                                                          target: {
                                                            value:
                                                              selectedOption
                                                                ? selectedOption.value
                                                                : "",
                                                          },
                                                        };

                                                        handlejwellaryChange(
                                                          syntheticEvent,
                                                        );
                                                      }}
                                                      value={
                                                        Jewelry.map((item) => ({
                                                          value: item.style,
                                                          label: `${item.style} ${item.description}`,
                                                        })).find(
                                                          (option) =>
                                                            option.value ===
                                                            field.value,
                                                        ) || null
                                                      }
                                                    />
                                                  )}
                                                />
                                                {errors.Jewelry && (
                                                  <p className="red">
                                                    {errors.Jewelry.message}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {watch("Tie") &&
                                        !sortedTie.some(
                                          (opt) => opt.style === watch("Tie"),
                                        ) && <SubRentalWarning />}
                                    </AccordionItem>
                                    <AccordionItem
                                      id={6}
                                      title={
                                        LebelShoes?.style ? (
                                          <span className="fw-400">
                                            <strong className="fw-700">
                                              Shoe Style
                                            </strong>{" "}
                                            ({LebelShoes?.style}{" "}
                                            {LebelShoes?.description} -
                                            <span>
                                              <strong className="fw-700">
                                                {LebelShoessize
                                                  ? LebelShoessize
                                                  : "N/A"}
                                              </strong>
                                            </span>
                                            )
                                          </span>
                                        ) : (
                                          <span>
                                            <strong className="fw-700">
                                              Shoe Style
                                            </strong>
                                          </span>
                                        )
                                      }
                                    >
                                      <div className="accordion-inner">
                                        <div className="row">
                                          <div className="col-md-12 p-0 stateSelect">
                                            <div className="row">
                                              <div className="col-md-8 mb-3">
                                                <div className="row">
                                                  <div className="col-md-6 mb-3">
                                                    <label>
                                                      {" "}
                                                      Shoe Style{" "}
                                                      <span className="text-red-500"></span>
                                                    </label>
                                                    <Controller
                                                      name="Shoes"
                                                      control={control}
                                                      render={({ field }) => (
                                                        <Select
                                                          {...field}
                                                          options={sortedShoes.map(
                                                            (item) => ({
                                                              value: `${item.style}`,
                                                              label: `${item.style} ${item.description}`,
                                                              shoeColor:
                                                                item.shoe_color,
                                                            }),
                                                          )}
                                                          placeholder="Select shoe"
                                                          components={
                                                            customComponents
                                                          }
                                                          isClearable
                                                          onChange={(
                                                            selectedOption,
                                                          ) => {
                                                            field.onChange(
                                                              selectedOption
                                                                ? selectedOption.value
                                                                : "",
                                                            );
                                                            if (
                                                              selectedOption &&
                                                              selectedOption.shoeColor
                                                            ) {
                                                              setValue(
                                                                "shoe_color",
                                                                selectedOption.shoeColor,
                                                              );
                                                            } else {
                                                              setValue(
                                                                "shoe_color",
                                                                "",
                                                              ); // Clear if no selection
                                                            }

                                                            const syntheticEvent =
                                                            {
                                                              target: {
                                                                value:
                                                                  selectedOption
                                                                    ? selectedOption.value
                                                                    : "",
                                                              },
                                                            };
                                                            handleShoes(
                                                              syntheticEvent,
                                                            );
                                                          }}
                                                          value={
                                                            Shoes.map(
                                                              (item) => ({
                                                                value: `${item.style}`,
                                                                label: `${item.style} ${item.description}`,
                                                                shoeColor:
                                                                  item.shoe_color,
                                                              }),
                                                            ).find(
                                                              (option) =>
                                                                option.value ===
                                                                field.value,
                                                            ) || null
                                                          }
                                                        />
                                                      )}
                                                    />
                                                    {errors.Shoes && (
                                                      <p className="red">
                                                        {errors.Shoes.message}
                                                      </p>
                                                    )}
                                                  </div>

                                                  <div className="col-md-6 mb-3">
                                                    <label>
                                                      Shoe Size
                                                      <span className="text-red-500">
                                                        *
                                                      </span>
                                                    </label>
                                                    <Controller
                                                      name="ShoesSize"
                                                      control={control}
                                                      rules={{
                                                        required:
                                                          shoesStyleSelected
                                                            ? "Shoe Size is required"
                                                            : false,
                                                      }}
                                                      render={({
                                                        field,
                                                        fieldState: { error },
                                                      }) => (
                                                        <>
                                                          <Select
                                                            {...field}
                                                            options={ShoeSizes.map(
                                                              (size) => ({
                                                                value: size,
                                                                label: size,
                                                              }),
                                                            )}
                                                            placeholder="Select size"
                                                            isClearable
                                                            onChange={(
                                                              selectedOption,
                                                            ) => {
                                                              field.onChange(
                                                                selectedOption
                                                                  ? selectedOption.value
                                                                  : "",
                                                              );
                                                              trigger(
                                                                "ShoesSize",
                                                              );
                                                            }}
                                                            value={
                                                              ShoeSizes.map(
                                                                (size) => ({
                                                                  value: size,
                                                                  label: size,
                                                                }),
                                                              ).find(
                                                                (option) =>
                                                                  option.value ===
                                                                  field.value,
                                                              ) || null
                                                            }
                                                          />
                                                          {error && (
                                                            <span className="error-messagesss">
                                                              {error.message}
                                                            </span>
                                                          )}
                                                        </>
                                                      )}
                                                    />
                                                  </div>

                                                  <div className="col-md-6 mb-3">
                                                    <label>
                                                      Shoe Color
                                                      <span className="text-red-500">
                                                        *
                                                      </span>
                                                    </label>
                                                    <Controller
                                                      name="shoe_color"
                                                      control={control}
                                                      render={({
                                                        field,
                                                        fieldState: { error },
                                                      }) => {
                                                        const selectedColor =
                                                          shoeColors
                                                            .map((color) => ({
                                                              value: color,
                                                              label: color,
                                                            }))
                                                            .find(
                                                              (option) =>
                                                                option.value ===
                                                                field.value,
                                                            );
                                                        return (
                                                          <>
                                                            <div className="disabled-select-box">
                                                              {selectedColor
                                                                ? selectedColor.label
                                                                : "No color selected"}
                                                            </div>

                                                            {error && (
                                                              <span className="error-message">
                                                                {error.message}
                                                              </span>
                                                            )}
                                                          </>
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-md-4 addStyleMobileImg">
                                                {ShoesData?.image ? (
                                                  <Image
                                                    src={`${ImageUrl}${ShoesData?.image}`}
                                                    className="noSelectCoatImg"
                                                    alt=""
                                                  />
                                                ) : (
                                                  <img
                                                    src="/assets/images/no-photo.png"
                                                    className="selectCoatImg"
                                                    alt=""
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </AccordionItem>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="row align-items-center">
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                      Rental Weeks{" "}
                                      <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                      {...register("Rentalterm")}
                                      className="form-select"
                                    >
                                      <option value="">Select week</option>
                                      <option value="1 week">1 week</option>
                                      <option value="2 weeks">2 weeks</option>
                                      <option value="3 weeks">3 weeks</option>
                                      <option value="4 weeks">4 weeks</option>
                                    </select>
                                    {errors.Rentalterm && (
                                      <div className="invalid-feedback d-block">
                                        {errors.Rentalterm.message}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="row">
                                  <div class="col-md-12 mt-3">
                                    <a
                                      className="backBtnWedding"
                                      style={{ cursor: "pointer" }}
                                      onClick={handleBack}
                                    >
                                      Back
                                    </a>
                                    <button
                                      type="submit"
                                      className="addBtnCustomer"
                                      onClick={(e) => {
                                        const formHasErrors =
                                          Object.keys(formState.errors).length >
                                          0 || !!categoryValidationMessage;
                                        if (formHasErrors) {
                                          e.preventDefault();
                                          openAccordionWithErrors(
                                            formState.errors,
                                            !!categoryValidationMessage,
                                          );
                                          if (
                                            categoryValidationMessage &&
                                            categoryErrorRef.current
                                          ) {
                                            categoryErrorRef.current.scrollIntoView(
                                              {
                                                behavior: "smooth",
                                                block: "center",
                                              },
                                            );
                                          }
                                          return;
                                        }
                                      }}
                                    >
                                      Continue
                                    </button>{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AlterationsCoatModal />
      </Container>
    </>
  );
}

export default AddMeasured;
